webpackJsonp([313],Array(50).concat([
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darken", function() { return d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fade", function() { return $; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getColorFromRgbValue", function() { return u; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOpacity", function() { return c; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRgbValue", function() { return a; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRgbaValue", function() { return f; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHex", function() { return i; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRgb", function() { return C; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRgbOrRgba", function() { return l; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRgba", function() { return b; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lighten", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toHex", function() { return y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRgb", function() { return V; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_keywords_mjs__ = __webpack_require__(908);



function i(r) {
  return typeof r != "string" ? !1 : (r = r.toLowerCase(), /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/.test(r));
}
function C(r) {
  return typeof r != "string" ? !1 : (r = r.toLowerCase(), /^(rgb\(|RGB\()/.test(r));
}
function b(r) {
  return typeof r != "string" ? !1 : (r = r.toLowerCase(), /^(rgba|RGBA)/.test(r));
}
function l(r) {
  return (/^(rgb|rgba|RGB|RGBA)/.test(r)
  );
}
function p(r) {
  return __WEBPACK_IMPORTED_MODULE_2__config_keywords_mjs__["a" /* ColorKeywords */][r];
}
function g(r) {
  if (i(r) || l(r)) return r;
  var t = p(r);
  if (!t) throw new Error("Color: Invalid Input of " + r);
  return t;
}
function m(r) {
  r = r.replace("#", ""), r.length === 3 && (r = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(r).map(function (e) {
    return e + e;
  }).join(""));
  var t = r.split("");
  return new Array(3).fill(0).map(function (e, n) {
    return parseInt("0x" + t[n * 2] + t[n * 2 + 1]);
  });
}
function R(r) {
  return r.replace(/rgb\(|rgba\(|\)/g, "").split(",").slice(0, 3).map(function (t) {
    return parseInt(t);
  });
}
function a(r) {
  var e = g(r).toLowerCase();
  return i(e) ? m(e) : R(e);
}
function c(r) {
  var t = g(r);
  return b(t) ? Number(t.toLowerCase().split(",").slice(-1)[0].replace(/[)|\s]/g, "")) : 1;
}
function f(r) {
  var t = a(r);
  return t && [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(t), [c(r)]);
}
function V(r, t) {
  var e = a(r);
  return typeof t == "number" ? "rgba(" + e.join(",") + "," + t + ")" : "rgb(" + e.join(",") + ")";
}
function y(r) {
  if (i(r)) return r;
  var t = a(r),
      e = function e(n) {
    return Number(n).toString(16).padStart(2, "0");
  };
  return "#" + t.map(e).join("");
}
function u(r) {
  if (!Array.isArray(r)) throw new Error("getColorFromRgbValue: " + r + " is not an array");
  var t = r.length;

  if (t !== 3 && t !== 4) throw new Error("getColorFromRgbValue: value length should be 3 or 4");
  return (t === 3 ? "rgb(" : "rgba(") + r.join(",") + ")";
}
function d(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var e = f(r);
  return e = e.map(function (n, o) {
    return o === 3 ? n : n - Math.ceil(2.55 * t);
  }).map(function (n) {
    return n < 0 ? 0 : n;
  }), u(e);
}
function h(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var e = f(r);
  return e = e.map(function (n, o) {
    return o === 3 ? n : n + Math.ceil(2.55 * t);
  }).map(function (n) {
    return n > 255 ? 255 : n;
  }), u(e);
}
function $(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  var e = a(r);
  return u([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(e), [t / 100]));
}


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_permission__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_cilentType__ = __webpack_require__(880);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_4__modules_permission__["a" /* default */],
    cilentType: __WEBPACK_IMPORTED_MODULE_6__modules_cilentType__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeToken;
// import Cookies from 'js-cookie'

// const TokenKey = 'Admin-Token'

// export function getToken() {
//   return Cookies.get(TokenKey)
// }

// export function setToken(token) {
//   return Cookies.set(TokenKey, token)
// }

// export function removeToken() {
//   return Cookies.remove(TokenKey)
// }


function getToken() {
  return localStorage.getItem('KAKASHINE_TOKEN');
}

function setToken(token) {
  return localStorage.setItem('KAKASHINE_TOKEN', token);
}

function removeToken() {
  localStorage.removeItem('KAKASHINE_TOKEN');
}

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28d840c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_auth__ = __webpack_require__(98);








// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: "", // api的base_url
  timeout: 50000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.token) {
    config.headers['x-access-token'] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_auth__["a" /* getToken */])(); // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  if ((config.method || 'get').toUpperCase() === 'GET' && config.params && config.formatArray) {
    var params = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(config.params));

    for (var key in params) {
      if (!params[key]) {
        params[key] = null;
      } else {
        if (params[key] !== null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(params[key]) === 'object' && params[key] instanceof Array && params[key].length > 0) {
          params[key] = params[key].join(',');
        }
      }
    }

    config.params = params;
  }

  return config;
}, function (error) {
  // Do something with request error// for debug
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// respone拦截器
service.interceptors.response.use(function (response) {
  /**
   * code为非20000是抛错 可结合自己业务进行修改
   */
  var res = response.data || {};

  if (!res.success) {
    Object(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"])({
      message: res.errMsg,
      type: 'error',
      duration: 5 * 1000
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.data);
  } else {
    return response.data;
  }
}, function (error) {
  var response = error.response || {};

  var err = response.data || {};
  if (response.status === 401) {
    // 添加对 401 状态码的处理
    Object(__WEBPACK_IMPORTED_MODULE_6__utils_auth__["b" /* removeToken */])(); // 清除 token
    router.push('/login'); // 跳转到登录页
  } else if (!err.success) {
    Object(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"])({
      message: err.errMsg || error,
      type: 'error',
      duration: 5 * 1000
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(551)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b6411016",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export login */
/* harmony export (immutable) */ __webpack_exports__["h"] = unifyLogin;
/* harmony export (immutable) */ __webpack_exports__["c"] = getInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = changePassword;
/* harmony export (immutable) */ __webpack_exports__["e"] = logout;
/* harmony export (immutable) */ __webpack_exports__["d"] = haiLogin;
/* harmony export (immutable) */ __webpack_exports__["a"] = captchaImage;
/* harmony export (immutable) */ __webpack_exports__["f"] = needChangePwd;
/* harmony export (immutable) */ __webpack_exports__["g"] = refreshToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(154);


/*用手机号登录*/
function login(phone, password, captcha, captchaUUID) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/phoneLogin',
        method: 'post',
        data: {
            phone: phone,
            password: password,
            captcha: captcha,
            captchaUUID: captchaUUID
        }
    });
}
//新的 可用账号 或者手机登录新接口
function unifyLogin(userName, password, captcha, captchaUUID) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/login',
        method: 'post',
        data: {
            userName: userName,
            password: password,
            captcha: captcha,
            captchaUUID: captchaUUID
        }
    });
}

function getInfo() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/profile',
        method: 'get'
    });
}

function changePassword(data) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/password',
        method: 'post',
        data: data
    });
}

function logout() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/logout',
        method: 'post'
    });
}

function haiLogin(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/environmentAuth/autoLogin',
        method: 'post',
        data: obj
    });
}

//验证码
function captchaImage() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/captcha/captchaImage ',
        method: 'get'
    });
}

function needChangePwd(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: "/needChangePwd",
        method: 'get',
        params: params
    });
}
//设置token过期时间
function refreshToken() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: "/refreshToken",
        method: 'post'
    });
}

/***/ }),
/* 227 */,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(568),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ae795a48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f076de7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c34adcc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2684b5cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(564),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(567),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a44d0bf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_languages_zh_js__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_languages_en_js__ = __webpack_require__(435);











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: 'zh',
  messages: {
    'zh': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6__assets_languages_zh_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN___default.a),
    'en': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__assets_languages_en_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a)
  }
});
__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale___default.a.i18n(function (key, value) {
  return i18n.t(key, value);
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constantRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(86);



/* layout */
var _import = __webpack_require__(881);
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

/* login */
var Login = _import('login/index');
var LargeScreen = _import('largeScreen/index');
var ScreenChild = _import('largeScreen/screenChild');
var MaterielListChild = _import('largeScreen/materielListChild');
var UserListChild = _import('largeScreen/userListChild');
/* error page */
var Err404 = _import('404');
var VersionText = _import('versionText/index');
/* 查看库存*/
var ViewInventory = _import('viewInventory/index');
var Stock = _import('cabinet/stock');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
var constantRouterMap = [{ path: '/login', component: Login, hidden: true }, { path: '/404', component: Err404, hidden: true }, { path: '/versionText', component: VersionText, hidden: true }, { path: '/largeScreen', component: LargeScreen, hidden: true }, { path: '/viewInventory', component: ViewInventory, hidden: true },
// Stock
{ path: '/cabinet/stock', component: Stock, hidden: true },
// largeScreen/screenChild
{ path: '/largeScreen/screenChild', component: ScreenChild, hidden: true },
// largeScreen/screenChild
{ path: '/largeScreen/materielListChild', component: MaterielListChild, hidden: true },
// UserListChild
{ path: '/largeScreen/userListChild', component: UserListChild, hidden: true }];

/* harmony default export */ __webpack_exports__["c"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history', // 后端支持可开
    base: 'sjg',
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: constantRouterMap
}));
var asyncRouterMap = [{ path: '*', redirect: '/404', hidden: true }];

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57f2cb35",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user.7cfc08d.png";

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(944),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */,
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["n"] = save;
/* harmony export (immutable) */ __webpack_exports__["j"] = edit;
/* unused harmony export get */
/* harmony export (immutable) */ __webpack_exports__["l"] = listCompanys;
/* harmony export (immutable) */ __webpack_exports__["m"] = remove;
/* harmony export (immutable) */ __webpack_exports__["i"] = companysList;
/* harmony export (immutable) */ __webpack_exports__["h"] = companysAdd;
/* harmony export (immutable) */ __webpack_exports__["e"] = companyCftSave;
/* harmony export (immutable) */ __webpack_exports__["d"] = companyCftList;
/* unused harmony export companyCftSystemList */
/* unused harmony export companyCftSysSave */
/* harmony export (immutable) */ __webpack_exports__["f"] = companyPermissionGroupList;
/* harmony export (immutable) */ __webpack_exports__["g"] = companyPermissionGroupSave;
/* harmony export (immutable) */ __webpack_exports__["b"] = apiaccountList;
/* harmony export (immutable) */ __webpack_exports__["a"] = apiaccountId;
/* harmony export (immutable) */ __webpack_exports__["c"] = apiaccountSave;
/* harmony export (immutable) */ __webpack_exports__["k"] = getCompanyWithKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(154);


function save(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companys',
        method: 'post',
        data: obj
    });
}

function edit(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companys/' + obj.id + '/update',
        method: 'post',
        data: obj
    });
}

function get(id) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companys/' + id,
        method: 'get'
    });
}

function listCompanys(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companys',
        method: 'get',
        params: params
    });
}

function remove(id) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companys/' + id + '/remove',
        method: 'post'
    });
}

/*公司初始化列表*/
function companysList(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companys',
        method: 'get',
        params: params
    });
}

/*新公司初始化  添加*/
function companysAdd(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companys/init',
        method: 'post',
        data: obj
    });
}

//公司配置

function companyCftSave(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/configure/saveCompany',
        method: 'post',
        data: obj
    });
}

function companyCftList(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/configure/getCompany',
        method: 'get',
        params: params
    });
}

// 获取公司详细设置（超级管理员）
// /configure/getCompanySystem/{companyId}   GET
//
function companyCftSystemList(id) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/configure/getCompanySystem/' + id,
        method: 'get'
    });
}

// 设置公司详细设置（超级管理员）
// /configure/saveCompanySystem/{companyId}  POST
// 参数：同/configure/saveCompany'
function companyCftSysSave(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/configure/saveCompanySystem',
        method: 'post',
        data: obj
    });
}

//获取某个公司下的可用功能和权限
function companyPermissionGroupList(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companyPermissionGroup/list',
        method: 'get',
        params: params
    });
}

//保存某个公司下可用功能和权限
function companyPermissionGroupSave(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/companyPermissionGroup/save',
        method: 'post',
        data: obj
    });
}

//API用户列表
function apiaccountList(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/apiaccount/list',
        method: 'get',
        params: params
    });
}
//获取单个API用户的信息
function apiaccountId(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/apiaccount/' + params.id,
        method: 'get',
        params: params
    });
}
//新增或修改一个API用户的信息
function apiaccountSave(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/apiaccount/save',
        method: 'post',
        data: obj
    });
}
//公司logo配置查询
function getCompanyWithKey(params) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
        url: '/configure/getCompanyWithKey',
        method: 'get',
        params: params
    });
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = permissionList;
/* harmony export (immutable) */ __webpack_exports__["a"] = permissionAdd;
/* harmony export (immutable) */ __webpack_exports__["i"] = permissionUpdate;
/* harmony export (immutable) */ __webpack_exports__["j"] = permissionrRemove;
/* unused harmony export permissionGroupList */
/* harmony export (immutable) */ __webpack_exports__["e"] = permissionGroupTree;
/* harmony export (immutable) */ __webpack_exports__["b"] = permissionGroupAdd;
/* harmony export (immutable) */ __webpack_exports__["f"] = permissionGroupUpdate;
/* harmony export (immutable) */ __webpack_exports__["d"] = permissionGroupRemove;
/* harmony export (immutable) */ __webpack_exports__["g"] = permissionGroupgetRouters;
/* harmony export (immutable) */ __webpack_exports__["c"] = permissionGroupDetil;
/* unused harmony export permissionGroupBtn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(154);

//权限信息列表接口
function permissionList(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permission/list',
    method: 'get',
    params: params
  });
}
//权限信息-单个添加
function permissionAdd(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permission/add',
    method: 'post',
    data: obj
  });
}
//权限信息-单个修改
function permissionUpdate(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permission/update/',
    method: 'post',
    data: obj
  });
}
//权限信息-单个删除
function permissionrRemove(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permission/remove',
    method: 'post',
    data: data
  });
}
//权限组列表接口
function permissionGroupList(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permissionGroup/list',
    method: 'get',
    params: params
  });
}
//getGroupTree
//权限组列表接口
function permissionGroupTree(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permissionGroup/getGroupTree',
    method: 'get',
    params: params
  });
}
//permissionGroupAdd 添加单个权限组
function permissionGroupAdd(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permissionGroup/add',
    method: 'post',
    data: obj
  });
}
//权限组信息-单个修改
function permissionGroupUpdate(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permissionGroup/update',
    method: 'post',
    data: obj
  });
}
//权限组信息-单个删除
function permissionGroupRemove(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permissionGroup/remove',
    method: 'post',
    data: data
  });
}
//获取用户路由信息
function permissionGroupgetRouters(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permissionGroup/getRouterInfo',
    method: 'get',
    params: params
  });
}

//获取单个权限组详情信息
function permissionGroupDetil(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/permissionGroup/' + id,
    method: 'get'
  });
}
//获取按钮权限
function permissionGroupBtn(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: /permissionGroup/ + id + '/SubFunctionCode',
    method: 'get'
  });
}

/***/ }),
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Sidebar", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Levelbar__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Levelbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Levelbar", function() { return __WEBPACK_IMPORTED_MODULE_2__Levelbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppMain__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AppMain", function() { return __WEBPACK_IMPORTED_MODULE_3__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Header__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Header1", function() { return __WEBPACK_IMPORTED_MODULE_4__Header___default.a; });










/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_index__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_print_nb__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_print_nb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_print_nb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nprogress__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nprogress_nprogress_css__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_normalize_css_normalize_css__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_iconfont_iconfont__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_iconfont_iconfont___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_iconfont_iconfont__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_iconfont_newicon__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_iconfont_newicon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_iconfont_newicon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Icon_svg_index_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Icon_svg_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Icon_svg_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filters__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_auth__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directive_index__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__jiaminghi_data_view__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_echarts__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_echarts__);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import 'element-ui/lib/theme-default/index.css'







 // 全局filter






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_20_echarts___default.a;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__directive_index__["a" /* default */]);
// 自定义树选择组件
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__jiaminghi_data_view__["a" /* default */]);
// register global utility filters.
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_15__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_15__filters__[key]);
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_print_nb___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('icon-svg', __WEBPACK_IMPORTED_MODULE_14__components_Icon_svg_index_vue___default.a);

var whiteList = ['/login', '/cabinet/stock', '/versionText'];
__WEBPACK_IMPORTED_MODULE_4__router__["c" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_9_nprogress___default.a.start();
  if (to.query && to.query.token) {
    Object(__WEBPACK_IMPORTED_MODULE_16__utils_auth__["c" /* setToken */])(to.query.token);
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_TOKEN', to.query.token);
    window.location.search = '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_16__utils_auth__["a" /* getToken */])()) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.roles.length === 0) {
        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('GetInfo').then(function (res) {
          var roles = res.data.role;
          __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('GenerateRoutes', { roles: roles }).then(function () {
            __WEBPACK_IMPORTED_MODULE_4__router__["c" /* default */].addRoutes(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.addRouters);
            next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to));
          });
        });
      } else {
        next();
      }
    }
  } else {
    // next('/login');
    console.log(whiteList.indexOf(to.path), '000');
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else if (whiteList.indexOf(to.path) === 1) {
      next({ path: '/cabinet/stock' });
      __WEBPACK_IMPORTED_MODULE_9_nprogress___default.a.done();
    } else if (whiteList.indexOf(to.path) === 2) {
      next({ path: '/versionText' });
      __WEBPACK_IMPORTED_MODULE_9_nprogress___default.a.done();
    } else {
      next('/login');
      __WEBPACK_IMPORTED_MODULE_9_nprogress___default.a.done();
    }
  }
});

__WEBPACK_IMPORTED_MODULE_4__router__["c" /* default */].afterEach(function () {
  __WEBPACK_IMPORTED_MODULE_9_nprogress___default.a.done();
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  i18n: __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["c" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  created: function created() {
    // 在Vue实例创建时启动token刷新任务
    this.$store.dispatch('startTokenRefresh');
  },

  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_17__App___default.a }
});

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var zh = {
    name01: "智能柜概况",
    name02: "操作记录",
    name03: "领取记录",
    name04: "归还记录",
    name05: "待归还试剂记录",
    name06: "待注销试剂记录",
    name07: "库存不足信息",
    name08: "逾期未归还记录",
    name09: "即将过期试剂",
    name10: "归还未称重记录",
    name11: "人员管理",
    name12: "试剂管理",
    name13: "在库试剂",
    name14: "注销申请",
    name15: "违规管理",
    name16: "查找",
    name17: "报表管理",
    name18: "化学品月报表",
    name19: "危险化学品月报表",
    name20: "危险化学品领用报表",
    name21: "系统设置",
    name22: "公司信息",
    name23: "学院信息",
    name24: "违规条件",
    name25: "试剂分类",
    name26: "试剂配置",
    name27: "厂商配置",
    name28: "设备状态",
    name29: "邮件配置",
    name30: "APK升级",
    name31: "智能柜端日志",
    name32: "申请管理",
    name33: "我的申请",
    name34: "申请处理",
    name35: "Excel导入",
    name36: "手持机盘点记录",
    name37: "全部",
    name38: "返回",
    name39: "更多筛选(展开)",
    name40: "更多筛选(收起)",
    name41: "保存",
    name42: "保存并提交",
    main: {
        name01: "智能柜管理系统",
        name02: "检索",
        name03: "添加",
        name04: "编辑",
        name05: "删除",
        name06: "操作",
        name07: "取 消",
        name08: "确 定",
        name09: "是",
        name10: "否",
        name11: "开始时间",
        name12: "结束时间",
        name13: "全部",
        name14: "无法连接到服务器，请检查网络!",
        name15: "您无权访问系统，重新登陆或者联系管理员!",
        name16: "批量处理",
        name17: "标签打印",
        name18: "张",
        name19: "编辑选中",
        name20: "删除选中",
        name21: "展示列",
        name22: "更多操作",
        name23: '打印',
        name24: "详情",
        name25: "关闭",
        name26: "未选",
        name27: "下一步",
        name28: "上一步",
        name29: "提交",
        name30: "暂无数据",
        name31: '添加成功',
        name32: "入库导出",
        name33: "退回",
        name34: "授权权限",
        name35: "查看权限",
        name36: "添加子项",
        name37: "单个添加",
        name38: "批量添加",
        name39: "查看详情",
        name40: "编辑柜门",
        name41: "更多设置",
        name42: "编辑柜子",
        name43: "功能",
        name44: "远程盘点",
        name45: "同步人脸",
        name46: "查看视频",
        name47: "查看库存",
        name48: "指定智能柜",
        name49: "全选",
        enable: "启用",
        disable: "禁用"

    },
    login: {
        name1: "智能柜管理系统",
        name2: "登录",
        name3: "账号/手机号",
        name4: "密码",
        name5: "账号/手机号不能为空",
        name6: "密码不能为空",
        name7: "化学品智能试剂柜管理系统V2.1.0",
        name8: "修改密码",
        name9: "退出登录",
        name10: "旧密码",
        name11: "新密码",
        name12: "确定密码",
        name13: "统一身份认证"

    },
    cabinet: {
        name01: "编号",
        name02: "请输入智能柜编号",
        name03: "名称",
        name04: "请输入智能柜名称",
        name05: "是否多门柜",
        name06: "请输入柜门总数",
        name07: "智能柜类型",
        name08: "请选择智能柜类型",
        name09: "智能柜控制类型",
        name10: "请选择智能柜控制类型",
        name11: "控制柜",
        name12: "请选择控制柜",
        name13: "存放分类",
        name14: "请选择危险分类",
        name15: "公司",
        name16: "请选择保管公司",
        name17: "学院",
        name18: "请选择保管学院",
        name19: "位置",
        name20: "请输入保管场位置",
        name21: "容量不能为空",
        name22: "容量必须为正整数",
        name23: "RFID柜",
        name24: "条码柜",
        name25: "存储柜",
        name26: "控制柜",
        name27: "一体柜",
        name28: "智能柜编号不能为空",
        name29: "智能柜名称不能为空",
        name30: "编辑智能柜",
        name31: "添加智能柜",
        name32: "注销此智能柜",
        name33: "门锁",
        name34: "风扇",
        name35: "库存",
        name36: "液体",
        name37: "固体",
        name38: "今日操作",
        name39: "今日借出",
        name40: "今日归还",
        name41: "请选择柜门",
        name42: "编辑信息",
        name43: "今日使用",
        name44: "查看库存",
        name45: "温度",
        name46: "湿度",
        name47: "VOC",
        name48: "智能柜",
        name49: "确认注销该智能柜信息！",
        name50: "注销智能柜",
        name51: "删除智能柜信息成功!",
        name52: "在线",
        name53: "离线",
        name54: "排风扇",
        name55: "智能柜状态",
        name56: "总设备数(台)",
        name57: "总库存数(瓶)",
        name58: "今日数据",
        name59: "今日特别提示",
        name60: "今日操作数",
        name61: "今日异常数",
        name62: "今日领取数",
        name63: "今日归还数",
        name64: "待归还试剂",
        name65: "待注销试剂",
        name66: "库存不足",
        name67: "逾期未归还",
        name68: "即将过期",
        name69: "归还未称重",
        name70: "次",
        name71: "个",
        name72: "瓶",
        name73: "类型",
        name74: "重量",
        name75: "所有智能柜",
        name76: "便捷检索编号",
        name77: "当前容量",
        name78: "总容量",
        name79: "刷新",
        name80: "其他配置",
        name81: "请输入其他配置(建议使用JSON字符串)",
        name82: "排序",
        name83: "智能柜序列号",
        name84: "是否有温度传感器",
        name85: "是否有湿度传感器",
        name86: "是否智能锁",
        name87: "是否有风机",
        name88: "是否有VOC传感器",
        name89: "位置简称",
        name90: "请输入存放位置的简称",
        name91: "普通柜",
        name92: "是否有摄像头",
        name93: "摄像头序列号",
        name94: "摄像头IP",
        name95: "是否监管",
        name96: "锁连接类型",
        name97: "锁连接地址",
        name98: "请输入锁连接地址",
        name99: "锁连接端口",
        name100: "请输入锁连接端口",
        name101: "IO端口号",
        name102: "请输入IO端口号",
        name103: "智能柜门",
        name104: "请选择智能柜门",
        name105: '展示?',
        name106: "请选择柜子类型",
        name107: "异常",
        name108: "下属共",
        name109: "台智能柜",
        name110: "确定是否远程盘点！",
        name111: "盘点成功!",
        name112: "存放属性",
        name113: "请选择存放属性",
        name114: "场所设置",
        name115: "是否展示",
        name116: "存储柜（有屏）",
        name117: "存储柜（无屏）",
        name118: "MQ连接(默认)",
        name119: "WIFI继电器",
        name120: "独立钥匙盒",
        name121: "蓝牙锁",
        name122: "确定同步人脸信息！",
        name123: "同步成功!",
        name124: "实验室",
        name125: "仓库",
        name126: "无需监管",
        name127: "1次验证",
        name128: "2次验证"
    },
    door: {
        name01: "柜门名称",
        name02: "柜门编号",
        name03: "编辑柜门信息",
        name04: "修改成功!",
        name05: "柜门",
        name06: "确认授权",
        name07: "确认取消授权",
        name08: "智能柜",
        name09: '请选择入库柜门',
        name10: '入库柜门'

    },
    user: {
        name01: "用户信息:",
        name02: "用户卡号",
        name03: "请输入卡号",
        name04: "用户姓名",
        name05: "请输入姓名",
        name06: "邮箱",
        name07: "请输入邮箱",
        name08: "用户工号",
        name09: "请输入工号",
        name10: "手机号",
        name11: "请输入手机号",
        name12: "学院",
        name13: "请选择学院",
        name14: "密码设置:",
        name15: "登录名",
        name16: "请输入登录名",
        name17: "密码",
        name18: "请输入密码",
        name19: "密码确认",
        name20: "请再次输入密码",
        name21: "使用权限:",
        name22: "请选择角色",
        name23: "领用权限",
        name24: "请选择危险分类",
        name25: "授权",
        name26: "授权到期时间",
        name27: "选择授权到期时间",
        name28: "卡号不能为空",
        name29: "登录名不能为空",
        name30: "密码长度不能小于6位",
        name31: "两次密码不一致",
        name32: "请输入姓名",
        name33: "请输入正确邮箱",
        name34: "usiname不能为空",
        name35: "请输入正确手机号",
        name36: "不能为空",
        name37: "不能为空",
        name38: "编辑人员",
        name39: "添加人员",
        name40: "修改用户信息成功!",
        name41: "添加用户信息成功!",
        name42: "确认删除该条人员信息！",
        name43: "删除人员信息",
        name44: "删除人员信息成功!",
        name45: "管理员",
        name46: "操作员",
        name47: "角色",
        name48: "工号/用户名",
        name49: "编辑开门权限",
        name50: "开门",
        name51: "*",
        name52: "状  态",
        name53: "试剂负责人",
        name54: "试剂领用人",
        name55: "请选择状态",
        name56: "请选择负责人",
        name57: "请选择领用人",
        name58: "人员信息",
        name59: "试剂领用申请审批成功后，可打开的柜门列表",
        name60: "授权",
        name61: "管理后台手动授权，可打开的柜门列表",
        name62: "默认",
        name63: "智能柜默认授权开门的柜门列表",
        name64: "卡号不能以0开头",
        name65: "开门权限",
        name66: '是否启用',
        name67: "请输入用户名",
        name68: "照片MD5",
        name69: "照片",
        name70: "是否有特征值",
        name71: "确定删除此条人脸信息?",
        name72: "删除人脸信息",
        name73: "上传照片",
        name74: "编辑人脸信息",
        name75: "添加人脸信息",
        name76: "用户",
        name77: "确定要删除嘛?",
        name78: "角色名称",
        name79: "角色等级",
        name80: "请输入角色名称",
        name81: "请输入排序",
        name82: '等级',
        name83: "请输入等级",
        name84: "权限列表信息",
        name85: "全选/全不选",
        name86: "加载中，请稍候",
        name87: "编辑角色信息",
        name88: "添加角色信息",
        role_code: "角色标识",
        input_role_code: "请输入角色标识",
        please_select_status: "请选择用户状态",
        user_status: "用户状态"

    },
    materiel: {
        name01: "试剂信息",
        name02: "批次号",
        name03: "请输入批次号",
        name04: "RFID号",
        name05: "请输入RFID编号",
        name06: "称重",
        name07: "是否需要称重",
        name08: "毛重",
        name09: "请输入毛重",
        name10: "净含量",
        name11: "请输入净含量",
        name12: "瓶子重量",
        name13: "请输入瓶子重量",
        name14: "入库信息",
        name15: "生产日期",
        name16: "选择生产日期",
        name17: "有效期",
        name18: "选择有效日期",
        name19: "厂商",
        name20: "请选择厂商",
        name21: "备注",
        name22: "请输入备注",
        name23: "是否注销",
        name24: "* 为必填项",
        name25: "RFID编号不能为空",
        name26: "请输入瓶子重量",
        name27: "请输入非负数",
        name28: "请输入毛重",
        name29: "请输入净含量",
        name30: "请输入密度",
        name31: "请输入规格",
        name32: "编辑试剂",
        name33: "添加试剂",
        name34: "确定要注销该试剂吗？",
        name35: "确定",
        name36: "取消",
        name37: "提示",
        name38: "确认删除该条试剂信息!",
        name39: "删除试剂信息",
        name40: "删除试剂信息成功!",
        name41: "品名/CAS号",
        name42: "注销时间",
        name43: "最后记录时间",
        name44: "拷贝",
        name45: "权限",
        name46: "瓶子重量不能小于0!",
        name47: "入库时间",
        name48: "注销申请",
        name49: "已注销试剂",
        name50: "申请人",
        name51: "申请时间",
        name52: "审核状态",
        name53: "未审核",
        name54: "审核通过",
        name55: "审核未通过",
        name56: "审核人",
        name57: "审核时间",
        name58: "通过",
        name59: "拒绝",
        name60: "品名/英文名/CAS编号",
        name61: "请选择品名",
        name62: "分布图",
        name63: "智能柜中有",
        name64: "件试剂",
        name65: "Excel导出",
        name66: "分类",
        name67: "净含量",
        name68: "总瓶数",
        name69: "详情",
        name70: "预警",
        name71: "瓶",
        name72: "试剂归还时未称重",
        name73: "试剂",
        name74: "天后即将过期",
        name75: "试剂已过期",
        name76: "分布信息",
        name77: "Barcode",
        name78: "Please enter Barcode",
        name79: "Location",
        name80: "Please enter Location",
        name81: "Short Location",
        name82: "Please enter Short Location",
        name83: "Please select the custodian location",
        name84: "Owner",
        name85: "Please select the shortLocation",
        name86: "Please select the owner",
        name87: "按编号展示",
        name88: "按品名展示",
        name89: "智能柜负责人",
        name90: "请选择智能柜负责人",
        name91: "瓶重参考信息",
        name92: "编辑内容:",
        name93: "负责人",
        name94: "请选择负责人",
        name95: "是否称重",
        name96: "入库柜",
        name97: "请选择入库柜",
        name98: "批量入库",
        name99: "负责人信息",
        name100: "试剂配置信息",
        name101: "试剂详情信息",
        name102: "请选择负责人信息",
        name103: "请选择试剂配置信息",
        name104: "位置信息",
        name105: "您确定要删除此试剂吗?",
        name106: "请完成第一项负责人和部门的选择",
        name107: "请完成第二项试剂配置的选择",
        name108: "没找到配置信息？请先",
        name109: "添加配置",
        name110: "请填写试剂详情信息",
        name111: "净含量和瓶重必填一个!",
        name112: "多门柜柜门不能为空！",
        name113: "学校/部门",
        name114: "品牌名"

    },
    error: {
        name01: "版权所有",
        name02: "请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告",
        name03: "返回首页",
        name04: "XX说这个页面你不能进......"
    },
    alarm: {
        name01: "请选择智能柜",
        name02: "人员工号/姓名/用户名/试剂名称",
        name03: "人员",
        name04: "智能柜编号",
        name05: "事件",
        name06: "时间",
        name07: "删除选中",
        name08: "删除所有",
        name09: "所有智能柜",
        name10: "确认删除违规信息!",
        name11: "删除违规信息",
        name12: "删除违规信息成功!",
        name13: "处理意见",
        name14: "已处理",
        name15: "未处理",
        name16: "是否记录",
        name17: "是否通知",
        name18: "阈值",
        name19: "通知类型",
        name20: "通知对象类型",
        name21: "通知人员",
        name22: "上报人",
        name23: "上报时间",
        name24: "上报说明",
        name25: "上报图片",
        name26: "处理",
        name27: "添加异常标签",
        name28: "编辑异常标签",
        name29: "请输入处理意见",
        name30: "请输入异常类型名称",
        name31: "处理违规记录",
        name32: "是否开启通知",
        name33: "记录类型",
        name34: "未填写",
        name35: "违规",
        name36: "预警",
        name37: "通知对象",
        name38: "处理异常",
        name39: "异常标签名称不能为空!",
        name40: "确实删除该异常标签",
        name41: "删除异常标签"
    },
    search: {
        name01: "试剂查找",
        name02: "人员名下试剂查找",
        name03: "RFID编号/品名/CAS号",
        name04: "RFID编号",
        name05: "状态",
        name06: "未借出",
        name07: "已借出",
        name08: "已采购",
        name09: "位置",
        name10: "最后接触人员",
        name11: "最后记录时间",
        name12: "流转详情",
        name13: "点击查看",
        name14: "人员工号/姓名/用户名",
        name15: "用户名",
        name16: "姓名",
        name17: "当前持有试剂数量",
        name18: "借用试剂数量",
        name19: "借用次数",
        name20: "归还次数",
        name21: "流转信息",
        name22: "名称:",
        name23: "编号:",
        name24: "状态:",
        name25: "未借出",
        name26: "柜中:",
        name27: "净含量:",
        name28: "净含量",
        name29: "未称重",
        name30: "已采购",
        name31: "入柜",
        name32: "借出",
        name33: "归还",
        name34: "注销",
        name35: "试剂查找",
        name36: "申请",
        name37: "审核"
    },
    report: {
        name01: "危 险 化 学 品 月 报 表",
        name02: "危 险 化 学 品 领 用 报 表",
        name03: "化 学 品 月 报 表",
        name04: "化 学 品 库 存 报 表",
        name05: "日期",
        name06: "入库量",
        name07: "出库量",
        name08: "在库量",
        name09: "试剂编号",
        name10: "操作人",
        name11: "使用量",
        name12: "操作类型",
        name13: "智能柜名称",
        name14: "请选择试剂",
        name15: "按单瓶展示",
        name16: "按单次展示",
        name17: "场所",
        name18: "按品名分组",
        name19: "按品名分组",
        name20: "公安台账",
        name21: "监管人",
        name22: "事由",
        name23: "监管人",
        name24: "剩余量",
        name25: "请输入试剂名/RFID",
        name26: "请选择操作类型",
        name27: "请选择操作人",
        name28: "按时间排序",
        name29: "操作内容",
        name30: "查看录像",
        name31: "请输入试剂品名",
        amount_purchased: "采购量",
        cancellation_amount: "注销量",
        adjustment_amount: "调整量",
        total_margin: "总余量",
        total_quantity_in_storage: "总在库量"
    },
    company: {
        name01: "公司名称",
        name02: "编辑公司信息",
        name03: "添加公司信息",
        name04: "请输入公司名称!",
        name05: "公司名称不能为空",
        name06: "删除公司信息",
        name07: "确认删除该条公司信息!",
        name08: "删除公司信息成功!",
        name09: "添加新公司信息",
        name10: "功能配置项",
        name11: "部门名称",
        name12: "配置项",
        name13: "配置名",
        name14: "配置KEY",
        name15: "配置类型",
        name16: "是否默认",
        name17: "填写要求",
        name18: "配置值",
        name19: "编辑系统配置项信息",
        name20: "添加系统配置项信息",
        name21: "通用配置",
        name22: "仅超管配置",
        name23: "请选择公司",
        name24: "请选择配置类型",
        name25: "请输入key",
        name26: "是否仅超管配置",
        name27: "用户名称",
        name28: "公司类型",
        name29: "编辑新公司信息"
    },
    department: {
        name01: "学院名称",
        name02: "编辑",
        name03: "添加",
        name04: "请输入名称",
        name05: "名称不能为空",
        name06: "删除信息",
        name07: "确认删除该条信息!",
        name08: "删除信息成功!",
        name09: '请选择部门/学院',
        name10: "学号",
        name11: "请输入学号",
        name12: "学院信息",
        name13: "部门",
        name14: "请选择部门",
        name15: "工号",
        name16: "请输入工号",
        name17: '部门信息'

    },
    setting: {
        name01: "预警项",
        name02: "数据",
        name03: "通知固定邮箱",
        name04: "是否通知违规者",
        name05: "库存不足比列(%)",
        name06: "管理员试剂领用上限",
        name07: "操作员试剂领用上限",
        name08: "试剂逾期未归还(小时)",
        name09: "在柜内长时间闲置上限(天)",
        name10: "柜体打开时间上限(分钟)",
        name11: "未称重是否记录",
        name12: "取得非法的试剂是否记录",
        name13: "归还前时间段内完成称重(秒)",
        name14: "有效期前时间段过期预警(天)",
        name15: "小时",
        name16: "天",
        name17: "分",
        name18: "请输入库存不足比例(%)",
        name19: "库存不足比例通知邮箱",
        name20: "请输入库存比例通知邮箱(多个邮箱以;隔开)",
        name21: "请输入管理员试剂领用上限",
        name22: "管理员试剂领用上限通知邮箱",
        name23: "请输入管理员试剂领用上限通知邮箱(多个邮箱以;隔开)",
        name24: "A管理员名试剂领用上限是否通知违规人",
        name25: "请输入操作员试剂领用上限",
        name26: "操作员试剂领用上限通知邮箱",
        name27: "请输入操作员试剂领用上限通知邮箱(多个邮箱以;隔开)",
        name28: "操作员试剂领用上限是否通知违规人",
        name29: "请输入试剂逾期未归还上限",
        name30: "试剂逾期未归还通知邮箱",
        name31: "请输入试剂逾期未归还通知邮箱(多个邮箱以;隔开)",
        name32: "试剂逾期未归还是否通知违规人",
        name33: "请输入在柜内长时间闲置上限",
        name34: "在柜内长时间闲置上限通知邮箱",
        name35: "请输入在柜内长时间闲置上限通知邮箱(多个邮箱以;隔开)",
        name36: "柜体打开时间上限",
        name37: "柜体打开时间上限通知邮箱",
        name38: "请输入试剂逾期未归还通知邮箱(多个邮箱以;隔开)",
        name39: "柜体打开时间上限是否通知违规人",
        name40: "请输入归还前时间段内完成称重(单位秒)",
        name41: "归还前时间未称重通知邮箱",
        name42: "请输入归还前时间未称重通知邮箱(多个邮箱以;隔开)",
        name43: "归还前时间未称重是否通知违规人",
        name44: "有效期前通知邮箱",
        name45: "请输入有效期前通知邮箱(多个邮箱以;隔开)",
        name46: "未称重通知邮箱",
        name47: "请输入未称重通知邮箱(多个邮箱以;隔开)",
        name48: "未称重是否通知违规人",
        name49: "取得非法的试剂是否记录",
        name50: "取得非法的试剂通知邮箱",
        name51: "请输入得非法的试剂通知邮箱(多个邮箱以;隔开)",
        name52: "得非法的试剂是否通知违规人",
        name53: "管理员试剂领用上限不能为空",
        name54: "管理员试剂领用上限不能为负",
        name55: "试剂逾期未归还上限不能为空",
        name56: "试剂逾期未归还上限不能为负",
        name57: "柜体打开时间上限不能为空",
        name58: "柜体打开时间上限不能为负",
        name59: "在柜内长时间闲置上限不能为空",
        name60: "在柜内长时间闲置上限不能为负",
        name61: "操作员剂领用上限不能为空",
        name62: "操作员剂领用上限不能为负",
        name63: "智能柜中存放数量上限不能为空",
        name64: "智能柜中存放数量上限不能为负",
        name65: "秒",
        name66: "预警项配置",
        name67: "VOC阈值",
        name68: "VOC告警通知邮箱",
        name69: "VOC告警通知邮箱(多个邮箱以;隔开)",
        name70: "开门超时时间",
        name71: "请输入开门超时时间",
        name72: "温度预警上限",
        name73: "请输入温度预警上限",
        name74: "温度预警下限",
        name75: "请输入温度预警下限",
        name76: "湿度预警上限",
        name77: "请输入湿度预警上限",
        name78: "湿度预警下限",
        name79: "请输入湿度预警下限",
        name80: "VOC预警上限",
        name81: "请输入VOC预警上限",
        name82: "最大存放量",
        name83: "请输入最大存放量设置",
        name84: "是否默认授权开门",
        name85: "是否默认授权开门",
        name86: "跟随智能柜",
        name87: "是否开启属性冲突检测",
        name88: "跟随系统",
        name89: "是否授权给子部门",
        name90: "是否开启试剂属性冲突检测",
        name91: "系统报警连续推送的间隔时间(s)",
        name92: "配置项",
        name93: "配置数据",
        name94: "选取文件"
    },
    danger: {
        name01: "名称",
        name02: "请输入危险分类名称",
        name03: "编辑危险分类配置",
        name04: "添加危险分类配置",
        name05: "确认删除该条危险分类配置信息！",
        name06: "删除危险分类配置信息",
        name07: "删除危险分类配置信息成功!",
        name08: "危险分类名称不能为空!",
        name09: "是否是危险化学品",
        name10: "是否是管制分类",
        name11: "请输入危险分类编号",
        name12: "管制分类"
    },
    cas: {
        name01: "品名/英文名/CAS编号",
        name02: "品名",
        name03: "英文名",
        name04: "CAS编号",
        name05: "MSDS",
        name06: "形态",
        name07: "液体(毫升)",
        name08: "固体(克)",
        name09: "密度",
        name10: "规格",
        name11: "危险分类",
        name12: "其他描述",
        name13: "请输入品名",
        name14: "请输入英文名",
        name15: "请输入CAS编号",
        name16: "请选择试剂形态",
        name17: "液体密度(克/毫升)",
        name18: "请输入规格(克)",
        name19: "请输入规格(毫升)",
        name20: "请选择危险分类",
        name21: "克/毫升",
        name22: "请输入其他描述",
        name23: "编辑品名配置",
        name24: "添加品名配置",
        name25: "确认删除该条品名配置信息!",
        name26: "删除品名配置信息",
        name27: "删除品名配置信息成功!",
        name28: "品名名称不能为空!",
        name29: "毫升",
        name30: "克",
        name31: "MSDS URL",
        name32: "Sample Name",
        name33: "Sample Name in Chinese",
        name34: "Please enter Sample Name",
        name35: "Please enter Sample Name in Chinese",
        name36: "中文别名",
        name37: "英文别名",
        name38: "请输入品名中文别名",
        name39: "请输入品名英文别名"

    },
    manufacturer: {
        name01: "名称",
        name02: "厂商名称",
        name03: "厂商编码",
        name04: "联系人",
        name05: "联系电话",
        name06: "请输入厂商名称",
        name07: "请输入厂商编码",
        name08: "请输入联系人",
        name09: "请输入联系方式",
        name10: "厂商名称不能为空",
        name11: "编辑厂商配置",
        name12: "添加厂商配置",
        name13: "确认删除该条厂商配置信息！",
        name14: "删除厂商配置信息",
        name15: "删除厂商配置信息成功!"
    },
    sensor: {
        name01: "字段名称",
        name02: "是否显示",
        name03: "显示",
        name04: "隐藏",
        name05: "名称"
    },
    mail: {
        name01: "邮件测试",
        name02: "邮件配置",
        name03: "数据",
        name04: "邮件服务地址",
        name05: "邮件服务端口",
        name06: "邮箱",
        name07: "邮箱密码",
        name08: "是否启用SSL",
        name09: "是否是Exchange邮件服务",
        name10: "修改设置成功!",
        name11: "请输入邮件服务地址",
        name12: "请输入邮件服务端口",
        name13: "请输入邮箱",
        name14: "请输入邮箱密码",
        name15: "测试邮箱",
        name16: "请输入测试邮箱地址",
        name17: "邮件发送成功!",
        name18: "邮件"
    },
    apk: {
        name01: "APK版本号/名称",
        name02: "版本",
        name03: "版本地址",
        name04: "点击下载",
        name05: "版本描述",
        name06: "上传者",
        name07: "上传时间",
        name08: "APK文件",
        name09: "只能上传APK文件，将文件拖到此处，或",
        name10: "点击上传",
        name11: "APK版本名称",
        name12: "请输APK版本名称",
        name13: "APK描述",
        name14: "请输APK描述",
        name15: "APK版本名称不能为空!",
        name16: "编辑APK版本信息",
        name17: "添加APK版本信息",
        name18: "APK文件上传成功!",
        name19: "确认删除该条APK版本信息!",
        name20: "删除APK版本信息",
        name21: "删除APK版本信息成功!",
        name22: "下载地址",
        name23: "请输入下载地址",
        name24: "APK类型",
        name25: "请选中APK类型"
    },
    log: {
        name01: "智能柜编号",
        name02: "日志名称",
        name03: "上传服务器时间",
        name04: "下载日志",
        name05: "认删除该条日志信息!",
        name06: "删除日志信息",
        name07: "删除日志信息成功!"
    },
    apply: {
        name01: "开门申请",
        name02: "注销申请",
        name03: "申请通过",
        name04: "审核拒绝",
        name05: "审核备注",
        name06: "请输入审核备注",
        name07: "删除申请信息",
        name08: "确定删除申请信息!",
        name09: "删除申请消息成功!",
        name10: "申请",
        name11: "申请注销",
        name12: "确定申请注销该试剂!",
        name13: "申请理由",
        name14: "请输入申请理由!",
        name15: "有效次数",
        name16: "请选择有效次数!"
    },
    materielDoor: {
        name01: "编辑试剂指定存放信息",
        name02: "试剂信息",
        name03: "存放位置",
        name04: "确定存放到",
        name05: "智能柜!",
        name06: "确定取消存放到",
        name07: "修改试剂指定存放信息成功！",
        name08: "请选择存放位置",
        name09: "指定位置柜",
        name10: "请选择指定位置柜",
        name11: "指定柜门",
        name12: '请选择指定柜门',
        name13: "是否立即入库"

    },
    inventory: {
        name01: "盘点人员",
        name02: "盘点时间",
        name03: "盘点柜子",
        name04: "盘点柜门",
        name05: "库存盘亏",
        name06: "库存盘盈",
        name07: "详情",
        name08: "请选择盘点柜",
        name09: "请选择盘点人员",
        name10: "试样名称",
        name11: "中文样本名称",
        name12: "CAS 号",
        name13: "条形码",
        name14: "RFID 号码",
        name15: "数量",
        name16: "所有者",
        name17: "位置",
        name18: "短距离",
        name19: "登记日期",
        name20: "位置(现在)",
        name21: "短距离(现在)",
        name22: "库存类型",
        name23: "试剂名",
        name24: "请选择库存类型",
        name25: "盘点结果",
        name26: '正常',
        name27: '试剂数量'
    },
    receive: {
        name01: '同意',
        name02: '不同意',
        name03: '点击详情',
        name04: '添加申请试剂',
        name05: '编辑申请信息',
        name06: "取消申请",
        name07: "审核驳回",
        name08: "审核通过",
        name09: "撤回申请",
        name10: "审核取消"

    },
    largeScreen: {
        name01: "智能柜可视化平台",
        name02: "进入后台系统",
        name03: "左滑",
        name04: "右滑",
        name05: "智能柜总数",
        name06: "试剂总数",
        name07: "人员总数",
        name08: "库存数据统计图",
        name09: "使用量数据统计图",
        name10: "违规记录",
        name11: "试剂分类",
        name12: "试剂属性",
        name13: "领取记录",
        name14: "操作记录",
        name15: "周日",
        name16: "周一",
        name17: "周二",
        name18: "周三",
        name19: "周四",
        name20: "周五",
        name21: "周六",
        name22: "周日",
        name23: "试剂名称",
        name24: "CAS号",
        name25: "RFID编号",
        name26: "负责人",
        name27: "净含量",
        name28: "瓶重",
        name29: "属性",
        name30: "分类",
        name31: "状态",
        name32: "已采购",
        name33: "在柜内",
        name34: "已借出",
        name35: "已注销",
        name36: "使用量",
        name37: '库存量',
        name38: ' 已采购'
    },
    attribute: {
        name01: "请选择试剂属性",
        name02: "冲突试剂",
        name03: "请选择冲突的试剂",
        name04: "系统默认",
        name05: "确认删除试剂配置信息",
        name06: " 注：删除后可能导致试剂分类与统计错误！",
        name07: "互斥属性",
        name08: "属性名称",
        name09: "请输入属性名称",
        name10: "请选择互斥属性",
        name11: "属性名称不能为空!",
        name12: "编辑试剂属性",
        name13: "添加试剂属性",
        name14: "确认删除该条试剂属性信息",
        name15: "删除试剂属性信息",
        name16: "删除成功",
        name17: "设置成功",
        name18: "编辑成功"
    },
    placeholder: {
        name01: '请输入内容',
        name02: "请选择",
        name03: '请输入'
    },
    keyBox: {
        name01: "钥匙名称",
        name02: "标识码",
        name03: "状态",
        name04: "开启",
        name05: "废弃",
        name06: "类型",
        name07: "普通钥匙",
        name08: "卡片",
        name09: "绑定智能柜",
        name10: "存放智能柜",
        name11: "存放智能柜门",
        name12: "钥匙状态",
        name13: "修改钥匙盒信息",
        name14: "添加钥匙盒信息",
        name15: "是否在柜内",
        name16: "状态类型",
        name17: "钥匙类型"

    },
    print: {
        name01: '打印机',
        name02: '请选择打印机',
        name03: '是否打印详情',
        name04: "打印机名称/IP",
        name05: "连接类型",
        name06: "网络",
        name07: "设备类型",
        name08: "Zebra RFID打印机",
        name09: "ZMIN RFID打印机",
        name10: "RD 条码打印机",
        name11: "打印深度",
        name12: "打印速度",
        name13: "端口",
        name14: "X轴偏移量",
        name15: "Y轴偏移量",
        name16: "关联智能柜",
        name17: "名称",
        name18: "打印机名称",
        name19: "请输入打印机名称",
        name20: "请选择类型",
        name21: "请输入设备类型",
        name22: "请输入打印深度",
        name23: "请输入打印速度",
        name24: "IP地址",
        name25: "请输入IP地址",
        name26: "端口号",
        name27: "请输入端口号",
        name28: "请输入X轴偏移量",
        name29: "请输入Y轴偏移量",
        name30: "选择打印模板",
        name31: "请选择关联智能柜",
        name32: "修改打印机信息",
        name33: "添加打印机信息",
        name34: "确定删除打印机信息!",
        name35: "删除打印机"
    },
    upload: {
        name01: '试剂文件',
        name02: '只能上传XLSX文件，将文件拖到此处，或',
        name03: '点击上传',
        name04: '下载模版',
        name05: '错误信息共计',
        name06: "条，请修改后重新上传！",
        name07: "错误原因",
        name08: "Excel行号",
        name09: "上传试剂",
        name10: "试剂导入成功!",
        name11: "上传文件只能是XLSX格式!",
        name12: "只上传Excel文件，将文件拖到此处，或者",
        name13: "错误信息",
        name14: "导入成功!",
        name15: "上传文件只能是XLSX格式",
        name16: "只能上传jpg/png文件",
        name17: "说明",
        name18: "1. 照片命名为用户姓名, 如：张三",
        name19: "2. 如果姓名有重复,需要添加唯一不重复的标识,使用下划线分割, 如: 张三_123"
    },
    msds: {
        name01: "CAS号/名称",
        name02: "化学品中文名",
        name03: "化学品英文名",
        name04: "安全技术说明书",
        name05: "第一部分：化学品名称",
        name06: "化学品中文名称：",
        name07: "化学品俗名：",
        name08: "化学品英文名称：",
        name09: "英文名称:",
        name10: "技术说明书编码：",
        name11: "生产企业名称：",
        name12: "地址：",
        name13: "生效日期:",
        name14: "第二部分：危险性概述",
        name15: " 危险性类别：",
        name16: "侵入途径：",
        name17: "健康危害：",
        name18: "环境危害：",
        name19: "燃爆危险：",
        name20: "第三部分：成分/组成信息",
        name21: "有害物成分",
        name22: "含量",
        name23: "第四部分：急救措施",
        name24: "皮肤接触：",
        name25: "眼睛接触：",
        name26: "吸入：",
        name27: "食入",
        name28: "第五部分：消防措施",
        name29: "危险特性：",
        name30: " 有害燃烧产物：",
        name31: "灭火方法：",
        name32: "第六部分：泄漏应急处理",
        name33: "应急处理：",
        name34: "第七部分：操作处置与储存",
        name35: " 操作注意事项：",
        name36: "储存注意事项：",
        name37: "第八部分：接触控制/个体防护",
        name38: " 中国MAC(mg/m3)：",
        name39: "前苏联MAC(mg/m3)：",
        name40: "监测方法：",
        name41: "工程控制：",
        name42: " 呼吸系统防护：",
        name43: "眼睛防护：",
        name44: "身体防护：",
        name45: "手防护：",
        name46: "其他防护：",
        name47: "第九部分：理化特性",
        name48: '外观与性状：',
        name49: "熔点(℃)：",
        name50: "相对密度(水=1)：",
        name51: "沸点(℃)：",
        name52: " 相对蒸气密度(空气=1)：",
        name53: "分子式：",
        name54: "分子量：",
        name55: "主要成分：",
        name56: "饱和蒸气压(kPa)：",
        name57: "燃烧热(kJ/mol)：",
        name58: "临界温度(℃)：",
        name59: "临界压力(MPa)：",
        name60: " 辛醇/水分配系数的对数值：",
        name61: "闪点(℃)：",
        name62: "爆炸上限%(V/V)：",
        name63: "引燃温度(℃)：",
        name64: "爆炸下限%(V/V)：",
        name65: "溶解性：",
        name66: "主要用途：",
        name67: "其它理化性质：",
        name68: "第十部分：稳定性和反应活性",
        name69: "稳定性：",
        name70: "禁配物：",
        name71: "避免接触的条件：",
        name72: "聚合危害：",
        name73: "分解产物：",
        name74: "第十一部分：毒理学资料",
        name75: "急性毒性：",
        name76: "亚急性和慢性毒性：",
        name77: "刺激性：",
        name78: "致敏性：",
        name79: "致突变性：",
        name80: "致畸性：",
        name81: "致癌性：",
        name82: "第十二部分：生态学资料",
        name83: "生态毒理毒性：",
        name84: " 生物降解性：",
        name85: " 非生物降解性：",
        name86: " 生物富集或生物积累性：",
        name87: ' 其它有害作用：',
        name88: "第十三部分：废弃处置",
        name89: "废弃物性质：",
        name90: " 废弃处置方法：",
        name91: " 废弃注意事项：",
        name92: "第十四部分：运输信息",
        name93: "危险货物编号：",
        name94: "UN编号：",
        name95: "包装标志：",
        name96: "包装类别：",
        name97: "包装方法：",
        name98: " 运输注意事项：",
        name99: "第十五部分：法规信息",
        name100: "法规信息：",
        name101: "第十六部分：其他信息",
        name102: "参考文献：",
        name103: "填表部门：",
        name104: "数据审核单位：",
        name105: "修改说明：",
        name106: "其他信息：",
        name107: "未找到相应MSDS",
        name108: "确定删除该条MSDS信息！",
        name109: "删除MSDS信息",
        name110: '删除成功'
    },
    purchaseOrder: {
        name01: "入库状态",
        name02: "采购单号",
        name03: "按选中采购单入库",
        name04: "按选中采购单导出",
        name05: "按选中采购单打印",
        name06: "批量导出",
        name07: "批量打印",
        name08: "采购单号",
        name09: "发起时间",
        name10: "审批中",
        name11: "审批失败",
        name12: "审批成功",
        name13: "取消审批",
        name14: "发起人",
        name15: "发起人联系方式",
        name16: "采购单联系方式",
        name17: "采购明细",
        name18: "课题组",
        name19: "项目准入编号",
        name20: "未入库",
        name21: "已入库",
        name22: "审批状态",
        name23: "已取消入库",
        name24: "入库成功"
    },
    video: {
        name01: "录像结束时间",
        name02: "录像开始时间",
        name03: "总时长",
        name04: "播放视频",
        name05: "视频列表"
    },
    approval: {
        name01: "试剂添加",
        name02: "试剂领用",
        name03: "试剂注销",
        name04: "采购申请",
        name05: "项目准入申请",
        name06: "补码申请",
        name07: "配置类型",
        name08: "全局配置",
        name09: "分类配置",
        name10: "配置名称",
        name11: "审批步骤",
        name12: "审核人",
        name13: "人员审核：",
        name14: "试剂负责人审核",
        name15: "实验室管理员审核 ",
        name16: "角色审核：  ",
        name17: "指定试剂",
        name18: "试剂柜负责人审核",
        name19: "审核步骤",
        name20: "确认删除该条审批流信息",
        name21: "步骤",
        name22: "点击选择试剂",
        name23: "是否仅本",
        name24: "编辑审批流",
        name25: "添加审批流",
        name26: "指定人员",
        name27: "指定角色",
        name28: "实验室管理员",
        name29: "试剂柜负责人",
        name30: "待审批",
        name31: "审批记录",
        name32: "审核详情",
        name33: "试剂配置详情",
        name34: "申请记录",
        name35: "添加补码申请",
        name36: "编辑补码申请",
        name37: "请输入补码原因",
        name38: "补码原因",
        name39: "操作码",
        name40: "审批详情",
        name41: "已申请",
        name42: "审批结果",
        name43: "已发出申请",
        name44: "待通知",
        name45: "已同意",
        name46: "已拒绝",
        name47: "撤销",
        name48: "项目名称",
        name49: "项目类型",
        name50: "本科生教学",
        name51: "研究生教学",
        name52: "创新类项目",
        name53: "科研类项目",
        name54: "实验项目准入编号",
        name55: "编辑项目准入申请",
        name56: "添加项目准入申请",
        name57: "撤回",
        name58: "试剂明细",
        name59: "试剂中文名称",
        name60: "试剂CAS号",
        name61: "记录",
        name62: "实验地点",
        name63: "实验日期",
        name64: "审批时间",
        name65: "化学品使用团队",
        name66: "采购试剂",
        name67: "采购详情",
        name68: "实验项目准入",
        name69: "采购联系人电话",
        name70: "费用编号",
        name71: "存放地点柜子",
        name72: "规格值",
        name73: "添加采购申请",
        name74: "申请审批",
        name75: "仅展示在柜内的试剂列表",
        name76: "添加实验室",
        name77: "编辑实验室",
        name78: "申请中",
        name79: "规格值",
        name80: "单位"
    },
    supplier: {
        name01: "供应商银行账号",
        name02: "供应商开户行",
        name03: "供应商联系人身份证",
        name04: "院内联系人身份证",
        name05: "院内联系人",
        name06: "院内联系人电话",
        name07: "许可证类型",
        name08: "许可证编号",
        name09: "许可证开始时间",
        name10: "许可证结束时间",
        name11: "附件",
        name12: "供应商姓名",
        name13: "供应商地址",
        name14: "供应商联系人姓名",
        name15: "供应商联系人电话",
        name16: "已确定",
        name17: "确认删除该条试剂属性信息!",
        name18: "化学品名称",
        name19: '供应商',
        name20: "供应商待确认",
        name21: "危化品经营许可证",
        name22: "供应商详情",
        name23: "待确定",
        name24: "附件类型",
        name25: "请选择附件类型",
        name26: "危化品明细",
        name27: "营业执照",
        name28: "供应商联系人不能为空!",
        name29: "供应商名称不能为空！",
        name30: "供应商确认",
        name31: "供应商下试剂明细"

    },
    permission: {
        name01: "菜单名称",
        name02: "请求方式",
        name03: "请求接口",
        name04: "校验方式",
        name05: "创建时间",
        name06: "修改时间",
        name07: "图标",
        name08: "编码",
        name09: "组件路径"

    },
    localSetting: {
        name01: "具体位置",
        name02: "选择上级",
        name03: "请输入具体位置",
        name04: "选择类型",
        name05: "添加场所",
        name06: "编辑场所"
    },
    confirm: {
        name01: "此次操作将撤销申请，是否继续？",
        name02: "是否需要继续申请？",
        name03: "是否需要继续录入？",
        name04: "退回此次采购单, 是否继续?",
        name05: "已取消退出",
        name06: "是否确认选中采购单进行入库",
        name07: "请填写危化品明细",
        name08: "审批拒绝时理由不能为空",
        name09: "品名不能为空",
        name10: "申请成功"

    },
    order: {
        name01: "订单号",
        name02: "课题组名称",
        name03: "课题组负责人姓名",
        name04: "请购人姓名",
        name05: "供应商名称",
        name06: "商品名称",
        name07: "品牌",
        name08: "货号",
        name09: "包装规格",
        name10: "单价",
        name11: '销售单位',
        name12: "总价",
        name13: '验收状态',
        name14: "收货状态",
        name15: "试剂入库",
        name16: "订单列表",
        name17: "试剂列表"

    }
};

/* harmony default export */ __webpack_exports__["a"] = (zh);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var zh = {
    name01: "Smart Cabinet Overview",
    name02: "Operation Records",
    name03: "Pick-up Records",
    name04: "Return Records",
    name05: "Pending Return Reagent Records",
    name06: "Pending Disposal Reagent Records",
    name07: "Insufficient Inventory Information",
    name08: "Overdue Unreturned Records",
    name09: "Imminent Expiry Reagents",
    name10: "Unweighed Return Records",
    name11: "Personnel Management",
    name12: "Reagent Management",
    name13: "In-stock Reagents",
    name14: "Disposal Request",
    name15: "Violation Management",
    name16: "Search",
    name17: "Report Management",
    name18: "Chemical Monthly Report",
    name19: "Hazardous Chemical Monthly Report",
    name20: "Hazardous Chemical Usage Report",
    name21: "System Settings",
    name22: "Company Information",
    name23: "College Information",
    name24: "Violation Conditions",
    name25: "Reagent Categories",
    name26: "Reagent Configuration",
    name27: "Manufacturer Configuration",
    name28: "Device Status",
    name29: "Email Configuration",
    name30: "APK Upgrade",
    name31: "Smart Cabinet Terminal Logs",
    name32: "Application Management",
    name33: "My Applications",
    name34: "Application Processing",
    name35: "Excel Import",
    name36: "Handheld Inventory Records",
    name37: "All",
    name38: "Back",
    name39: "More Filters (Expand)",
    name40: "More Filters (Collapse)",
    name41: "save",
    name42: "Save and submit",
    main: {
        name01: "Smart Cabinet Management System",
        name02: "Search",
        name03: "Add",
        name04: "Edit",
        name05: "Delete",
        name06: "Operation",
        name07: "Cancel",
        name08: "Confirm",
        name09: "Yes",
        name10: "No",
        name11: "Start Time",
        name12: "End Time",
        name13: "All",
        name14: "Unable to connect to the server, please check the network!",
        name15: "You do not have permission to access the system. Please log in again or contact the administrator!",
        name16: "Batch Processing",
        name17: "Label Printing",
        name18: "Sheets",
        name19: "Edit Selected",
        name20: "Delete Selected",
        name21: "Show Columns",
        name22: "More Actions",
        name23: "Print",
        name24: "Details",
        name25: "Close",
        name26: "Not Selected",
        name27: "Next",
        name28: "Previous",
        name29: "Submit",
        name30: "No Data Available",
        name31: "Added Successfully",
        name32: "Stock In Export",
        name33: "Return",
        name34: "Authorize Permissions",
        name35: "View Permissions",
        name36: "Add Subitem",
        name37: "Single Add",
        name38: "Batch Add",
        name39: "View Details",
        name40: "Edit Cabinet Door",
        name41: "More Settings",
        name42: "Edit Cabinet",
        name43: "Functionality",
        name44: "Remote Inventory",
        name45: "Sync Face",
        name46: "View Video",
        name47: "View Inventory",
        name48: "Specify Smart Cabinet",
        name49: "Select All",
        enable: "Enable",
        disable: "Disable"

    },
    login: {
        name1: "Smart Cabinet Management System",
        name2: "Login",
        name3: "Mobile Number",
        name4: "Password",
        name5: "Mobile number cannot be empty",
        name6: "Password cannot be empty",
        name7: "Chemical Intelligent Reagent Cabinet Management System V2.1.0",
        name8: "Change Password",
        name9: "Log Out",
        name10: "Old Password",
        name11: "New Password",
        name12: "Confirm Password"
    },
    cabinet: {
        name01: "Number",
        name02: "Enter Smart Cabinet Number",
        name03: "Name",
        name04: "Enter Smart Cabinet Name",
        name05: "Multi-Door Cabinet",
        name06: "Enter Total Door Count",
        name07: "Smart Cabinet Type",
        name08: "Select Smart Cabinet Type",
        name09: "Smart Cabinet Control Type",
        name10: "Select Smart Cabinet Control Type",
        name11: "Control Cabinet",
        name12: "Select Control Cabinet",
        name13: "Storage Category",
        name14: "Select Hazard Category",
        name15: "Company",
        name16: "Select Custodian Company",
        name17: "College",
        name18: "Select Custodian College",
        name19: "Location",
        name20: "Enter Custodian Location",
        name21: "Capacity cannot be empty",
        name22: "Capacity must be a positive integer",
        name23: "RFID Cabinet",
        name24: "Barcode Cabinet",
        name25: "Storage Cabinet",
        name26: "Control Cabinet",
        name27: "Integrated Cabinet",
        name28: "Smart Cabinet Number cannot be empty",
        name29: "Smart Cabinet Name cannot be empty",
        name30: "Edit Smart Cabinet",
        name31: "Add Smart Cabinet",
        name32: "Disposal of This Smart Cabinet",
        name33: "Door Lock",
        name34: "Fan",
        name35: "Inventory",
        name36: "Liquid",
        name37: "Solid",
        name38: "Operations Today",
        name39: "Borrowed Today",
        name40: "Returned Today",
        name41: "Select Cabinet Door",
        name42: "Edit Information",
        name43: "Used Today",
        name44: "View Inventory",
        name45: "Temperature",
        name46: "Humidity",
        name47: "VOC",
        name48: "Smart Cabinet",
        name49: "Confirm Disposal of This Smart Cabinet Information!",
        name50: "Disposal of Smart Cabinet",
        name51: "Successfully Deleted Smart Cabinet Information!",
        name52: "Online",
        name53: "Offline",
        name54: "Exhaust Fan",
        name55: "Smart Cabinet Status",
        name56: "Total Devices (Units)",
        name57: "Total Inventory (Bottles)",
        name58: "Data Today",
        name59: "Special Tips Today",
        name60: "Operations Today",
        name61: "Exceptions Today",
        name62: "Pick-ups Today",
        name63: "Returns Today",
        name64: "Pending Returns",
        name65: "Pending Disposals",
        name66: "Insufficient Inventory",
        name67: "Overdue Unreturns",
        name68: "Imminent Expiry",
        name69: "Unweighed Returns",
        name70: "Times",
        name71: "count",
        name72: "Bottles",
        name73: "Type",
        name74: "Weight",
        name75: "All Smart Cabinets",
        name76: "Convenient Search by Number",
        name77: "Current Capacity",
        name78: "Total Capacity",
        name79: "Refresh",
        name80: "Other Configurations",
        name81: "Enter Other Configurations (Recommend using JSON string)",
        name82: "Sort",
        name83: "Smart Cabinet Serial Number",
        name84: "Has Temperature Sensor",
        name85: "Has Humidity Sensor",
        name86: "Has Smart Lock",
        name87: "Has Fan",
        name88: "Has VOC Sensor",
        name89: "Location Abbreviation",
        name90: "Enter Abbreviation for Storage Location",
        name91: "Regular Cabinet",
        name92: "Has Camera",
        name93: "Camera Serial Number",
        name94: "Camera IP",
        name95: "Supervised",
        name96: "Lock Connection Type",
        name97: "Lock Connection Address",
        name98: "Enter Lock Connection Address",
        name99: "Lock Connection Port",
        name100: "Enter Lock Connection Port",
        name101: "IO Port Number",
        name102: "Enter IO Port Number",
        name103: "Smart Cabinet Door",
        name104: "Select Smart Cabinet Door",
        name105: "Display?",
        name106: "Select Cabinet Type",
        name107: "Exception",
        name108: "Subordinate to a total of",
        name109: "Smart Cabinets",
        name110: "Confirm Remote Inventory!",
        name111: "Inventory Successful!",
        name112: "Storage Attribute",
        name113: "Select Storage Attribute",
        name114: "Location Settings",
        name115: "Display?",
        name116: "Storage Cabinet (with Screen)",
        name117: "Storage Cabinet (without Screen)",
        name118: "MQ Connection (Default)",
        name119: "WIFI Relay",
        name120: "Independent Key Box",
        name121: "Bluetooth Lock",
        name122: "Confirm Face Sync!",
        name123: "Face Sync Successful!",
        name124: "Laboratory",
        name125: "Warehouse",
        name126: "No need for supervision",
        name127: "One Verification",
        name128: "2 verifications"
    },
    door: {
        name01: "Cabinet Door Name",
        name02: "Cabinet Door Number",
        name03: "Edit Cabinet Door Information",
        name04: "Modification Successful!",
        name05: "Cabinet Door",
        name06: "Confirm Authorization",
        name07: "Confirm Deauthorization",
        name08: "Smart Cabinet",
        name09: "Select Stock In Cabinet Door",
        name10: "Stock In Cabinet Door"

    },
    user: {
        name01: "User Information:",
        name02: "User Card Number",
        name03: "Enter Card Number",
        name04: "User Name",
        name05: "Enter Name",
        name06: "Email",
        name07: "Enter Email",
        name08: "User ID",
        name09: "Enter User ID",
        name10: "Mobile Number",
        name11: "Enter Mobile Number",
        name12: "College",
        name13: "Select College",
        name14: "Password Settings:",
        name15: "Username",
        name16: "Enter Username",
        name17: "Password",
        name18: "Enter Password",
        name19: "Confirm Password",
        name20: "Re-enter Password",
        name21: "Permission Settings:",
        name22: "Select Role",
        name23: "Borrowing Permission",
        name24: "Select Hazard Category",
        name25: "Authorize",
        name26: "Authorization Expiry Date",
        name27: "Select Authorization Expiry Date",
        name28: "Card Number cannot be empty",
        name29: "Username cannot be empty",
        name30: "Password length cannot be less than 6 characters",
        name31: "Passwords do not match",
        name32: "Enter Name",
        name33: "Enter a valid Email",
        name34: "Username cannot be empty",
        name35: "Enter a valid Mobile Number",
        name36: "cannot be empty",
        name37: "cannot be empty",
        name38: "Edit Personnel",
        name39: "Add Personnel",
        name40: "Successfully Updated User Information!",
        name41: "Successfully Added User Information!",
        name42: "Confirm Deletion of this Personnel Information!",
        name43: "Delete Personnel Information",
        name44: "Successfully Deleted Personnel Information!",
        name45: "Administrator",
        name46: "Operator",
        name47: "Role",
        name48: "Employee ID/Username",
        name49: "Edit Door Access Permission",
        name50: "Open Door",
        name51: "*",
        name52: "Status",
        name53: "Reagent Responsible",
        name54: "Reagent User",
        name55: "Select Status",
        name56: "Select Responsible Person",
        name57: "Select Reagent User",
        name58: "Personnel Information",
        name59: "List of cabinet doors that can be opened after approval of reagent pickup application",
        name60: "Authorize",
        name61: "List of cabinet doors that can be manually opened in the admin panel",
        name62: "Default",
        name63: "List of cabinet doors automatically authorized to be opened in the smart cabinet",
        name64: "Card number cannot start with 0",
        name65: "Door Access Permission",
        name66: "Enable",
        name67: "Enter Username",
        name68: "Photo MD5",
        name69: "Photo",
        name70: "Has Feature Value",
        name71: "Confirm deletion of this facial information?",
        name72: "Delete Facial Information",
        name73: "Upload Photo",
        name74: "Edit Facial Information",
        name75: "Add Facial Information",
        name76: "User",
        name77: "Are you sure you want to delete?",
        name78: "Role Name",
        name79: "Role Level",
        name80: "Enter Role Name",
        name81: "Enter Sorting",
        name82: "Level",
        name83: "Enter Level",
        name84: "Permission List Information",
        name85: "Select All/Deselect All",
        name86: "Loading, please wait",
        name87: "Edit Role Information",
        name88: "Add Role Information",
        role_code: "Role Code",
        input_role_code: "please enter role code",
        please_select_status: "Please select user status",
        user_status: "User status"

    },
    materiel: {
        name01: "Reagent Information",
        name02: "Batch Number",
        name03: "Please enter the batch number",
        name04: "RFID Number",
        name05: "Please enter the RFID number",
        name06: "Weighing",
        name07: "Do you need weighing",
        name08: "Gross Weight",
        name09: "Please enter the gross weight",
        name10: "Net Content",
        name11: "Please enter the net content",
        name12: "Bottle Weight",
        name13: "Please enter the bottle weight",
        name14: "Inbound Information",
        name15: "Production Date",
        name16: "Select the production date",
        name17: "Expiration Date",
        name18: "Select the expiration date",
        name19: "Manufacturer",
        name20: "Please select the manufacturer",
        name21: "Remarks",
        name22: "Please enter remarks",
        name23: "Disposal Status",
        name24: "* Indicates required fields",
        name25: "RFID number cannot be empty",
        name26: "Please enter the bottle weight",
        name27: "Please enter a non-negative number",
        name28: "Please enter the gross weight",
        name29: "Please enter the net content",
        name30: "Please enter the density",
        name31: "Please enter the specifications",
        name32: "Edit Reagent",
        name33: "Add Reagent",
        name34: "Are you sure you want to dispose of this reagent?",
        name35: "Confirm",
        name36: "Cancel",
        name37: "Prompt",
        name38: "Confirm deletion of this reagent information!",
        name39: "Delete Reagent Information",
        name40: "Successfully deleted reagent information!",
        name41: "Product Name/CAS Number",
        name42: "Disposal Time",
        name43: "Last Record Time",
        name44: "Copy",
        name45: "Permissions",
        name46: "Bottle weight cannot be less than 0!",
        name47: "Inbound Time",
        name48: "Disposal Request",
        name49: "Disposed Reagents",
        name50: "Applicant",
        name51: "Application Time",
        name52: "Approval Status",
        name53: "Unreviewed",
        name54: "Approved",
        name55: "Not Approved",
        name56: "Approver",
        name57: "Approval Time",
        name58: "Approve",
        name59: "Reject",
        name60: "Product Name/English Name/CAS Number",
        name61: "Please select the product name",
        name62: "Distribution Chart",
        name63: "There are",
        name64: "reagents in the smart cabinet",
        name65: "Export to Excel",
        name66: "Category",
        name67: "Net Content",
        name68: "Total Bottle Count",
        name69: "Details",
        name70: "Alert",
        name71: "Bottles",
        name72: "Reagent Not Weighed Upon Return",
        name73: "Reagent",
        name74: "Days Until Expiry",
        name75: "Reagent Expired",
        name76: "Distribution Information",
        name77: "Barcode",
        name78: "Please enter Barcode",
        name79: "Location",
        name80: "Please enter Location",
        name81: "Short Location",
        name82: "Please enter Short Location",
        name83: "Please select the custodian location",
        name84: "Owner",
        name85: "Please select the shortLocation",
        name86: "Please select the owner",
        name87: "Show by Number",
        name88: "Show by Product Name",
        name89: "Smart Cabinet Manager",
        name90: "Please select the Smart Cabinet Manager",
        name91: "Bottle Weight Reference Information",
        name92: "Edit Content:",
        name93: "Responsible Person",
        name94: "Please select the responsible person",
        name95: "Weighing Required",
        name96: "Inbound Cabinet",
        name97: "Please select the inbound cabinet",
        name98: "Bulk Inbound",
        name99: "Manager Information",
        name100: "Reagent Configuration Information",
        name101: "Reagent Details Information",
        name102: "Please select the manager information",
        name103: "Please select the reagent configuration information",
        name104: "Location Information",
        name105: "Are you sure you want to delete this reagent?",
        name106: "Please complete the selection of the first item, responsible person and department",
        name107: "Please complete the selection of the second item, reagent configuration",
        name108: "Configuration not found? Please first",
        name109: "Add Configuration",
        name110: "Please fill in the reagent details information",
        name111: "Both net content and bottle weight must be filled in!",
        name112: "The door of a multi door cabinet cannot be empty!",
        name113: "School/Department"
    },
    error: {
        name01: "All Rights Reserved",
        name02: "Please check if the entered URL is correct. Click the button below to return to the homepage or send an error report.",
        name03: "Back to Homepage",
        name04: "XX says you can't access this page..."
    },
    alarm: {
        name01: "Please select the Smart Cabinet",
        name02: "Employee ID/Name/Username/Reagent Name",
        name03: "Personnel",
        name04: "Smart Cabinet Number",
        name05: "Event",
        name06: "Time",
        name07: "Delete Selected",
        name08: "Delete All",
        name09: "All Smart Cabinets",
        name10: "Confirm deletion of violation information!",
        name11: "Delete Violation Information",
        name12: "Successfully deleted violation information!",
        name13: "Handling Comments",
        name14: "Resolved",
        name15: "Unresolved",
        name16: "Record",
        name17: "Notify",
        name18: "Threshold",
        name19: "Notification Type",
        name20: "Notification Recipient Type",
        name21: "Notification Recipients",
        name22: "Reporter",
        name23: "Report Time",
        name24: "Report Explanation",
        name25: "Report Image",
        name26: "Handle",
        name27: "Add Exception Tag",
        name28: "Edit Exception Tag",
        name29: "Please enter handling comments",
        name30: "Please enter the exception type name",
        name31: "Handling Violation Records",
        name32: "Is notification enabled",
        name33: "record",
        name34: "Not filled in",
        name35: "deregulation",
        name36: "early warning",
        name37: "Notification object",
        name38: "Handling Exceptions",
        name39: "Exception label name cannot be empty!",
        name40: "Indeed delete the exception label",
        name41: "Delete Exception Tags"
    },
    search: {
        name01: "Reagent Search",
        name02: "Employee's Reagent Search",
        name03: "RFID Number/Product Name/CAS Number",
        name04: "RFID Number",
        name05: "Status",
        name06: "Not Borrowed",
        name07: "Borrowed",
        name08: "Purchased",
        name09: "Location",
        name10: "Last Contact Person",
        name11: "Last Record Time",
        name12: "Circulation Details",
        name13: "Click to view",
        name14: "Employee ID/Name/Username",
        name15: "Username",
        name16: "Name",
        name17: "Current Holding Quantity",
        name18: "Borrowed Quantity",
        name19: "Borrowing Times",
        name20: "Return Times",
        name21: "Circulation Information",
        name22: "Name:",
        name23: "Number:",
        name24: "Status:",
        name25: "Not Borrowed",
        name26: "In Cabinet:",
        name27: "Net Content:",
        name28: "Net Content",
        name29: "Not Weighed",
        name30: "Purchased",
        name31: "Inbound",
        name32: "Borrowed",
        name33: "Returned",
        name34: "Disposed",
        name35: "Reagent Search",
        name36: "Apply",
        name37: "Review"
    },
    report: {
        name01: "Hazardous Chemical Monthly Report",
        name02: "Hazardous Chemical Issuance Report",
        name03: "Chemical Monthly Report",
        name04: "Chemical Inventory Report",
        name05: "Date",
        name06: "Incoming Quantity",
        name07: "Outgoing Quantity",
        name08: "Inventory Quantity",
        name09: "Reagent Number",
        name10: "Operator",
        name11: "Usage Quantity",
        name12: "Operation Type",
        name13: "Smart Cabinet Name",
        name14: "Please Select Reagent",
        name15: "Display by Single Bottle",
        name16: "By single display",
        name17: "Location",
        name18: "Group by Name",
        name19: "Group by Name",
        name20: "Public Security Ledger",
        name21: "Supervisor",
        name22: "Reason",
        name23: "Supervisor",
        name24: "Remaining Quantity",
        name25: "Please enter reagent name/RFID",
        name26: "Please select the operation type",
        name27: "Please select the operator",
        name28: "Sort by time",
        name29: "Operation content",
        name30: "View video recordings",
        name31: "Please enter the name of the reagent product",
        amount_purchased: "Amount Purchased",
        cancellation_amount: "Cancellation Amount",
        adjustment_amount: "Adjustment Amount",
        total_margin: "Total Margin",
        total_quantity_in_storage: "Total Quantity In Storage"
    },
    company: {
        name01: "Company Name",
        name02: "Edit Company Information",
        name03: "Add Company Information",
        name04: "Please Enter Company Name!",
        name05: "Company Name cannot be empty",
        name06: "Delete Company Information",
        name07: "Confirm deletion of this company information!",
        name08: "Company Information deleted successfully!",
        name09: "Add New Company Information",
        name10: "Functional Configuration Item",
        name11: "Department Name",
        name12: "Configuration Item",
        name13: "Configuration Name",
        name14: "Configuration Key",
        name15: "Configuration Type",
        name16: "Default",
        name17: "Filling Requirements",
        name18: "Configuration Value",
        name19: "Edit System Configuration Item Information",
        name20: "Add System Configuration Item Information",
        name21: "General Configuration",
        name22: "Super Admin Configuration Only",
        name23: "Please Select Company",
        name24: "Please Select Configuration Type",
        name25: "Please enter the key",
        name26: "Is it only for super management configuration",
        name27: "User Name",
        name28: "Company Type",
        name29: "Edit New Company Information"

    },
    department: {
        name01: "College Name",
        name02: "Edit",
        name03: "Add",
        name04: "Please Enter Name!",
        name05: "Name cannot be empty",
        name06: "Delete Information",
        name07: "Confirm deletion of this information!",
        name08: "Information deleted successfully!",
        name09: "Please Select Department/College",
        name10: "Student ID",
        name11: "Please enter student ID",
        name12: "College Information",
        name13: "Department",
        name14: "Please Select Department",
        name15: "Job ID",
        name16: "Please enter the job number",
        name17: 'Department Information'
    },
    setting: {
        name01: "Warning Items",
        name02: "Data",
        name03: "Notify Fixed Email",
        name04: "Notify Violator",
        name05: "Low Inventory Ratio (%)",
        name06: "Admin Reagent Issuance Limit",
        name07: "Operator Reagent Issuance Limit",
        name08: "Reagent Overdue Return (hours)",
        name09: "Max Idle Time in Cabinet (days)",
        name10: "Cabinet Open Time Limit (minutes)",
        name11: "Record Unweighed Items",
        name12: "Record Unauthorized Reagent Acquisition",
        name13: "Time to Weigh Before Return (seconds)",
        name14: "Expiry Warning Period (days)",
        name15: "Hours",
        name16: "Days",
        name17: "Minutes",
        name18: "Please Enter Low Inventory Ratio (%)",
        name19: "Low Inventory Ratio Notification Email",
        name20: "Please Enter Low Inventory Ratio Notification Email (multiple emails separated by ;)",
        name21: "Please Enter Admin Reagent Issuance Limit",
        name22: "Admin Reagent Issuance Limit Notification Email",
        name23: "Please Enter Admin Reagent Issuance Limit Notification Email (multiple emails separated by ;)",
        name24: "Notify Violator for Admin Reagent Issuance Limit",
        name25: "Please Enter Operator Reagent Issuance Limit",
        name26: "Operator Reagent Issuance Limit Notification Email",
        name27: "Please Enter Operator Reagent Issuance Limit Notification Email (multiple emails separated by ;)",
        name28: "Notify Violator for Operator Reagent Issuance Limit",
        name29: "Please Enter Reagent Overdue Return Limit",
        name30: "Reagent Overdue Return Notification Email",
        name31: "Please Enter Reagent Overdue Return Notification Email (multiple emails separated by ;)",
        name32: "Notify Violator for Reagent Overdue Return",
        name33: "Please Enter Max Idle Time in Cabinet",
        name34: "Max Idle Time in Cabinet Notification Email",
        name35: "Please Enter Max Idle Time in Cabinet Notification Email (multiple emails separated by ;)",
        name36: "Cabinet Open Time Limit",
        name37: "Cabinet Open Time Limit Notification Email",
        name38: "Please Enter Cabinet Open Time Limit Notification Email (multiple emails separated by ;)",
        name39: "Notify Violator for Cabinet Open Time Limit",
        name40: "Please Enter Time to Weigh Before Return (in seconds)",
        name41: "Unweighed Before Return Notification Email",
        name42: "Please Enter Unweighed Before Return Notification Email (multiple emails separated by ;)",
        name43: "Notify Violator for Unweighed Before Return",
        name44: "Expiry Notification Email",
        name45: "Please Enter Expiry Notification Email (multiple emails separated by ;)",
        name46: "Unweighed Notification Email",
        name47: "Please Enter Unweighed Notification Email (multiple emails separated by ;)",
        name48: "Notify Violator for Unweighed",
        name49: "Record Unauthorized Reagent Acquisition",
        name50: "Unauthorized Reagent Acquisition Notification Email",
        name51: "Please Enter Unauthorized Reagent Acquisition Notification Email (multiple emails separated by ;)",
        name52: "Notify Violator for Unauthorized Reagent Acquisition",
        name53: "Admin Reagent Issuance Limit cannot be empty",
        name54: "Admin Reagent Issuance Limit cannot be negative",
        name55: "Reagent Overdue Return Limit cannot be empty",
        name56: "Reagent Overdue Return Limit cannot be negative",
        name57: "Cabinet Open Time Limit cannot be empty",
        name58: "Cabinet Open Time Limit cannot be negative",
        name59: "Max Idle Time in Cabinet cannot be empty",
        name60: "Max Idle Time in Cabinet cannot be negative",
        name61: "Operator Reagent Issuance Limit cannot be empty",
        name62: "Operator Reagent Issuance Limit cannot be negative",
        name63: "Max Quantity in Smart Cabinet cannot be empty",
        name64: "Max Quantity in Smart Cabinet cannot be negative",
        name65: "Seconds",
        name66: "Warning Configuration",
        name67: "VOC Threshold",
        name68: "VOC Alarm Notification Email",
        name69: "VOC Alarm Notification Email (multiple emails separated by ;)",
        name70: "Door Opening Timeout",
        name71: "Please Enter Door Opening Timeout",
        name72: "Temperature Upper Limit for Warning",
        name73: "Please Enter Temperature Upper Limit for Warning",
        name74: "Temperature Lower Limit for Warning",
        name75: "Please Enter Temperature Lower Limit for Warning",
        name76: "Humidity Upper Limit for Warning",
        name77: "Please Enter Humidity Upper Limit for Warning",
        name78: "Humidity Lower Limit for Warning",
        name79: "Please Enter Humidity Lower Limit for Warning",
        name80: "VOC Upper Limit for Warning",
        name81: "Please Enter VOC Upper Limit for Warning",
        name82: "Maximum Storage Quantity",
        name83: "Please Enter Maximum Storage Quantity",
        name84: "Default Authorization for Door Opening",
        name85: "Default Authorization for Door Opening",
        name86: "Follow Smart Cabinet",
        name87: "Enable Attribute Conflict Detection",
        name88: "Follow System",
        name89: "Authorize to Sub-Departments",
        name90: "Enable Reagent Attribute Conflict Detection",
        name91: "Interval for Continuous Alarm Push (s)",
        name92: "Configuration Item",
        name93: "Configuration Data",
        name94: "Select File"

    },
    danger: {
        name01: "Name",
        name02: "Please Enter Hazardous Category Name",
        name03: "Edit Hazardous Category Configuration",
        name04: "Add Hazardous Category Configuration",
        name05: "Confirm deletion of this Hazardous Category configuration!",
        name06: "Delete Hazardous Category Configuration",
        name07: "Hazardous Category Configuration deleted successfully!",
        name08: "Hazardous Category Name cannot be empty!",
        name09: "Is it a Hazardous Chemical",
        name10: "Is it a Controlled Category",
        name11: "Please Enter Hazardous Category Number",
        name12: "Controlled Category"
    },
    cas: {
        name01: "Product Name/English Name/CAS Number",
        name02: "Product Name",
        name03: "English Name",
        name04: "CAS Number",
        name05: "MSDS",
        name06: "Form",
        name07: "Liquid (ml)",
        name08: "Solid (g)",
        name09: "Density",
        name10: "Specification",
        name11: "Hazard Category",
        name12: "Other Description",
        name13: "Please Enter Product Name",
        name14: "Please Enter English Name",
        name15: "Please Enter CAS Number",
        name16: "Select Reagent Form",
        name17: "Liquid Density (g/ml)",
        name18: "Enter Specification (g)",
        name19: "Enter Specification (ml)",
        name20: "Select Hazard Category",
        name21: "g/ml",
        name22: "Enter Other Description",
        name23: "Edit Product Name Configuration",
        name24: "Add Product Name Configuration",
        name25: "Confirm deletion of this Product Name configuration!",
        name26: "Delete Product Name Configuration",
        name27: "Product Name Configuration deleted successfully!",
        name28: "Product Name cannot be empty!",
        name29: "ml",
        name30: "g",
        name31: "MSDS URL",
        name32: "Sample Name",
        name33: "Sample Name in Chinese",
        name34: "Please enter Sample Name",
        name35: "Please enter Sample Name in Chinese",
        name36: "Chinese Alias",
        name37: "English Alias",
        name38: "Enter Chinese Alias",
        name39: "Enter English Alias"

    },
    manufacturer: {
        name01: "Name",
        name02: "Manufacturer Name",
        name03: "Manufacturer Code",
        name04: "Contact Person",
        name05: "Contact Number",
        name06: "Please Enter Manufacturer Name",
        name07: "Please Enter Manufacturer Code",
        name08: "Please Enter Contact Person",
        name09: "Please Enter Contact Number",
        name10: "Manufacturer Name cannot be empty",
        name11: "Edit Manufacturer Configuration",
        name12: "Add Manufacturer Configuration",
        name13: "Confirm deletion of this Manufacturer configuration!",
        name14: "Delete Manufacturer Configuration",
        name15: "Manufacturer Configuration deleted successfully!"
    },
    sensor: {
        name01: "Field Name",
        name02: "Is Visible",
        name03: "Show",
        name04: "Hide",
        name05: "Name"
    },
    mail: {
        name01: "Email Test",
        name02: "Email Configuration",
        name03: "Data",
        name04: "Email Server Address",
        name05: "Email Server Port",
        name06: "Email",
        name07: "Email Password",
        name08: "Enable SSL",
        name09: "Is Exchange Email Service",
        name10: "Settings modified successfully!",
        name11: "Please Enter Email Server Address",
        name12: "Please Enter Email Server Port",
        name13: "Please Enter Email",
        name14: "Please Enter Email Password",
        name15: "Test Email",
        name16: "Please Enter Test Email Address",
        name17: "Email sent successfully!",
        name18: "Email"
    },
    apk: {
        name01: "APK Version Number/Name",
        name02: "Version",
        name03: "Version Address",
        name04: "Click to Download",
        name05: "Version Description",
        name06: "Uploader",
        name07: "Upload Time",
        name08: "APK File",
        name09: "Only APK files are allowed. Drag and drop files here or",
        name10: "Click to Upload",
        name11: "APK Version Name",
        name12: "Please Enter APK Version Name",
        name13: "APK Description",
        name14: "Please Enter APK Description",
        name15: "APK Version Name cannot be empty!",
        name16: "Edit APK Version Information",
        name17: "Add APK Version Information",
        name18: "APK File Uploaded Successfully!",
        name19: "Confirm deletion of this APK Version information!",
        name20: "Delete APK Version Information",
        name21: "APK Version Information deleted successfully!",
        name22: "Download Address",
        name23: "Please Enter Download Address",
        name24: "APK Type",
        name25: "Please Select APK Type"
    },
    log: {
        name01: "Smart Cabinet Number",
        name02: "Log Name",
        name03: "Server Upload Time",
        name04: "Download Log",
        name05: "Confirm deletion of this log information!",
        name06: "Delete Log Information",
        name07: "Log Information deleted successfully!"
    },
    apply: {
        name01: "Door Opening Request",
        name02: "Disposal Request",
        name03: "Request Approved",
        name04: "Request Rejected",
        name05: "Review Comment",
        name06: "Please Enter Review Comment",
        name07: "Delete Application Information",
        name08: "Confirm deletion of application information!",
        name09: "Application information deleted successfully!",
        name10: "Apply",
        name11: "Apply for Disposal",
        name12: "Confirm applying for the disposal of this reagent!",
        name13: "Application Reason",
        name14: "Please Enter Application Reason!",
        name15: "Valid Count",
        name16: "Please Select Valid Count!"
    },
    materielDoor: {
        name01: "Edit Reagent Designated Storage Information",
        name02: "Reagent Information",
        name03: "Storage Location",
        name04: "Confirm to Store in",
        name05: "Smart Cabinet!",
        name06: "Confirm to Cancel Storage in",
        name07: "Modified Reagent Designated Storage Information successfully!",
        name08: "Please Select Storage Location",
        name09: "Designated Cabinet",
        name10: "Please Select Designated Cabinet",
        name11: "Designated Cabinet Door",
        name12: "Please Select Designated Cabinet Door",
        name13: "Store Immediately"

    },
    inventory: {
        name01: "Inventory Personnel",
        name02: "Inventory Time",
        name03: "Inventory Cabinet",
        name04: "Inventory Cabinet Door",
        name05: "Inventory Loss",
        name06: "Inventory Gain",
        name07: "Details",
        name08: "Please Select Inventory Cabinet",
        name09: "Please Select Inventory Personnel",
        name10: "Sample Name",
        name11: "Chinese Sample Name",
        name12: "CAS Number",
        name13: "Barcode",
        name14: "RFID Number",
        name15: "Quantity",
        name16: "Owner",
        name17: "Location",
        name18: "Short Distance",
        name19: "Registration Date",
        name20: "Location (Current)",
        name21: "Short Distance (Current)",
        name22: "Inventory Type",
        name23: "Reagent Name",
        name24: "Please Select Inventory Type",
        name25: "Inventory Result",
        name26: "Normal",
        name27: "Reagent Quantity"
    },
    receive: {
        name01: 'Agree',
        name02: 'Disagree',
        name03: 'Click for Details',
        name04: 'Add Reagent Application',
        name05: 'Edit Application Information',
        name06: "Cancel Application",
        name07: "Reject Review",
        name08: "Approve Review",
        name09: "Withdraw Application",
        name10: "Review Cancellation"

    },
    largeScreen: {
        name01: "Smart Cabinet Visualization Platform",
        name02: "Enter Backend System",
        name03: "Swipe Left",
        name04: "Swipe Right",
        name05: "Total Smart Cabinets",
        name06: "Total Reagents",
        name07: "Total Personnel",
        name08: "Inventory Data Statistics Chart",
        name09: "Usage Data Statistics Chart",
        name10: "Violation Records",
        name11: "Reagent Categories",
        name12: "Reagent Properties",
        name13: "Withdrawal Records",
        name14: "Operation Records",
        name15: "Sunday",
        name16: "Monday",
        name17: "Tuesday",
        name18: "Wednesday",
        name19: "Thursday",
        name20: "Friday",
        name21: "Saturday",
        name22: "Sunday",
        name23: "Reagent Name",
        name24: "CAS Number",
        name25: "RFID Number",
        name26: "Owner",
        name27: "Net Content",
        name28: "Bottle Weight",
        name29: "Attribute",
        name30: "Category",
        name31: "Status",
        name32: "Purchased",
        name33: "In Cabinet",
        name34: "Borrowed",
        name35: "Disposed",
        name36: "Usage",
        name37: "Inventory",
        name38: 'Purchased'
    },
    attribute: {
        name01: "Please Select Reagent Property",
        name02: "Conflicting Reagents",
        name03: "Please Select Conflicting Reagents",
        name04: "System Default",
        name05: "Confirm deletion of reagent configuration information",
        name06: " Note: Deletion may cause errors in reagent categorization and statistics!",
        name07: "Mutual Exclusion Property",
        name08: "Property Name",
        name09: "Please Enter Property Name",
        name10: "Please Select Mutual Exclusion Property",
        name11: "Property Name cannot be empty!",
        name12: "Edit Reagent Property",
        name13: "Add Reagent Property",
        name14: "Confirm deletion of this reagent property information",
        name15: "Delete Reagent Property Information",
        name16: "Deletion Successful",
        name17: "Set successfully",
        name18: "Edit Successful"
    },
    placeholder: {
        name01: 'Please Enter Content',
        name02: "Please Select",
        name03: 'Please Enter'
    },
    keyBox: {
        name01: "Key Name",
        name02: "Identifier",
        name03: "Status",
        name04: "Open",
        name05: "Discard",
        name06: "Type",
        name07: "Regular Key",
        name08: "Card",
        name09: "Bind Smart Cabinet",
        name10: "Store in Smart Cabinet",
        name11: "Smart Cabinet Door",
        name12: "Key Status",
        name13: "Edit Key Box Information",
        name14: "Add Key Box Information",
        name15: "Is it inside the cabinet",
        name16: "Status Type",
        name17: "Key Type"
    },
    print: {
        name01: 'Printer',
        name02: 'Please Select Printer',
        name03: 'Print Details',
        name04: "Printer Name/IP",
        name05: "Connection Type",
        name06: "Network",
        name07: "Device Type",
        name08: "Zebra RFID Printer",
        name09: "ZMIN RFID Printer",
        name10: "RD Barcode Printer",
        name11: "Print Depth",
        name12: "Print Speed",
        name13: "Port",
        name14: "X-Axis Offset",
        name15: "Y-Axis Offset",
        name16: "Associate with Smart Cabinet",
        name17: "Name",
        name18: "Printer Name",
        name19: "Please Enter Printer Name",
        name20: "Please Select Type",
        name21: "Please Enter Device Type",
        name22: "Please Enter Print Depth",
        name23: "Please Enter Print Speed",
        name24: "IP Address",
        name25: "Please Enter IP Address",
        name26: "Port Number",
        name27: "Please Enter Port Number",
        name28: "Please Enter X-Axis Offset",
        name29: "Please Enter Y-Axis Offset",
        name30: "Select Print Template",
        name31: "Please Select Associated Smart Cabinet",
        name32: "Edit Printer Information",
        name33: "Add Printer Information",
        name34: "Confirm deletion of printer information!",
        name35: "Delete Printer"
    },
    upload: {
        name01: 'Reagent File',
        name02: 'Only upload XLSX files, drag the file here, or',
        name03: 'Click to Upload',
        name04: 'Download Template',
        name05: 'Total Error Messages',
        name06: "items, please modify and re-upload!",
        name07: "Error Reasons",
        name08: "Excel Line Number",
        name09: "Upload Reagents",
        name10: "Reagents Imported Successfully!",
        name11: "Uploaded file must be in XLSX format!",
        name12: "Only upload Excel files, drag the file here, or",
        name13: "Error Messages",
        name14: "Import Successful!",
        name15: "Uploaded file must be in XLSX format",
        name16: "Only upload jpg/png files",
        name17: "Instructions",
        name18: "1. Name the photo with the user's name, e.g., Zhang San",
        name19: "2. If names are duplicated, A unique and non-repetitive identifier needs to be added, e.g., Zhang San_123"

    },
    msds: {
        name01: "CAS Number/Name",
        name02: "Chemical Name (Chinese)",
        name03: "Chemical Name (English)",
        name04: "Safety Data Sheet",
        name05: "Part 1: Chemical Name",
        name06: "Chinese Name of the Chemical:",
        name07: "Common Name of the Chemical:",
        name08: "English Name of the Chemical:",
        name09: "English Name:",
        name10: "Technical Data Sheet Code:",
        name11: "Manufacturer Name:",
        name12: "Address:",
        name13: "Effective Date:",
        name14: "Part 2: Hazard Overview",
        name15: " Hazard Category:",
        name16: "Route of Entry:",
        name17: "Health Hazard:",
        name18: "Environmental Hazard:",
        name19: "Explosive Hazard:",
        name20: "Part 3: Composition/Information on Ingredients",
        name21: "Hazardous Component",
        name22: "Content",
        name23: "Part 4: First Aid Measures",
        name24: "Skin Contact:",
        name25: "Eye Contact:",
        name26: "Inhalation:",
        name27: "Ingestion:",
        name28: "Part 5: Firefighting Measures",
        name29: "Hazard Characteristics:",
        name30: " Hazardous Combustion Products:",
        name31: "Extinguishing Methods:",
        name32: "Part 6: Leak Emergency Handling",
        name33: "Emergency Handling:",
        name34: "Part 7: Operation, Disposal, and Storage",
        name35: " Operation Cautions:",
        name36: "Storage Cautions:",
        name37: "Part 8: Exposure Control/Personal Protection",
        name38: " China MAC (mg/m3):",
        name39: "Former Soviet Union MAC (mg/m3):",
        name40: "Monitoring Method:",
        name41: "Engineering Controls:",
        name42: "Respiratory Protection:",
        name43: "Eye Protection:",
        name44: "Body Protection:",
        name45: "Hand Protection:",
        name46: "Other Protections:",
        name47: "Part 9: Physical and Chemical Properties",
        name48: 'Appearance and Character:',
        name49: "Melting Point (℃):",
        name50: "Relative Density (water=1):",
        name51: "Boiling Point (℃):",
        name52: "Relative Vapor Density (air=1):",
        name53: "Molecular Formula:",
        name54: "Molecular Weight:",
        name55: "Main Components:",
        name56: "Saturated Vapor Pressure (kPa):",
        name57: "Combustion Heat (kJ/mol):",
        name58: "Critical Temperature (℃):",
        name59: "Critical Pressure (MPa):",
        name60: "Logarithm of Octanol/Water Partition Coefficient:",
        name61: "Flash Point (℃):",
        name62: "Explosion Upper Limit %(V/V):",
        name63: "Ignition Temperature (℃):",
        name64: "Explosion Lower Limit %(V/V):",
        name65: "Solubility:",
        name66: "Main Uses:",
        name67: "Other Physical and Chemical Properties:",
        name68: "Part 10: Stability and Reactivity",
        name69: "Stability:",
        name70: "Incompatible Materials:",
        name71: "Conditions to Avoid:",
        name72: "Hazardous Polymerization:",
        name73: "Decomposition Products:",
        name74: "Part 11: Toxicological Information",
        name75: "Acute Toxicity:",
        name76: "Subacute and Chronic Toxicity:",
        name77: "Irritation:",
        name78: "Sensitization:",
        name79: "Mutagenicity:",
        name80: "Teratogenicity:",
        name81: "Carcinogenicity:",
        name82: "Part 12: Ecological Information",
        name83: "Ecotoxicity:",
        name84: " Biodegradability:",
        name85: " Non-biodegradability:",
        name86: " Bioaccumulative Potential:",
        name87: " Other Harmful Effects:",
        name88: "Part 13: Disposal Considerations",
        name89: "Waste Characteristics:",
        name90: " Disposal Methods:",
        name91: " Waste Handling Precautions:",
        name92: "Part 14: Transportation Information",
        name93: "Hazardous Goods Number:",
        name94: "UN Number:",
        name95: "Packaging Markings:",
        name96: "Packaging Category:",
        name97: "Packaging Methods:",
        name98: " Transport Handling Precautions:",
        name99: "Part 15: Regulatory Information",
        name100: "Regulatory Information:",
        name101: "Part 16: Other Information",
        name102: "References:",
        name103: "Filling Department:",
        name104: "Data Review Unit:",
        name105: "Modification Description:",
        name106: "Other Information:",
        name107: "MSDS not found",
        name108: "Confirm deletion of this MSDS information!",
        name109: "Delete MSDS information",
        name110: 'Deletion successful'
    },
    purchaseOrder: {
        name01: "Storage Status",
        name02: "Purchase Order Number",
        name03: "Store by Selected Purchase Order",
        name04: "Export by Selected Purchase Order",
        name05: "Print by Selected Purchase Order",
        name06: "Batch Export",
        name07: "Batch Print",
        name08: "Purchase Order Number",
        name09: "Initiation Time",
        name10: "In Approval",
        name11: "Approval Failed",
        name12: "Approval Successful",
        name13: "Cancel Approval",
        name14: "Initiator",
        name15: "Initiator Contact Information",
        name16: "Purchase Order Contact Information",
        name17: "Purchase Details",
        name18: "Research Group",
        name19: "Project Admission Number",
        name20: "Not In Storage",
        name21: "In Storage",
        name22: "Approval Status",
        name23: "Storage Cancellation",
        name24: "Storage Successful"
    },
    video: {
        name01: "End Time of Recording",
        name02: "Start Time of Recording",
        name03: "Total Duration",
        name04: "Play Video",
        name05: "Video List"
    },
    approval: {
        name01: "Reagent Addition",
        name02: "Reagent Usage",
        name03: "Reagent Withdrawal",
        name04: "Purchase Request",
        name05: "Project Admission Request",
        name06: "Code Supplement Request",
        name07: "Configuration Type",
        name08: "Global Configuration",
        name09: "Category Configuration",
        name10: "Configuration Name",
        name11: "Approval Steps",
        name12: "Approver",
        name13: "Personnel Approval:",
        name14: "Reagent Responsible Person Approval",
        name15: "Lab Administrator Approval",
        name16: "Role Approval:",
        name17: "Designate Reagents",
        name18: "Cabinet Responsible Person Approval",
        name19: "Approval Steps",
        name20: "Confirm Deletion of Approval Flow Information",
        name21: "Step",
        name22: "Click to Select Reagents",
        name23: "Only Local",
        name24: "Edit Approval Flow",
        name25: "Add Approval Flow",
        name26: "Designate Personnel",
        name27: "Designate Role",
        name28: "Lab Administrator",
        name29: "Cabinet Responsible Person",
        name30: "Pending Approval",
        name31: "Approval Records",
        name32: "Approval Details",
        name33: "Reagent Configuration Details",
        name34: "Application Records",
        name35: "Add Code Supplement Request",
        name36: "Edit Code Supplement Request",
        name37: "Please Enter Code Supplement Reason",
        name38: "Code Supplement Reason",
        name39: "Opcode",
        name40: "Approval details",
        name41: "Applied for",
        name42: "Approval results",
        name43: "Application has been issued",
        name44: "To be notified",
        name45: "Agreed",
        name46: "Refused",
        name47: "revoke",
        name48: "entry name",
        name49: "project",
        name50: "undergraduate teaching",
        name51: "Graduate teaching",
        name52: "Innovation projects",
        name53: "Research projects",
        name54: "Experimental project admission number",
        name55: "Edit project admission application",
        name56: "Add project admission application",
        name57: "withdraw",
        name58: "Reagent details",
        name59: "Chinese name of reagent",
        name60: "Reagent CAS number",
        name61: "record",
        name62: "Experimental location",
        name63: "Test date",
        name64: "Approval time",
        name65: "Chemical usage team",
        name66: "Purchasing reagents",
        name67: "Procurement details",
        name68: "Admission of experimental projects",
        name69: "Purchasing contact phone number",
        name70: "Cost number",
        name71: "Storage location cabinet",
        name72: "Specification value",
        name73: "Add purchase request",
        name74: "Application approval",
        name75: "List of reagents displayed only in the cabinet",
        name76: "Add Laboratory",
        name77: "Editing laboratory",
        name78: "applying",
        name79: "Specification value",
        name80: "unit"
    },
    supplier: {
        name01: "Supplier Bank Account",
        name02: "Supplier Bank Name",
        name03: "Supplier Contact Person's ID Card",
        name04: "In-house Contact Person's ID Card",
        name05: "In-house Contact Person",
        name06: "In-house Contact \nPerson's Phone",
        name07: "License Type",
        name08: "License Number",
        name09: "License Start Date",
        name10: "License End Date",
        name11: "Attachment",
        name12: "Supplier Name",
        name13: "Supplier Address",
        name14: "Supplier Contact Person's Name",
        name15: "Supplier Contact Person's Phone",
        name16: "Confirmed",
        name17: "Confirm Deletion of This Reagent Property Information!",
        name18: "Chemical Name",
        name19: 'supplier',
        name20: "Supplier to be confirmed",
        name21: "Hazardous Chemicals Business License",
        name22: "Supplier Details",
        name23: "To be determined",
        name24: "Attachment Type",
        name25: "Please select attachment type",
        name26: "Details of Hazardous Chemicals",
        name27: "Business License",
        name28: "Supplier contact person cannot be empty!",
        name29: "Supplier name cannot be empty！",
        name30: "Supplier Confirmation",
        name31: "Supplier's Reagent Details"
    },
    permission: {
        name01: "Menu Name",
        name02: "Request Method",
        name03: "Request Interface",
        name04: "Validation Method",
        name05: "Creation Time",
        name06: "Modification Time",
        name07: "Icon",
        name08: "Code",
        name09: "Component Path"
    },
    localSetting: {
        name01: "Specific Location",
        name02: "Select Superior",
        name03: "Please enter specific location",
        name04: "Select Type",
        name05: "Add Place",
        name06: "Editing Place"
    },
    confirm: {
        name01: "This operation will revoke the application. Do you want to continue?",
        name02: "Do you need to continue applying?",
        name03: "Do you need to continue entering?",
        name04: "Return this purchase order, do you want to continue?",
        name05: "Canceled Exit",
        name06: "Are you sure to select the purchase order for warehousing?",
        name07: "Please fill in the details of hazardous chemicals",
        name08: "Reason cannot be empty when rejecting approval",
        name09: "Product name cannot be empty"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (zh);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);




var app = {
  state: {
    sidebar: {
      opened: !+__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('sidebarStatus')
    },
    theme: 'default',
    livenewsChannels: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('livenewsChannels') || '[]',
    visitedViews: []
  },
  mutations: {
    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
      if (state.sidebar.opened) {
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('sidebarStatus', 1);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    },
    ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
      if (state.visitedViews.some(function (v) {
        return v.path === view.path;
      })) return;
      state.visitedViews.push({ name: view.name, path: view.path });
    },
    DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
      var index = void 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var i = _ref2[0];
          var v = _ref2[1];

          if (v.path === view.path) {
            index = i;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.visitedViews.splice(index, 1);
    }
  },
  actions: {
    ToggleSideBar: function ToggleSideBar(_ref3) {
      var commit = _ref3.commit;

      commit('TOGGLE_SIDEBAR');
    },
    addVisitedViews: function addVisitedViews(_ref4, view) {
      var commit = _ref4.commit;

      commit('ADD_VISITED_VIEWS', view);
    },
    delVisitedViews: function delVisitedViews(_ref5, view) {
      var commit = _ref5.commit;

      commit('DEL_VISITED_VIEWS', view);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_login__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_index__ = __webpack_require__(238);




var user = {
    state: {
        token: Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["a" /* getToken */])(),
        phone: '',
        username: "",
        id: '',
        name: '',
        avatar: '',
        roles: [],
        companyType: '',
        company: '',
        departments: [],
        info: {}
    },

    mutations: {
        SET_INFO: function SET_INFO(state, info) {
            state.info = info;
        },
        SET_TOKEN: function SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_NAME: function SET_NAME(state, name) {
            state.name = name;
        },
        SET_USERNAME: function SET_USERNAME(state, userName) {
            state.userName = userName;
        },
        SET_USERID: function SET_USERID(state, id) {
            state.id = id;
        },
        SET_AVATAR: function SET_AVATAR(state, avatar) {
            state.avatar = avatar;
        },
        SET_ROLES: function SET_ROLES(state, roles) {
            state.roles = roles;
        },
        SET_COMPANY: function SET_COMPANY(state, companyType) {
            state.companyType = companyType;
        },
        SET_COMPANYNAME: function SET_COMPANYNAME(state, company) {
            state.company = company;
        },
        SET_DEPARTMENTS: function SET_DEPARTMENTS(state, departments) {
            state.departments = departments;
        }
    },

    actions: {
        // 登录
        Login: function Login(_ref, userInfo) {
            var commit = _ref.commit;

            console.log(userInfo, "90");
            var userName = userInfo.userName.trim();
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                Object(__WEBPACK_IMPORTED_MODULE_1__api_login__["h" /* unifyLogin */])(userName, userInfo.password, userInfo.captcha, userInfo.captchaUUID).then(function (response) {
                    var data = response.data;
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* setToken */])(data);
                    commit('SET_TOKEN', data);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },


        // 获取用户信息
        GetInfo: function GetInfo(_ref2) {
            var commit = _ref2.commit,
                state = _ref2.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                Object(__WEBPACK_IMPORTED_MODULE_1__api_login__["c" /* getInfo */])(state.token).then(function (response) {
                    var data = response.data;
                    var role = data.role;
                    data.role = [];
                    // switch(role.roleLeave)
                    // {
                    //   case 1:
                    //     data.role.push("super");
                    //   case 2:
                    //     data.role.push('admin');
                    //   default :
                    //     data.role.push('user');
                    // }
                    if (null == role || null == role.roleCode) {
                        data.role.push("user");
                    } else {
                        data.role.push(role.roleCode);
                    }

                    // if (data.admin) {
                    //   data.role = ['admin'];
                    // } else {
                    //   data.role = ['edit'];
                    // }
                    commit('SET_INFO', data);
                    commit('SET_ROLES', data.role);
                    commit('SET_NAME', data.name);
                    commit('SET_USERNAME', data.userName);
                    commit('SET_USERID', data.id);
                    //  commit('SET_AVATAR', data.avatar);
                    commit('SET_COMPANY', data.company.id);
                    commit('SET_COMPANYNAME', data.company.name);
                    commit('SET_DEPARTMENTS', data.departments);
                    if (data.company.type == 1) {
                        commit('deptOrCollegeName', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('user.name12'));
                        commit('deptOrCollegeTip', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('user.name13'));
                        commit('deptOrCollegeNo', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('department.name10'));
                        commit('deptOrCollegeNoTip', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('department.name11'));
                        commit('deptOrCollege', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('department.name12'));
                    } else {
                        commit('deptOrCollegeName', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('department.name13'));
                        commit('deptOrCollegeTip', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('department.name14'));
                        commit('deptOrCollegeNo', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('department.name15'));
                        commit('deptOrCollegeNoTip', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('department.name16'));
                        commit('deptOrCollege', __WEBPACK_IMPORTED_MODULE_3__i18n_index__["a" /* default */].t('department.name17'));
                    }

                    resolve(response);
                }).catch(function (error) {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* removeToken */])();
                    reject(error);
                });
            });
        },


        // 登出
        LogOut: function LogOut(_ref3) {
            var commit = _ref3.commit,
                state = _ref3.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                Object(__WEBPACK_IMPORTED_MODULE_1__api_login__["e" /* logout */])(state.token).then(function () {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* removeToken */])();
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },


        // 前端 登出
        FedLogOut: function FedLogOut(_ref4) {
            var commit = _ref4.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                commit('SET_TOKEN', '');
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* removeToken */])();
                resolve();
            });
        },

        // 获取新token
        refreshToken: function refreshToken(_ref5, userInfo) {
            var commit = _ref5.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                Object(__WEBPACK_IMPORTED_MODULE_1__api_login__["g" /* refreshToken */])().then(function (response) {
                    console.log(response.data, "获取新token");
                    var data = response.data;
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* setToken */])(data);
                    commit('SET_TOKEN', data);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        startTokenRefresh: function startTokenRefresh(_ref6) {
            var dispatch = _ref6.dispatch;

            setInterval(function () {
                dispatch('refreshToken').catch(function (error) {
                    console.error('Failed to refresh token:', error);
                    // 可能需要处理token刷新失败的情况，比如清除token并让用户重新登录
                });
            }, 3600000); // 3600000毫秒 = 1小时
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generaMenu */
/* unused harmony export filterAsyncRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_index__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_index__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_permission__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_auth__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_layout_Layout__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_layout_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_layout_Layout__);











/* layout */

// const _import = require('./_import_' +  process.env.NODE_ENV);
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.role) {
    return roles.some(function (role) {
      return route.meta.role.indexOf(role) >= 0;
    });
  } else {
    return true;
  }
}

/**
 * 后台查询的菜单数据拼装成路由格式的数据
 * @param routes (resolve: any) => require([`@/views/${view}.vue`], resolve)
 */
function generaMenu(routes, data) {
  data.forEach(function (item) {
    // 这里的字段在实际业务开发中都有用的，当然如果只是简单学习的话，id，label可以移除
    var menu = {
      id: item.id,
      label: item.label,
      name: item.name,
      path: item.path,
      component: item.component == 'Layout' ? __WEBPACK_IMPORTED_MODULE_9__views_layout_Layout___default.a : function (resolve) {
        return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1403)("./" + item.component)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      redirect: item.redirect,
      hidden: !item.isShow,
      alwaysShow: item.alwaysShow,
      meta: item.meta,
      icon: item.icon,
      children: [],
      noDropdown: !item.isDropDown
      // hidden:false,
    };
    if (item.children) {
      generaMenu(menu.children, item.children);
    }
    routes.push(menu);
  });
}
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes, roles) {
  var res = [];

  routes.forEach(function (route) {
    var tmp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, route);
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}

var permission = {
  state: {
    routers: __WEBPACK_IMPORTED_MODULE_6__router_index__["b" /* constantRouterMap */],
    addRouters: [],
    functionCodeList: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = __WEBPACK_IMPORTED_MODULE_6__router_index__["b" /* constantRouterMap */].concat(routers);
    },
    SET_FUCNTIONCODES: function SET_FUCNTIONCODES(state, functionCodes) {
      state.functionCodeList = functionCodes;
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, roles) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var loadMenuData = [];
        Object(__WEBPACK_IMPORTED_MODULE_7__api_permission__["g" /* permissionGroupgetRouters */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils_auth__["a" /* getToken */])()).then(function (response) {
          var data = response;
          // if (response.data != []) {
          //   throw new Error('菜单数据加载异常')
          // }
          // else {
          data = response.data.routers;
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(loadMenuData, data);
          var tempAsyncRoutes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], __WEBPACK_IMPORTED_MODULE_6__router_index__["a" /* asyncRouterMap */]);
          // tempAsyncRoutes = asyncRoutes
          generaMenu(tempAsyncRoutes, loadMenuData);
          var accessedRoutes = void 0;
          // if (roles.includes('super') >= 0) {
          //   accessedRoutes = tempAsyncRoutes || []
          // } else {
          accessedRoutes = filterAsyncRoutes(tempAsyncRoutes, roles);
          //  }
          commit('SET_ROUTERS', accessedRoutes);
          commit('SET_FUCNTIONCODES', response.data.functionCodes);
          resolve(accessedRoutes);
          //  }
        }).catch(function (error) {
          console.log(error);
        });
        //   let accessedRouters
        //   if (roles.indexOf('super') >= 0) {
        //     accessedRouters = asyncRouterMap
        //   } else {
        //     accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        //   }
        //   commit('SET_ROUTERS', accessedRouters);
        //   resolve();
      });
    }
  }
};
console.log(permission, "quanxaun");
/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout__ = __webpack_require__(410);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__views_layout__["Navbar"],
    Sidebar: __WEBPACK_IMPORTED_MODULE_0__views_layout__["Sidebar"],
    AppMain: __WEBPACK_IMPORTED_MODULE_0__views_layout__["AppMain"],
    Header1: __WEBPACK_IMPORTED_MODULE_0__views_layout__["Header1"]
  },
  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabsView__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TabsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Levelbar__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Levelbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hamburger__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hamburger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Hamburger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_changePassword__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_changePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_changePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_imgs_user_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_imgs_user_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_imgs_user_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_imgs_logout_png__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_imgs_logout_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_imgs_logout_png__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Levelbar: __WEBPACK_IMPORTED_MODULE_3__Levelbar___default.a,
        Hamburger: __WEBPACK_IMPORTED_MODULE_4__components_Hamburger___default.a,
        TabsView: __WEBPACK_IMPORTED_MODULE_2__TabsView___default.a,
        changePasswordDialog: __WEBPACK_IMPORTED_MODULE_5__components_changePassword___default.a
    },
    data: function data() {
        return {
            img_user: __WEBPACK_IMPORTED_MODULE_6__assets_imgs_user_png___default.a,
            img_logout: __WEBPACK_IMPORTED_MODULE_7__assets_imgs_logout_png___default.a,
            dialogChangePasswordFormVisible: false,
            must: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["sidebar", "name", "username", "avatar"])),
    methods: {
        handleCommand: function handleCommand(command) {
            switch (command) {
                case "changePassword":
                    this.showDialog();
                    break;
                case "logout":
                    this.logout();
                    break;
            }
        },
        showDialog: function showDialog() {
            this.must = false;
            this.dialogChangePasswordFormVisible = true;
        },
        toggleSideBar: function toggleSideBar() {
            this.$store.dispatch("ToggleSideBar");
            // location.reload();
        },
        logout: function logout() {
            this.$store.dispatch("LogOut").then(function () {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
        }
    }
});

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    visitedViews: function visitedViews() {
      return this.$store.state.app.visitedViews.slice(-6);
    }
  },
  methods: {
    closeViewTabs: function closeViewTabs(view, $event) {
      this.$store.dispatch('delVisitedViews', view);
      $event.preventDefault();
    },
    generateRoute: function generateRoute() {
      if (this.$route.matched[this.$route.matched.length - 1].name) {
        return this.$route.matched[this.$route.matched.length - 1];
      }
      this.$route.matched[0].path = '/';
      return this.$route.matched[0];
    },
    addViewTabs: function addViewTabs() {
      this.$store.dispatch('addVisitedViews', this.generateRoute());
    },
    isActive: function isActive(path) {
      return path === this.$route.path;
    }
  },
  watch: {
    $route: function $route() {
      this.addViewTabs();
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-view-container"
  }, _vm._l((Array.from(_vm.visitedViews)), function(tag) {
    return _c('router-link', {
      key: tag.path,
      staticClass: "tabs-view",
      attrs: {
        "to": tag.path
      }
    }, [_c('el-tag', {
      attrs: {
        "closable": true,
        "type": _vm.isActive(tag.path) ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          return _vm.closeViewTabs(tag, $event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")])], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    created: function created() {
        this.getBreadcrumb();
    },
    data: function data() {
        return {
            levelList: null
        };
    },

    methods: {
        getBreadcrumb: function getBreadcrumb() {
            var matched = this.$route.matched.filter(function (item) {
                return item.name;
            });
            var first = matched[0];
            if (first && (first.name !== '首页' || first.path !== '')) {
                matched = [{ name: '首页', path: '/' }].concat(matched);
            }
            this.levelList = matched;
        }
    },
    watch: {
        $route: function $route() {
            this.getBreadcrumb();
        }
    }
});

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [(item.redirect === "noredirect" || index == _vm.levelList.length - 1) ? _c('span', {
      staticClass: "no-redirect"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]) : _c('router-link', {
      attrs: {
        "to": item.redirect || item.path
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))])], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
});

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    staticClass: "svg-icon hamburger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "t": "1492500959545",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1691",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "64",
      "height": "64"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('path', {
    attrs: {
      "d": "M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z",
      "p-id": "1692"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z",
      "p-id": "1693"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z",
      "p-id": "1694"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_login__ = __webpack_require__(226);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'changePasswordDialog',
  props: ['isshow', 'must'],
  data: function data() {
    var _this = this;

    var validateOldPassword = function validateOldPassword(rule, value, callback) {
      if (value.trim().length === 0) {
        callback(new Error('The original password cannot be empty'));
      } else {
        callback();
      }
    };
    var validateNewPassword = function validateNewPassword(rule, value, callback) {
      if (value.trim().length === 0) {
        callback(new Error('The new password cannot be empty'));
      } else if (value.trim().length < 6) {
        callback(new Error('The password length cannot be less than 6 bits'));
      } else {
        callback();
      }
    };
    var validateConfirmPassword = function validateConfirmPassword(rule, value, callback) {
      if (value.trim().length === 0) {
        callback(new Error('Confirm that the password cannot be empty'));
      } else if (value !== _this.changePasswordForm.newPassword) {
        callback(new Error('Two passwords are inconsistent'));
      } else {
        callback();
      }
    };
    return {
      changePasswordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      loading: false,
      dialogFormVisible: false,
      changePasswordRules: {
        oldPassword: [{ required: true, trigger: 'blur', validator: validateOldPassword }],
        newPassword: [{ required: true, trigger: 'blur', validator: validateNewPassword }],
        confirmPassword: [{ required: true, trigger: 'blur', validator: validateConfirmPassword }]
      }
    };
  },

  computed: {},
  watch: {
    isshow: function isshow(val) {
      this.dialogFormVisible = val; // 新增result的watch，监听变更并同步到myResult上
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    },
    updatePassword: function updatePassword() {
      var _this2 = this;

      this.$refs.changePasswordForm.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          Object(__WEBPACK_IMPORTED_MODULE_0__api_login__["b" /* changePassword */])(_this2.changePasswordForm).then(function () {
            _this2.$message({
              type: 'success',
              message: 'Change password successfully !'
            });
            _this2.loading = false;
            _this2.dialogFormVisible = false;
          }).catch(function () {
            _this2.loading = false;
          });
        } else {
          return false;
        }
      });
    },

    //强制退出
    cancel: function cancel() {
      if (this.must === true) {
        //强制修改密码  点击取消直接退出登陆
        this.dialogFormVisible = false;
        this.$store.dispatch("LogOut").then(function () {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      } else {
        this.dialogFormVisible = false;
      }
    }
  }

});

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('login.name8'),
      "visible": _vm.dialogFormVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    ref: "changePasswordForm",
    attrs: {
      "model": _vm.changePasswordForm,
      "rules": _vm.changePasswordRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('login.name10') + '：',
      "prop": "oldPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.$t('placeholder.name03') + _vm.$t('login.name10')
    },
    model: {
      value: (_vm.changePasswordForm.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.changePasswordForm, "oldPassword", $$v)
      },
      expression: "changePasswordForm.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('login.name11') + '：',
      "prop": "newPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.$t('placeholder.name03') + _vm.$t('login.name11')
    },
    model: {
      value: (_vm.changePasswordForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.changePasswordForm, "newPassword", $$v)
      },
      expression: "changePasswordForm.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('login.name12') + '：',
      "prop": "confirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.$t('placeholder.name03') + _vm.$t('login.name12')
    },
    model: {
      value: (_vm.changePasswordForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.changePasswordForm, "confirmPassword", $$v)
      },
      expression: "changePasswordForm.confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('main.name07')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v(_vm._s(_vm.$t('main.name08')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAABI1BMVEWWrrz///+WrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrryWrrycHdqqAAAAYHRSTlMAAMrCPyNwb+1sHwhRUsPxbgq5v8eVFVmRyddT4ykxhBSvy4f4mYqyAeCJKPJqPLMFsMbRaJi6u4P03Sb1K1oLt8/+GZt0HBOMkHhMcuhN1ZQHL9P3qOah5EE9qvDztUja7GuiAAAA6UlEQVR4Xm3Q5VLGQAyF4ROof664u7u7u7uf+78Kym4Lpe3795lJMkGQ19VKv/aFTtFpqPeQvc2WPVghWzr+oI20MtA1FWiHUOTUNMJEBpjVkGUNiIAYpoISy4hCEFAmUqGbVgxKQ5M/0EfEINPPMR8e5+IgwyM0BRxNgEh13AMnFLj5fONvM7N0wHkFxYZIi0ssgMspoyorJpxqEla5Jqglz13nhgg8bsZga9tQL9nZTX8J9rifDnB58B8OjzTgmCdROOVZADjnxWUIxhWvb0LA7R3vH+xczn1y+PyidwS9vr3T7+PzS3Tfo7IjWEiLjcQAAAAASUVORK5CYII="

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "isActive": _vm.sidebar.opened,
      "toggleClick": _vm.toggleSideBar
    }
  }), _vm._v(" "), _c('levelbar'), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('img', {
    staticClass: "user-avatar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": _vm.img_user
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.name || _vm.username))])]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "changePassword"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('login.name8')))])]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "logout",
      "divided": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('login.name9')))])])], 1)], 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container-logout",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.logout
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('div', {
    staticClass: "exit",
    on: {
      "click": _vm.logout
    }
  }, [_c('icon-svg', {
    attrs: {
      "icon-class": "tuichu"
    }
  })], 1)]), _vm._v(" "), _c('el-dropdown-menu', [_c('el-dropdown-item')], 1)], 1)], 1), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "must": _vm.must,
      "isshow": _vm.dialogChangePasswordFormVisible
    },
    on: {
      "close": function($event) {
        _vm.dialogChangePasswordFormVisible = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SidebarItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_imgs_logo_index_png__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_imgs_logo_index_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_imgs_logo_index_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_company__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import logo from '@/assets/imgs/jl_logo_small.png'



/* harmony default export */ __webpack_exports__["default"] = ({
    components: { SidebarItem: __WEBPACK_IMPORTED_MODULE_2__SidebarItem___default.a },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['permission_routers', 'sidebar']), {
        isCollapse: function isCollapse() {
            return !this.sidebar.opened;
        }
    }),
    data: function data() {
        return {
            logo: __WEBPACK_IMPORTED_MODULE_3__assets_imgs_logo_index_png___default.a,
            loginlogo: {},
            configure: false
        };
    },
    created: function created() {
        this.getCompanyWithKey();
    },

    methods: {
        getCompanyWithKey: function getCompanyWithKey() {
            var _this = this;

            var token = Object(__WEBPACK_IMPORTED_MODULE_5__utils_auth__["a" /* getToken */])();
            Object(__WEBPACK_IMPORTED_MODULE_4__api_company__["k" /* getCompanyWithKey */])({ token: token }).then(function (response) {
                response.data.forEach(function (element) {
                    if (element.configureKey === 'mainLogoPath') {
                        _this.loginlogo = element;
                    }
                });
                if (_this.checkConfigureValue(_this.loginlogo) === true) {
                    _this.configure = true;
                } else {
                    _this.configure = false;
                }
                console.log(_this.loginlogo.configureValue, _this.configure, _this.loginlogo, "logo");
            }).catch(function () {
                _this.configure = false;
            });
        },
        checkConfigureValue: function checkConfigureValue(obj) {
            // 检查对象是否有 configureValue 属性
            if (obj && obj.hasOwnProperty('configureValue')) {
                // 获取 configureValue 的值
                var value = obj.configureValue;

                // 检查 configureValue 是否为空
                if (value === null || value === undefined || value === '') {
                    return false; // 是空
                } else {
                    return true; // 不是空
                }
            }

            return false; // 对象不存在 configureValue 属性
        }
    }
});

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SidebarItem',
    props: {
        routes: {
            type: Array
        }
    }
});

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrapper"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0 && item.path !== '/dataBoard') ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      staticClass: "submenu-title-noDropdown",
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.children[0].name)))])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.hidden && item.noDropdown && item.children.length > 0 && item.path === '/dataBoard') ? _c('router-link', {
      attrs: {
        "to": '/largeScreen'
      }
    }, [_c('el-menu-item', {
      staticClass: "submenu-title-noDropdown",
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.children[0].name)))])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [(!item.icon.includes('el-icon')) ? _c('template', {
      slot: "title"
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.name)))])], 1) : _vm._e(), _vm._v(" "), (item.icon.includes('el-icon')) ? _c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "icon-I",
      class: item.icon
    }), _c('span', [_vm._v(_vm._s(_vm.$t(item.name)))])]) : _vm._e(), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "nest-menu",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(child.icon) ? _c('icon-svg', {
        attrs: {
          "icon-class": child.icon
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(child.name)))])], 1)], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-index.f6f73de.png";

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "logo-container"
  }, [(_vm.configure === true) ? _c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.loginlogo.configureValue
    }
  }) : _c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _c('el-menu', {
    staticClass: "menu-yx",
    attrs: {
      "collapse": _vm.isCollapse,
      "default-active": _vm.$route.path,
      "mode": "vertical",
      "theme": "dark",
      "unique-opened": ""
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.permission_routers
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppMain',
  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabsView__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TabsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Levelbar__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Levelbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hamburger__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hamburger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Hamburger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_changePassword__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_changePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_changePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_imgs_user_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_imgs_user_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_imgs_user_png__);

//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_3__Levelbar___default.a,
    Hamburger: __WEBPACK_IMPORTED_MODULE_4__components_Hamburger___default.a,
    TabsView: __WEBPACK_IMPORTED_MODULE_2__TabsView___default.a,
    changePasswordDialog: __WEBPACK_IMPORTED_MODULE_5__components_changePassword___default.a
  },
  data: function data() {
    return {
      img_user: __WEBPACK_IMPORTED_MODULE_6__assets_imgs_user_png___default.a,
      dialogChangePasswordFormVisible: false

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sidebar', 'name', 'username', 'avatar'])),
  methods: {
    handleCommand: function handleCommand(command) {
      switch (command) {
        case 'changePassword':
          this.showDialog();
          break;
        case 'logout':
          this.logout();
          break;
      }
    },
    showDialog: function showDialog() {
      this.dialogChangePasswordFormVisible = true;
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
    },
    test: function test() {
      alert(123);
    },
    logout: function logout() {
      this.$store.dispatch('LogOut').then(function () {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm._v("Hazardous Chemicals Management System")])])])
}]}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.sidebar.opened
    }
  }, [_c('div', [_c('sidebar', {
    staticClass: "sidebar-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('navbar'), _vm._v(" "), _c('app-main')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon-svg',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  companyType: function companyType(state) {
    return state.user.companyType;
  },
  permission_routers: function permission_routers(state) {
    return state.permission.routers;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cilentType = {
    state: {
        deptName: "部门",
        deptNameTip: "请选择部门",
        deptUserNo: "工号",
        deptUserNoTip: "请输入工号",
        dept: "部门信息"
        // collegeName: "学院",
        // collegeNameTip: "请选择学院",
        // collegeUserNo: "学号",

    },
    mutations: {
        deptOrCollegeName: function deptOrCollegeName(state, deptName) {
            state.deptName = deptName;
        },
        deptOrCollegeTip: function deptOrCollegeTip(state, deptNameTip) {
            state.deptNameTip = deptNameTip;
        },
        deptOrCollegeNo: function deptOrCollegeNo(state, deptUserNo) {
            state.deptUserNo = deptUserNo;
        },
        deptOrCollegeNoTip: function deptOrCollegeNoTip(state, deptUserNoTip) {
            state.deptUserNoTip = deptUserNoTip;
        },
        deptOrCollege: function deptOrCollege(state, dept) {
            state.dept = dept;
        }
    }

};
/* harmony default export */ __webpack_exports__["a"] = (cilentType);

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (file) {
  return function () {
    return __webpack_require__(882)("./" + file + '.vue');
  };
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": [
		1359,
		174
	],
	"./abnormal/handleDialog.vue": [
		1155,
		297
	],
	"./abnormal/index.vue": [
		1298,
		110
	],
	"./abnormalTag/edit.vue": [
		1156,
		296
	],
	"./abnormalTag/index.vue": [
		1299,
		131
	],
	"./abnormalTag/remove.vue": [
		1157,
		295
	],
	"./alarm/handleDialog.vue": [
		1158,
		294
	],
	"./alarm/index.vue": [
		1300,
		59
	],
	"./alarm/remove.vue": [
		1107,
		293
	],
	"./apk/edit.vue": [
		1159,
		223
	],
	"./apk/index.vue": [
		1301,
		95
	],
	"./apk/remove.vue": [
		1160,
		292
	],
	"./appRecord/aproveIndex.vue": [
		1360,
		73
	],
	"./appRecord/canel.vue": [
		1162,
		291
	],
	"./appRecord/remove.vue": [
		1161,
		222
	],
	"./apply/check.vue": [
		1361,
		45
	],
	"./apply/index.vue": [
		1302,
		44
	],
	"./apply/logoff.vue": [
		1164,
		147
	],
	"./apply/logoffCheck.vue": [
		1166,
		119
	],
	"./apply/logoffCheckEdit.vue": [
		1128,
		290
	],
	"./apply/logoffCheckRemove.vue": [
		1129,
		289
	],
	"./apply/logoffEdit.vue": [
		1125,
		288
	],
	"./apply/open.vue": [
		1163,
		98
	],
	"./apply/openCheck.vue": [
		1165,
		118
	],
	"./apply/openCheckEdit.vue": [
		1126,
		287
	],
	"./apply/openCheckRemove.vue": [
		1127,
		286
	],
	"./apply/openEdit.vue": [
		1123,
		204
	],
	"./apply/openRemove.vue": [
		1124,
		285
	],
	"./approvalProcess/complement.vue": [
		1172,
		36
	],
	"./approvalProcess/edit.vue": [
		1094,
		66
	],
	"./approvalProcess/index.vue": [
		1303,
		6
	],
	"./approvalProcess/materSearch.vue": [
		1096,
		203
	],
	"./approvalProcess/materielAdd.vue": [
		1167,
		35
	],
	"./approvalProcess/materielCollect.vue": [
		1169,
		26
	],
	"./approvalProcess/materielsiWthdraw.vue": [
		1168,
		34
	],
	"./approvalProcess/projectAdmiss.vue": [
		1171,
		33
	],
	"./approvalProcess/purchasingRequisiton.vue": [
		1170,
		32
	],
	"./approvalProcess/remove.vue": [
		1095,
		284
	],
	"./approvalReviewAdd/approvalP.vue": [
		1173,
		62
	],
	"./approvalReviewAdd/edit.vue": [
		1130,
		130
	],
	"./approvalReviewAdd/index.vue": [
		1304,
		14
	],
	"./approvalReviewAdd/requestedR.vue": [
		1174,
		22
	],
	"./approvalReviewAdd/results.vue": [
		1108,
		283
	],
	"./approvalReviewAdd/steps.vue": [
		1131,
		221
	],
	"./attribute/edit.vue": [
		1175,
		282
	],
	"./attribute/index.vue": [
		1305,
		129
	],
	"./attribute/remove.vue": [
		1176,
		281
	],
	"./cabinet/door.vue": [
		1120,
		202
	],
	"./cabinet/edit.vue": [
		1101,
		92
	],
	"./cabinet/editWeb.vue": [
		1117,
		111
	],
	"./cabinet/index.vue": [
		1306,
		4
	],
	"./cabinet/info.vue": [
		1177,
		18
	],
	"./cabinet/infoChart.vue": [
		1178,
		21
	],
	"./cabinet/remove.vue": [
		1102,
		280
	],
	"./cabinet/spreadDetail.vue": [
		1362,
		173
	],
	"./cabinet/stock.vue": [
		1363,
		116
	],
	"./cabinetInfo/expire.vue": [
		1364,
		86
	],
	"./cabinetInfo/overRestore.vue": [
		1365,
		81
	],
	"./cabinetInfo/stock.vue": [
		1366,
		85
	],
	"./cabinetInfo/todayBack.vue": [
		1367,
		102
	],
	"./cabinetInfo/todayBorrow.vue": [
		1368,
		101
	],
	"./cabinetInfo/todayOperation.vue": [
		1369,
		96
	],
	"./cabinetInfo/todayUnWeight.vue": [
		1370,
		80
	],
	"./cabinetInfo/unLogout.vue": [
		1371,
		84
	],
	"./cabinetInfo/unRestore.vue": [
		1372,
		83
	],
	"./cas/edit.vue": [
		1109,
		157
	],
	"./cas/index.vue": [
		1307,
		61
	],
	"./cas/remove.vue": [
		1179,
		279
	],
	"./cas/setting.vue": [
		1181,
		278
	],
	"./cas/upload.vue": [
		1180,
		220
	],
	"./company/edit.vue": [
		1182,
		307
	],
	"./company/index.vue": [
		1308,
		88
	],
	"./company/remove.vue": [
		1183,
		306
	],
	"./companyCft/index.vue": [
		1309,
		146
	],
	"./companyCft/remove.vue": [
		1373,
		277
	],
	"./companyCft/setting.vue": [
		1374,
		139
	],
	"./companyCft/updateSetting.vue": [
		1121,
		219
	],
	"./companyInitial/APIaccount.vue": [
		1188,
		156
	],
	"./companyInitial/edit.vue": [
		1184,
		305
	],
	"./companyInitial/editAPI.vue": [
		1132,
		218
	],
	"./companyInitial/functionSetting.vue": [
		1187,
		217
	],
	"./companyInitial/index.vue": [
		1310,
		30
	],
	"./companyInitial/remove.vue": [
		1185,
		276
	],
	"./companyInitial/setting.vue": [
		1186,
		172
	],
	"./complementapply/approvalP.vue": [
		1189,
		28
	],
	"./complementapply/edit.vue": [
		1133,
		117
	],
	"./complementapply/index.vue": [
		1311,
		9
	],
	"./complementapply/purchaseDialog.vue": [
		1111,
		152
	],
	"./complementapply/requestedR.vue": [
		1190,
		15
	],
	"./complementapply/results.vue": [
		1110,
		275
	],
	"./complementapply/steps.vue": [
		1134,
		216
	],
	"./components/changePassword.vue": [
		156
	],
	"./configurationItem/edit.vue": [
		1191,
		274
	],
	"./configurationItem/index.vue": [
		1312,
		75
	],
	"./configurationItem/remove.vue": [
		1192,
		273
	],
	"./danger/edit.vue": [
		1193,
		272
	],
	"./danger/index.vue": [
		1313,
		128
	],
	"./danger/remove.vue": [
		1194,
		271
	],
	"./dataBoard/detailsDialog.vue": [
		1195,
		201
	],
	"./dataBoard/index.vue": [
		1314,
		40
	],
	"./dataBoard/remove.vue": [
		1375,
		270
	],
	"./demonstration/authorizedUser.vue": [
		1201,
		46
	],
	"./demonstration/autoDetails.vue": [
		1196,
		269
	],
	"./demonstration/edit.vue": [
		1198,
		29
	],
	"./demonstration/faceDetails.vue": [
		1200,
		268
	],
	"./demonstration/handUserDialog.vue": [
		1202,
		200
	],
	"./demonstration/index.vue": [
		1315,
		5
	],
	"./demonstration/remove.vue": [
		1103,
		267
	],
	"./demonstration/setting.vue": [
		1197,
		171
	],
	"./demonstration/video.vue": [
		1199,
		151
	],
	"./department/addchildren.vue": [
		1204,
		266
	],
	"./department/edit.vue": [
		1203,
		140
	],
	"./department/index.vue": [
		1316,
		53
	],
	"./department/remove.vue": [
		1205,
		265
	],
	"./facial/batch.vue": [
		1208,
		199
	],
	"./facial/edit.vue": [
		1206,
		170
	],
	"./facial/feature.vue": [
		1209,
		264
	],
	"./facial/index.vue": [
		1317,
		23
	],
	"./facial/remove.vue": [
		1207,
		263
	],
	"./facial/setting.vue": [
		1376,
		138
	],
	"./facial/updateSetting.vue": [
		1210,
		198
	],
	"./facialInformation/edit.vue": [
		1211,
		311
	],
	"./facialInformation/removeInfo.vue": [
		1212,
		310
	],
	"./facialInformation/roleIndex.vue": [
		1377,
		155
	],
	"./globalConfig/edit.vue": [
		1213,
		262
	],
	"./globalConfig/index.vue": [
		1318,
		127
	],
	"./globalConfig/remove.vue": [
		1214,
		261
	],
	"./handheldMachine/edit.vue": [
		1215,
		121
	],
	"./handheldMachine/index.vue": [
		1319,
		52
	],
	"./handheldMachine/remove.vue": [
		1216,
		260
	],
	"./headerSettings/index.vue": [
		1320,
		109
	],
	"./initdata/index.vue": [
		1321,
		309
	],
	"./inventory/edit.vue": [
		1136,
		215
	],
	"./inventory/index.vue": [
		1135,
		69
	],
	"./inventory/materiel.vue": [
		1217,
		197
	],
	"./inventory/remove.vue": [
		1378,
		259
	],
	"./inventory/search.vue": [
		1379,
		38
	],
	"./keyBox/edit.vue": [
		1218,
		100
	],
	"./keyBox/index.vue": [
		1322,
		42
	],
	"./keyBox/remove.vue": [
		1219,
		258
	],
	"./keyBoxRecord/edit.vue": [
		1220,
		214
	],
	"./keyBoxRecord/index.vue": [
		1323,
		74
	],
	"./keyBoxRecord/remove.vue": [
		1380,
		257
	],
	"./labelManage/edit.vue": [
		1221,
		196
	],
	"./labelManage/index.vue": [
		1324,
		78
	],
	"./labelManage/remove.vue": [
		1222,
		256
	],
	"./laboratory/edit.vue": [
		1223,
		213
	],
	"./laboratory/index.vue": [
		1325,
		87
	],
	"./laboratory/remove.vue": [
		1224,
		255
	],
	"./largeScreen/TypeClassifyEcharts.vue": [
		1230,
		70
	],
	"./largeScreen/bottomLeft.vue": [
		1227,
		55
	],
	"./largeScreen/bottomRight.vue": [
		1226,
		54
	],
	"./largeScreen/center.vue": [
		1381,
		169
	],
	"./largeScreen/classifyEcharts.vue": [
		1229,
		71
	],
	"./largeScreen/dangerType.vue": [
		1137,
		72
	],
	"./largeScreen/detailsDialog.vue": [
		1228,
		195
	],
	"./largeScreen/index.vue": [
		1326,
		2
	],
	"./largeScreen/materielListChild.vue": [
		411,
		0
	],
	"./largeScreen/materielListChild.vue.vue": [
		411,
		0
	],
	"./largeScreen/receive.vue": [
		1231,
		194
	],
	"./largeScreen/screenChild.vue": [
		1382,
		31
	],
	"./largeScreen/userListChild.vue": [
		1383,
		39
	],
	"./largeScreen/violationRecords.vue": [
		1225,
		193
	],
	"./layout/AppMain.vue": [
		232
	],
	"./layout/Header.vue": [
		233
	],
	"./layout/Layout.vue": [
		228
	],
	"./layout/Levelbar.vue": [
		124
	],
	"./layout/Navbar.vue": [
		229
	],
	"./layout/Sidebar.vue": [
		230
	],
	"./layout/SidebarItem.vue": [
		231
	],
	"./layout/TabsView.vue": [
		158
	],
	"./layout/index.vue": [
		1402,
		308
	],
	"./localSetting/edit.vue": [
		1232,
		132
	],
	"./localSetting/index.vue": [
		1327,
		58
	],
	"./localSetting/remove.vue": [
		1233,
		254
	],
	"./localSetting/upload.vue": [
		1234,
		212
	],
	"./log/index.vue": [
		1328,
		150
	],
	"./log/remove.vue": [
		1235,
		253
	],
	"./login/index.vue": [
		1329,
		168
	],
	"./logoff/edit.vue": [
		1139,
		252
	],
	"./logoff/index.vue": [
		1138,
		57
	],
	"./logoff/materiel.vue": [
		1236,
		82
	],
	"./logoff/remove.vue": [
		1140,
		251
	],
	"./logoff/requestedR.vue": [
		1237,
		48
	],
	"./logoff/results.vue": [
		1141,
		250
	],
	"./logoff/search.vue": [
		1384,
		10
	],
	"./logoff/steps.vue": [
		1142,
		192
	],
	"./mail/edit.vue": [
		1238,
		191
	],
	"./mail/index.vue": [
		1330,
		108
	],
	"./mail/test.vue": [
		1239,
		190
	],
	"./manufacturer/edit.vue": [
		1240,
		249
	],
	"./manufacturer/index.vue": [
		1331,
		126
	],
	"./manufacturer/remove.vue": [
		1241,
		248
	],
	"./materiel/batchAdd.vue": [
		1385,
		19
	],
	"./materiel/batchDetail.vue": [
		1247,
		137
	],
	"./materiel/batchaddmateriel.vue": [
		1249,
		68
	],
	"./materiel/bottletDetail.vue": [
		1106,
		189
	],
	"./materiel/columnShow.vue": [
		1246,
		211
	],
	"./materiel/densityModify.vue": [
		1144,
		247
	],
	"./materiel/detailsDialog.vue": [
		1122,
		188
	],
	"./materiel/distribute.vue": [
		1099,
		115
	],
	"./materiel/door.vue": [
		1245,
		187
	],
	"./materiel/edit.vue": [
		1242,
		25
	],
	"./materiel/index.vue": [
		1332,
		3
	],
	"./materiel/logoff.vue": [
		1386,
		186
	],
	"./materiel/modifyWeight.vue": [
		1143,
		246
	],
	"./materiel/print.vue": [
		1243,
		76
	],
	"./materiel/remove.vue": [
		1100,
		154
	],
	"./materiel/spreadDetail.vue": [
		1098,
		167
	],
	"./materiel/spreadDetails.vue": [
		1145,
		166
	],
	"./materiel/upload.vue": [
		1244,
		210
	],
	"./materiel/usageDetails.vue": [
		1248,
		185
	],
	"./msds/edit.vue": [
		1250,
		136
	],
	"./msds/index.vue": [
		1333,
		67
	],
	"./msds/info.vue": [
		1093,
		184
	],
	"./msds/remove.vue": [
		1146,
		245
	],
	"./orderInLocal/addmateriel.vue": [
		1251,
		165
	],
	"./orderInLocal/index.vue": [
		1334,
		113
	],
	"./orderInquiry/addmateriel.vue": [
		1252,
		164
	],
	"./orderInquiry/index.vue": [
		1335,
		49
	],
	"./page/form.vue": [
		1387,
		304
	],
	"./permissonMgt/edit.vue": [
		1253,
		209
	],
	"./permissonMgt/index.vue": [
		1336,
		94
	],
	"./permissonMgt/permissonGoup/edit.vue": [
		1255,
		89
	],
	"./permissonMgt/permissonGoup/index.vue": [
		1337,
		63
	],
	"./permissonMgt/permissonGoup/removeInfo.vue": [
		1256,
		303
	],
	"./permissonMgt/permissonGoup/selectIconDialog.vue": [
		1147,
		158
	],
	"./permissonMgt/removeInfo.vue": [
		1254,
		302
	],
	"./personnelUS/edit.vue": [
		1257,
		244
	],
	"./personnelUS/index.vue": [
		1338,
		50
	],
	"./print/index.vue": [
		1339,
		183
	],
	"./printRecord/edit.vue": [
		1258,
		243
	],
	"./printRecord/index.vue": [
		1340,
		120
	],
	"./printer/edit.vue": [
		1259,
		79
	],
	"./printer/index.vue": [
		1341,
		37
	],
	"./printer/remove.vue": [
		1260,
		242
	],
	"./projectAdmiss/approvalP.vue": [
		1261,
		27
	],
	"./projectAdmiss/edit.vue": [
		1148,
		65
	],
	"./projectAdmiss/index.vue": [
		1342,
		7
	],
	"./projectAdmiss/purchaseDialog.vue": [
		1113,
		149
	],
	"./projectAdmiss/requestedR.vue": [
		1262,
		11
	],
	"./projectAdmiss/results.vue": [
		1112,
		241
	],
	"./projectAdmiss/selectReagentConfiguration.vue": [
		1118,
		182
	],
	"./projectAdmiss/steps.vue": [
		1149,
		208
	],
	"./purchaseOrderMenu/edit.vue": [
		1263,
		301
	],
	"./purchaseOrderMenu/index.vue": [
		1343,
		56
	],
	"./purchaseOrderMenu/librarySelDialog.vue": [
		1265,
		240
	],
	"./purchaseOrderMenu/printdialog.vue": [
		1266,
		163
	],
	"./purchaseOrderMenu/remove.vue": [
		1264,
		239
	],
	"./purchasing/approvalP.vue": [
		1267,
		51
	],
	"./purchasing/edit.vue": [
		1150,
		91
	],
	"./purchasing/index.vue": [
		1344,
		12
	],
	"./purchasing/purchaseDialog.vue": [
		1115,
		300
	],
	"./purchasing/requestedR.vue": [
		1268,
		20
	],
	"./purchasing/results.vue": [
		1114,
		238
	],
	"./purchasing/steps.vue": [
		1151,
		207
	],
	"./reagenbottlet/edit.vue": [
		1269,
		162
	],
	"./reagenbottlet/index.vue": [
		1345,
		93
	],
	"./reagenbottlet/remove.vue": [
		1270,
		237
	],
	"./receiveReagent/approvalP.vue": [
		1271,
		43
	],
	"./receiveReagent/edit.vue": [
		1273,
		103
	],
	"./receiveReagent/index.vue": [
		1346,
		17
	],
	"./receiveReagent/reagentsearch.vue": [
		1388,
		24
	],
	"./receiveReagent/requestedR.vue": [
		1272,
		47
	],
	"./receiveReagent/results.vue": [
		1116,
		236
	],
	"./receiveReagent/steps.vue": [
		1152,
		181
	],
	"./report/chemicalsMonth.vue": [
		1389,
		145
	],
	"./report/dangerPrivate.vue": [
		1390,
		144
	],
	"./report/dangerPublic.vue": [
		1391,
		143
	],
	"./report/dangerousChemicalsConsuming.vue": [
		1392,
		13
	],
	"./report/dangerousChemicalsMonthly.vue": [
		1393,
		64
	],
	"./report/dataSupplementationDialog.vue": [
		1276,
		148
	],
	"./report/dccEdit.vue": [
		1275,
		206
	],
	"./report/detailsDialog.vue": [
		1274,
		180
	],
	"./report/excel.vue": [
		1097,
		299
	],
	"./report/index.vue": [
		1347,
		124
	],
	"./report/index_back.vue": [
		1394,
		97
	],
	"./report/info.vue": [
		1277,
		179
	],
	"./report/undanger.vue": [
		1395,
		142
	],
	"./report/undangernew.vue": [
		1396,
		141
	],
	"./returnList/index.vue": [
		1348,
		99
	],
	"./returnList/remove.vue": [
		1278,
		235
	],
	"./role/edit.vue": [
		1279,
		178
	],
	"./role/removeInfo.vue": [
		1280,
		234
	],
	"./role/roleIndex.vue": [
		1397,
		123
	],
	"./search/index.vue": [
		1349,
		16
	],
	"./search/materiel.vue": [
		1281,
		125
	],
	"./search/materiels.vue": [
		1282,
		90
	],
	"./search/spreadDetail.vue": [
		1153,
		161
	],
	"./search/user.vue": [
		1283,
		77
	],
	"./sensor/edit.vue": [
		1398,
		233
	],
	"./sensor/index.vue": [
		1350,
		160
	],
	"./sensor/remove.vue": [
		1399,
		232
	],
	"./setting/edit.vue": [
		1284,
		231
	],
	"./setting/index.vue": [
		1351,
		112
	],
	"./setting/remove.vue": [
		1285,
		230
	],
	"./setting/setting.vue": [
		1400,
		107
	],
	"./setting/updateSetting.vue": [
		1286,
		153
	],
	"./supplier/details.vue": [
		1119,
		135
	],
	"./supplier/edit.vue": [
		1287,
		105
	],
	"./supplier/editDetails.vue": [
		1105,
		229
	],
	"./supplier/index.vue": [
		1352,
		41
	],
	"./supplier/remove.vue": [
		1288,
		228
	],
	"./supplier/removeDetails.vue": [
		1104,
		227
	],
	"./supplier/state.vue": [
		1289,
		106
	],
	"./sysParameter/edit.vue": [
		1290,
		177
	],
	"./sysParameter/index.vue": [
		1353,
		122
	],
	"./sysParameter/remove.vue": [
		1291,
		226
	],
	"./systemsetting/edit.vue": [
		1292,
		176
	],
	"./systemsetting/index.vue": [
		1354,
		134
	],
	"./user/addUser.vue": [
		1293,
		60
	],
	"./user/batchDetail.vue": [
		1296,
		104
	],
	"./user/cabinet.vue": [
		1295,
		225
	],
	"./user/door.vue": [
		1294,
		175
	],
	"./user/index.vue": [
		1355,
		8
	],
	"./user/removeUser.vue": [
		1154,
		224
	],
	"./versionText/index.vue": [
		1356,
		298
	],
	"./viewInventory/index.vue": [
		1357,
		114
	],
	"./viewInventory/spreadDetail.vue": [
		1401,
		159
	],
	"./webtools/index.vue": [
		1358,
		133
	],
	"./webtools/upload.vue": [
		1297,
		205
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 882;
module.exports = webpackAsyncContext;

/***/ }),
/* 883 */,
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */,
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

!function (s) {
  var c,
      e = '<svg><symbol id="icon-report" viewBox="0 0 1248 1024"><path d="M31.008 98.56c8-24.128 24.096-32.96 47.296-32.48 44.832 0.96 89.728 0.224 134.624 0.32 27.488 0.064 42.24 15.552 42.24 45.216 0.064 266.816 0.064 533.632 0 800.48 0 29.728-14.656 45.408-42.016 45.472-44.896 0.128-89.76-0.64-134.624 0.32-23.104 0.512-39.296-8.224-47.552-32.192 0-275.712 0-551.424 0-827.136z"  ></path><path d="M891.808 533.024c0 123.648 0.128 247.328-0.224 371.008-0.032 11.424-2.048 23.232-5.152 34.176-3.776 13.12-13.152 19.584-26.432 19.52-47.584-0.224-95.168 0.128-142.72-0.192-26.688-0.16-49.952-25.76-49.952-54.4-0.032-247.36-0.032-494.656 0-742.016 0-16.8 4.8-24.768 19.744-29.248 9.504-2.848 19.648-4.32 29.472-4.416 47.936-0.448 95.936-0.32 143.872-0.128 26.24 0.064 31.392 5.92 31.424 34.688 0 123.68 0 247.36 0 371.04z"  ></path><path d="M573.632 645.664c0 89.472 0.032 178.944 0 268.416-0.032 38.88-4.352 43.52-40.256 43.52-41.408 0-82.88 0.8-124.224-0.512-12.512-0.416-25.536-5.024-37.088-10.656-16.16-7.84-23.488-21.312-23.36-42.624 0.832-175.2 0.48-350.432 0.48-525.632 0-17.76 2.56-21.696 19.072-24.768 10.496-1.952 21.312-2.88 31.968-2.944 50.208-0.288 100.448-0.16 150.72-0.128 22.112 0.032 22.688 0.768 22.688 24.32 0 90.368 0 180.672 0 270.976z"  ></path><path d="M1209.824 786.944c0 46.208 0 92.384-0.032 138.592-0.032 20.832-9.344 31.808-28.768 31.936-49.472 0.384-98.944 0.288-148.416-0.064-6.752-0.032-13.728-1.952-20.192-4.288-23.68-8.544-26.752-13.44-26.752-40 0-87.424 0-174.816 0-262.24 0-17.184 0.32-17.632 15.904-17.632 65.984-0.032 131.904 0.128 197.888-0.128 8.16-0.032 10.528 2.848 10.496 11.488-0.32 47.456-0.128 94.912-0.128 142.368z"  ></path></symbol><symbol id="icon-search" viewBox="0 0 1024 1024"><path d="M938.670589 832.937476 724.072023 618.264209c-2.493797-2.481518-5.266957-4.377704-7.883551-6.445806 36.231179-55.625902 57.400315-121.893164 57.400315-193.285145 0-196.1064-158.901033-355.056552-355.045295-355.056552-196.033745 0-355.056552 158.951175-355.056552 355.056552 0 196.130959 159.022807 355.044272 355.056552 355.044272 71.342862 0 137.697105-21.216207 193.404871-57.471946 2.033309 2.700505 3.894703 5.376451 6.351662 7.836479l214.636429 214.69578c14.635325 14.610766 33.736359 21.886473 52.850695 21.886473 19.122523 0 38.223556-7.275707 52.859905-21.851681C967.797977 909.451104 967.797977 862.134449 938.670589 832.937476M418.543492 661.46615c-133.911896 0-242.933915-108.996436-242.933915-242.933915 0-133.912919 109.020996-242.946194 242.933915-242.946194 133.912919 0 242.921635 109.033275 242.921635 242.946194C661.465127 552.469714 552.456411 661.46615 418.543492 661.46615"  ></path></symbol><symbol id="icon-setting" viewBox="0 0 1024 1024"><path d="M882.527918 434.149934c-2.234901-5.303796-7.311523-8.853645-13.059434-9.138124l-61.390185-3.009544c-6.635117-20.973684-15.521508-41.175795-26.513864-60.282968l42.051745-47.743374c4.308119-4.889357 4.955872-12.004405 1.602498-17.59268-46.384423-77.30362-103.969956-101.422947-106.400309-102.410438-5.332449-2.170432-11.432377-1.090844-15.693424 2.77009L654.674467 240.664222c-17.004279-8.654101-35.092239-15.756869-53.995775-21.210068l-3.26537-66.490344c-0.280386-5.747911-3.833305-10.824533-9.134031-13.059434-1.683339-0.709151-30.193673-12.391215-76.866668-12.051477-46.672996-0.339738-75.18333 11.342326-76.866668 12.051477-5.300726 2.234901-8.853645 7.311523-9.134031 13.059434l-3.26537 66.490344c-18.903535 5.453199-36.991496 12.555967-53.995775 21.210068l-48.450479-43.922349c-4.261047-3.860934-10.360975-4.940522-15.693424-2.77009-2.430352 0.98749-60.015885 25.106818-106.400309 102.410438-3.353374 5.588275-2.705622 12.703323 1.602498 17.59268l42.051745 47.743374c-10.992355 19.107173-19.878746 39.309284-26.513864 60.282968l-61.390185 3.009544c-5.747911 0.284479-10.824533 3.834328-13.059434 9.138124-1.01512 2.415003-24.687262 60.190871-2.822278 147.651828 1.583055 6.324032 7.072069 10.893094 13.57518 11.308557 5.892197 0.37146 11.751648 0.523933 17.419741 0.667196 14.498202 0.372483 28.193109 0.723477 40.908712 4.63353 4.212952 1.294482 6.435573 8.270361 9.349949 18.763342 1.287319 4.640694 2.617617 9.43693 4.484128 14.010085 1.794879 4.393054 3.75758 8.570189 5.66093 12.607132 1.302669 2.765997 2.529613 5.380544 3.689019 8.018627 2.986007 6.803963 2.682086 9.773598 2.578732 10.349719-3.061732 3.672646-6.391571 7.238868-9.91379 11.015891-1.810229 1.943258-3.680832 3.949962-5.523807 5.980201l-22.560832 24.8909c-3.865028 4.261047-4.940522 10.365068-2.774183 15.693424 0.991584 2.426259 25.102724 60.011792 102.414531 106.400309 5.588275 3.353374 12.703323 2.701528 17.591657-1.603521l23.476691-20.682042c2.346441-2.061962 4.64888-4.336772 6.875594-6.534833 9.05319-8.93858 14.018272-12.95608 17.73185-11.576663 3.305279 1.222851 6.907317 3.166109 10.720156 5.228071 3.325745 1.794879 6.764054 3.650133 10.465352 5.288446 6.016017 2.662643 12.120039 4.688789 18.019399 6.65149 6.827499 2.266623 13.279445 4.409426 18.819624 7.275707 1.518586 0.782829 1.926886 0.994654 2.358721 7.830339 0.726547 11.496845 1.25048 23.276123 1.753947 34.672684 0.264013 5.900384 0.528026 11.803837 0.815575 17.700127 0.284479 5.743818 3.833305 10.82044 9.138124 13.05534 1.654686 0.698918 29.371958 12.063757 74.869175 12.063757 0.328481 0 3.65832 0 3.986801 0 45.497217 0 73.214489-11.364839 74.869175-12.063757 5.304819-2.234901 8.853645-7.311523 9.138124-13.05534 0.287549-5.89629 0.551562-11.799744 0.815575-17.700127 0.503467-11.396561 1.027399-23.175839 1.753947-34.672684 0.431835-6.835685 0.840134-7.04751 2.358721-7.830339 5.54018-2.866281 11.992125-5.009084 18.819624-7.275707 5.89936-1.962701 12.003382-3.988848 18.019399-6.65149 3.701299-1.638313 7.139607-3.493567 10.465352-5.288446 3.812839-2.061962 7.414877-4.00522 10.720156-5.228071 3.713578-1.379417 8.67866 2.638083 17.73185 11.576663 2.226714 2.198062 4.529153 4.472871 6.875594 6.534833l23.476691 20.682042c4.888334 4.305049 12.003382 4.956895 17.591657 1.603521 77.311807-46.388517 101.422947-103.97405 102.414531-106.400309 2.166339-5.328355 1.090844-11.432377-2.774183-15.693424l-22.560832-24.8909c-1.842974-2.030239-3.713578-4.036943-5.523807-5.980201-3.52222-3.777023-6.852058-7.343245-9.91379-11.015891-0.103354-0.576121-0.407276-3.545756 2.578732-10.349719 1.159406-2.638083 2.38635-5.252631 3.689019-8.018627 1.90335-4.036943 3.866051-8.214079 5.66093-12.607132 1.866511-4.573155 3.196809-9.369392 4.484128-14.010085 2.914376-10.492982 5.136997-17.46886 9.349949-18.763342 12.715603-3.910053 26.41051-4.261047 40.908712-4.63353 5.668093-0.143263 11.527544-0.295735 17.419741-0.667196 6.503111-0.415462 11.992125-4.984524 13.57518-11.308557C907.21518 494.340805 883.543038 436.564937 882.527918 434.149934zM643.49894 643.761929c-35.280528 35.280528-82.191954 54.711066-132.086317 54.711066s-96.806813-19.430538-132.086317-54.711066c-35.280528-35.279504-54.711066-82.191954-54.711066-132.086317 0-49.894364 19.430538-96.80272 54.711066-132.082224 35.283598-35.284621 82.191954-54.711066 132.086317-54.711066s96.80579 19.426445 132.086317 54.711066c35.279504 35.279504 54.711066 82.187861 54.711066 132.082224C698.210006 561.569976 678.782537 608.482425 643.49894 643.761929z"  ></path></symbol><symbol id="icon-dunpaisuo" viewBox="0 0 1024 1024"><path d="M539.733333 996.266667c-8.533333 4.266667-17.066667 6.4-27.733333 6.4s-19.2-2.133333-27.733333-6.4C384 947.2 85.333333 770.133333 85.333333 558.933333V157.866667c0-27.733333 17.066667-51.2 40.533334-59.733334C249.6 49.066667 366.933333 21.333333 512 21.333333s262.4 27.733333 386.133333 76.8C921.6 106.666667 938.666667 130.133333 938.666667 157.866667v401.066666c0 211.2-298.666667 388.266667-398.933334 437.333334zM896 157.866667c0-8.533333-6.4-17.066667-14.933333-21.333334C750.933333 85.333333 642.133333 64 512 64S273.066667 85.333333 142.933333 136.533333c-8.533333 4.266667-14.933333 12.8-14.933333 21.333334v401.066666C128 725.333333 362.666667 887.466667 503.466667 957.866667c2.133333 2.133333 4.266667 2.133333 8.533333 2.133333s6.4 0 8.533333-2.133333C661.333333 887.466667 896 725.333333 896 558.933333V157.866667zM533.333333 443.733333V618.666667c0 12.8-8.533333 21.333333-21.333333 21.333333s-21.333333-8.533333-21.333333-21.333333v-170.666667-4.266667c-25.6-8.533333-42.666667-32-42.666667-59.733333 0-36.266667 27.733333-64 64-64s64 27.733333 64 64c0 27.733333-19.2 51.2-42.666667 59.733333zM512 362.666667c-12.8 0-21.333333 8.533333-21.333333 21.333333s8.533333 21.333333 21.333333 21.333333 21.333333-8.533333 21.333333-21.333333-8.533333-21.333333-21.333333-21.333333z" fill="#666767" ></path></symbol><symbol id="icon-password" viewBox="0 0 1024 1024"><path d="M358.4 256c0-84.48 69.12-153.6 153.6-153.6s153.6 69.12 153.6 153.6v102.4h102.4v-102.4c0-140.8-115.2-256-256-256S256 115.2 256 256v102.4h102.4v-102.4zM870.4 409.6H153.6c-28.16 0-51.2 23.04-51.2 51.2v512c0 28.16 23.04 51.2 51.2 51.2h716.8c28.16 0 51.2-23.04 51.2-51.2V460.8c0-28.16-23.04-51.2-51.2-51.2zM563.2 793.6c0 28.16-23.04 51.2-51.2 51.2s-51.2-23.04-51.2-51.2v-153.6c0-28.16 23.04-51.2 51.2-51.2s51.2 23.04 51.2 51.2v153.6z"  ></path></symbol><symbol id="icon-dunpai" viewBox="0 0 1024 1024"><path d="M868.7 211c-0.1 0-0.2-0.1-0.2-0.1-80-20.2-151.3-60.5-219.9-92.3-45.7-20.2-80-54.8-145.7-54.8h-3c-19.9 2.9-31.3 5.8-45.5 11.5-97.1 43.2-185.7 106.7-299.9 135.5h-0.2c-17.1 2.9-28.5 20.2-28.5 37.5C134.4 663.6 311.5 828 494.4 952c11.4 8.7 25.7 8.7 40 0C743 825.1 888.7 580 897.3 248.3c-0.2-17.1-11.5-31.5-28.6-37.3zM576.1 703.9c0 35.3-28.6 63.9-63.9 63.9h-0.2c-35.3 0-63.9-28.6-63.9-63.9S476.7 640 512 640h0.2c35.3 0 63.9 28.6 63.9 63.9z m0.4-191.6c0 35.5-28.7 64.2-64.2 64.2s-64.2-28.7-64.2-64.2V320.2c0-35.5 28.7-64.2 64.2-64.2s64.2 28.7 64.2 64.2v192.1z" fill="#CDCDCD" ></path></symbol><symbol id="icon-door" viewBox="0 0 1024 1024"><path d="M417.426286 397.604571v185.417143a12.8 12.8 0 1 0 25.563428 0v-185.417143a12.8 12.8 0 0 0-25.563428 0z m208.512 0v185.417143a12.8 12.8 0 1 0 25.563428 0v-185.417143a12.8 12.8 0 1 0-25.563428 0z"  ></path><path d="M835.273143 0.365714H205.714286C167.515429 0.365714 136.502857 29.952 136.502857 66.56v890.185143c0 36.516571 30.957714 66.194286 69.229714 66.194286H835.291429c38.217143 0 69.229714-29.604571 69.229714-66.194286V66.486857c0-36.534857-31.030857-66.121143-69.229714-66.121143zM164.626286 944.896V78.262857c0-27.392 30.500571-49.609143 68.114285-49.609143h333.531429v965.869715H232.740571c-37.613714 0-68.114286-22.198857-68.114285-49.609143z m711.753143 0c0 27.410286-23.222857 49.609143-51.876572 49.609143H498.651429V28.653714h325.76c28.672 0 51.894857 22.198857 51.894857 49.590857v866.651429h0.073143z"  ></path></symbol><symbol id="icon-chemistry" viewBox="0 0 1024 1024"><path d="M341.333333 170.666667H298.666667a42.666667 42.666667 0 1 1 0-85.333334h426.666666a42.666667 42.666667 0 0 1 0 85.333334h-42.666666v298.666666a42.666667 42.666667 0 0 1-85.333334 0V170.666667h-170.666666v298.666666a42.666667 42.666667 0 0 1-4.522667 19.072L256 820.778667V853.333333h512v-30.848L658.517333 640H469.333333a42.666667 42.666667 0 0 1 0-85.333333h213.333334a42.666667 42.666667 0 0 1 36.565333 20.736l128 213.333333A42.666667 42.666667 0 0 1 853.333333 810.666667v85.333333a42.666667 42.666667 0 0 1-42.666666 42.666667H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667v-85.333333a42.666667 42.666667 0 0 1 4.522666-19.072L341.333333 459.221333V170.666667z"  ></path></symbol><symbol id="icon-report2" viewBox="0 0 1024 1024"><path d="M128 960c-19.2 0-32-12.8-32-32v-832c0-19.2 12.8-32 32-32s32 12.8 32 32v832c0 16-12.8 32-32 32z" fill="#f3ca7e" ></path><path d="M1024 806.4c0 19.2-12.8 32-32 32h-960c-19.2 0-32-12.8-32-32s12.8-32 32-32h960c19.2 0 32 16 32 32zM320 672c-19.2 0-32-12.8-32-32v-320c0-19.2 12.8-32 32-32s32 12.8 32 32v320c0 16-12.8 32-32 32zM480 672c-19.2 0-32-12.8-32-32v-192c0-19.2 12.8-32 32-32s32 12.8 32 32v192c0 16-12.8 32-32 32zM640 672c-19.2 0-32-12.8-32-32v-512c0-19.2 12.8-32 32-32s32 12.8 32 32v512c0 16-12.8 32-32 32zM800 672c-19.2 0-32-12.8-32-32v-384c0-19.2 12.8-32 32-32s32 12.8 32 32v384c0 16-12.8 32-32 32z" fill="#f3ca7e" ></path></symbol><symbol id="icon-UserSettings" viewBox="0 0 1024 1024"><path d="M955.904 803.328l-41.472-8.192c-4.608-1.024-8.704-4.096-10.24-8.704-1.536-3.584-3.072-7.68-4.608-11.264-2.048-4.096-1.536-9.216 1.024-13.312l23.552-35.328c3.584-5.632 3.072-12.8-1.536-17.408l-22.528-22.528c-4.608-4.608-11.776-5.12-17.408-1.536l-35.328 23.552c-4.096 2.56-9.216 3.072-13.312 1.024-3.584-1.536-7.168-3.072-11.264-4.608-4.608-1.536-7.68-5.632-8.704-10.24l-8.192-41.472c-1.024-6.144-6.656-10.752-13.312-10.752h-32.256c-6.656 0-12.288 4.608-13.312 10.752l-8.192 41.472c-1.024 4.608-4.096 8.704-8.704 10.24-3.584 1.536-7.68 3.072-11.264 4.608-4.096 2.048-9.216 1.536-13.312-1.024l-35.328-23.552c-5.632-3.584-12.8-3.072-17.408 1.536l-22.528 22.528c-4.608 4.608-5.12 11.776-1.536 17.408l23.552 35.328c2.56 4.096 3.072 9.216 1.024 13.312-1.536 3.584-3.072 7.168-4.608 11.264-1.536 4.608-5.632 7.68-10.24 8.704l-41.472 8.192c-6.144 1.024-10.752 6.656-10.752 13.312v32.256c0 6.656 4.608 12.288 10.752 13.312l41.472 8.192c4.608 1.024 8.704 4.096 10.24 8.704 1.536 3.584 3.072 7.68 4.608 11.264 2.048 4.096 1.536 9.216-1.024 13.312l-23.552 35.328c-3.584 5.632-3.072 12.8 1.536 17.408l22.528 22.528c4.608 4.608 11.776 5.12 17.408 1.536l35.328-23.552c4.096-2.56 9.216-3.072 13.312-1.024 3.584 1.536 7.168 3.072 11.264 4.608 4.608 1.536 7.68 5.632 8.704 10.24l8.192 41.472c1.024 6.144 6.656 10.752 13.312 10.752h32.256c6.656 0 12.288-4.608 13.312-10.752l8.192-41.472c1.024-4.608 4.096-8.704 8.704-10.24 3.584-1.536 7.68-3.072 11.264-4.608 4.096-2.048 9.216-1.536 13.312 1.024l35.328 23.552c5.632 3.584 12.8 3.072 17.408-1.536l22.528-22.528c4.608-4.608 5.12-11.776 1.536-17.408l-23.552-35.328c-2.56-4.096-3.072-9.216-1.024-13.312 1.536-3.584 3.072-7.168 4.608-11.264 1.536-4.608 5.632-7.68 10.24-8.704l41.472-8.192c6.144-1.024 10.752-6.656 10.752-13.312v-32.256c0.512-6.144-4.096-11.776-10.752-13.312zM834.048 890.88c-31.744 31.744-83.968 31.744-115.712 0-31.744-31.744-31.744-83.968 0-115.712 31.744-31.744 83.968-31.744 115.712 0 15.36 15.36 24.064 36.352 24.064 57.856 0 21.504-8.704 42.496-24.064 57.856z"  ></path><path d="M608.256 667.136c0.512-1.024-2.048-1.536-3.072-2.56-9.216-8.704-16.384-18.944-22.016-30.208-4.608-9.728-7.168-20.48-8.192-31.232-0.512-10.24 0-20.992 2.048-31.232 1.024-13.312 6.656-26.112 15.36-36.352 9.728-8.704 19.456-17.408 29.696-26.112 5.632-5.632 10.752-12.288 14.336-19.968 4.096-8.704 7.68-16.896 10.752-26.112 3.072-10.752 6.656-21.504 9.216-32.768 6.656-2.048 12.8-6.144 17.92-11.264 5.632-5.632 10.752-12.288 14.336-19.968 4.608-10.752 7.168-22.528 8.192-34.304 1.024-9.216 1.024-18.432-1.024-27.648-1.024-6.144-3.072-12.288-5.632-18.432-2.56-5.12-6.144-9.728-10.752-13.312 0-27.648-1.536-55.296-5.12-82.432-3.584-25.088-8.704-50.176-15.872-74.752-7.68-26.112-19.968-50.176-36.352-71.68-8.192-10.752-17.92-20.48-29.184-28.672-13.312-10.24-27.648-18.432-42.496-25.6-16.384-7.68-33.792-13.824-51.2-17.92C481.28 2.56 462.848 0 444.416 0c-15.36 0-30.208 1.024-45.568 3.584-16.384 2.56-32.256 7.168-47.104 13.824-16.384 7.168-31.744 16.896-46.08 28.16-15.872 13.312-29.696 28.672-40.96 46.08-13.824 20.48-24.064 43.008-30.208 67.072-6.144 23.04-10.752 46.592-13.824 70.144-3.072 25.6-4.608 51.712-4.096 77.312-5.632 6.144-9.728 13.312-12.8 21.504-2.56 7.68-4.608 15.872-5.12 24.576-1.024 10.752 0.512 21.504 4.096 31.232 2.048 9.216 6.144 18.432 11.264 26.624 3.584 5.12 7.68 10.24 12.8 14.336 4.096 3.072 8.704 5.632 13.312 7.168 3.072 10.752 6.144 21.504 9.216 32.768l10.752 26.112c3.072 7.168 7.68 14.336 13.312 19.968 10.24 8.704 20.48 18.432 29.696 28.16 9.216 10.24 14.848 23.552 15.36 37.376 1.024 10.752 1.024 20.48 1.024 29.696 0 8.704-1.536 17.408-5.12 25.6-3.584 9.216-8.704 17.408-15.36 24.576-8.704 9.728-19.456 18.432-30.72 25.6-17.92 11.776-38.4 20.992-59.392 26.624-22.016 6.144-43.52 12.8-64.512 20.992-19.968 7.168-38.4 17.92-54.272 31.232-16.384 14.848-26.624 35.328-28.16 57.344-6.144 35.84-7.68 71.68-4.096 108.032 0 17.92 5.12 35.328 14.848 49.664 8.192 5.12 17.92 8.704 27.648 10.24 14.848 3.584 32.768 6.656 53.76 10.24s44.544 6.656 70.656 9.728c26.112 3.072 52.224 5.632 77.824 8.192 26.112 2.56 51.2 4.096 76.288 5.632 24.576 1.536 46.08 2.048 64.512 2.048 18.432 0 40.448-0.512 65.536-2.048 26.624-1.536 52.736-3.072 79.36-5.632 10.24-1.024 30.208-3.072 30.208-3.072-55.296-70.656-101.888-215.552-10.24-343.552z"  ></path></symbol><symbol id="icon-dunpai1" viewBox="0 0 1024 1024"><path d="M498.071733 675.404255c-14.524823 0-36.312057 7.262411-43.574469 14.524823-14.524823 14.524823-21.787234 29.049645-21.787234 43.574468 0 14.524823 7.262411 29.049645 21.787234 43.574468 14.524823 14.524823 29.049645 21.787234 43.574469 21.787234 14.524823 0 36.312057-7.262411 43.574468-14.524822 14.524823-14.524823 14.524823-29.049645 14.524822-43.574469 0-14.524823-7.262411-29.049645-14.524822-43.574468-7.262411-14.524823-21.787234-21.787234-43.574468-21.787234zM447.234853 217.87234l21.787234 413.957447h72.624114L556.171023 217.87234H447.234853z m457.531915-72.624113c14.524823 14.524823 29.049645 36.312057 29.049645 65.361702V363.120567c0 254.184397-72.624113 428.48227-196.085106 544.680851-43.574468 43.574468-94.411348 72.624113-137.985816 94.411348-29.049645 14.524823-58.099291 21.787234-72.624113 21.787234h-29.049645c-14.524823 0-43.574468-7.262411-72.624114-21.787234-50.836879-21.787234-94.411348-50.836879-137.985816-94.411348C156.738399 784.340426 84.114286 610.042553 84.114286 355.858156V203.347518c0-21.787234 7.262411-43.574468 29.049645-58.099291 14.524823-14.524823 36.312057-21.787234 58.099291-21.787234h29.049645c36.312057 0 79.886525 0 116.198582-14.524823h7.262411c21.787234-7.262411 50.836879-21.787234 72.624114-43.574468 21.787234-14.524823 65.361702-50.836879 58.09929-50.836879 21.787234-7.262411 36.312057-14.524823 50.83688-14.524823 14.524823 0 36.312057 7.262411 50.836879 14.524823 7.262411 7.262411 50.836879 36.312057 65.361702 50.836879 21.787234 14.524823 36.312057 29.049645 58.099291 36.312057 7.262411 7.262411 14.524823 7.262411 21.787234 7.262411 36.312057 7.262411 72.624113 14.524823 116.198582 14.524823h29.049645c21.787234-7.262411 43.574468 7.262411 58.099291 21.787234z"  ></path></symbol><symbol id="icon-Setting" viewBox="0 0 1024 1024"><path d="M224 512c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32 17.632 0 32 14.4 32 32v416c0 17.6-14.368 32-32 32z m0 256c35.232 0 64-28.8 64-64s-28.768-64-64-64c-35.2 0-64 28.8-64 64s28.8 64 64 64z m0-192a127.968 127.968 0 0 1 32 251.84V960c0 17.6-14.368 32-32 32-17.6 0-32-14.4-32-32v-132.16A127.968 127.968 0 0 1 224 576z m288-192c35.232 0 64-28.8 64-64s-28.768-64-64-64c-35.2 0-64 28.8-64 64s28.8 64 64 64z m32-187.84A127.968 127.968 0 0 1 512 448a127.968 127.968 0 0 1-32-251.84V64c0-17.6 14.4-32 32-32 17.632 0 32 14.4 32 32v132.16zM512 512c17.632 0 32 14.4 32 32v416c0 17.6-14.368 32-32 32-17.6 0-32-14.4-32-32V544c0-17.6 14.4-32 32-32z m288 0c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32 17.632 0 32 14.4 32 32v416c0 17.6-14.368 32-32 32z m0 256c35.232 0 64-28.8 64-64s-28.768-64-64-64c-35.2 0-64 28.8-64 64s28.8 64 64 64z m0-192a127.968 127.968 0 0 1 32 251.84V960c0 17.6-14.368 32-32 32-17.6 0-32-14.4-32-32v-132.16A127.968 127.968 0 0 1 800 576z"  ></path></symbol><symbol id="icon-moreread" viewBox="0 0 1024 1024"><path d="M265.1 509.8c-0.1 45.5-36.8 82.2-82.4 82.1-45.4-0.1-82.3-37-82.2-82.5 0-45.3 37.1-82.2 82.6-82.1 45.4 0.1 82 36.9 82 82.5z m577-82.4c45.5 0 82.5 36.8 82.5 82.2 0.1 45.4-36.8 82.4-82.3 82.4-45.6 0-82.4-36.6-82.4-82.2s36.6-82.4 82.2-82.4zM512.4 592c-45.4 0-82.6-37.3-82.4-82.4 0.3-45.5 37.1-82.2 82.6-82.2 45.4 0 82.5 37.1 82.3 82.4-0.1 45.4-37 82.2-82.5 82.2z" fill="#f3ca7e" ></path></symbol><symbol id="icon-yonghuming" viewBox="0 0 1024 1024"><path d="M476.496933 0.623734a242.697929 242.697929 0 0 1 34.786704 0 199.012302 199.012302 0 0 1 30.741737 0 228.945046 228.945046 0 0 1 115.686013 47.730592 176.360495 176.360495 0 0 1 65.528441 161.79862 368.091859 368.091859 0 0 0-5.662952 85.753268A142.382785 142.382785 0 0 1 728.093786 384.086461c-8.089931 20.224827-29.123751 29.932745-39.640661 47.730593s-10.51691 40.449655-20.224828 59.056496-30.741738 45.303613-40.449655 70.382399a137.528826 137.528826 0 0 0 31.550731 119.730978 294.473487 294.473487 0 0 0 110.023061 69.573407 1537.086882 1537.086882 0 0 1 176.360495 80.899309 233.799005 233.799005 0 0 1 76.045351 63.910455v128.629902H0V890.516139a198.203308 198.203308 0 0 1 55.011531-50.966565 1319.467739 1319.467739 0 0 1 209.529211-93.034206 258.877791 258.877791 0 0 0 105.978096-73.618372 141.573792 141.573792 0 0 0 23.4608-113.259033 566.295167 566.295167 0 0 1-50.157572-94.652192A93.034206 93.034206 0 0 0 323.597238 423.727123a97.079172 97.079172 0 0 1-37.213682-59.056496 139.955806 139.955806 0 0 1 14.561876-70.3824c0-30.741738-8.089931-59.865489-8.898924-90.607226A173.933516 173.933516 0 0 1 361.619914 48.354326 228.945046 228.945046 0 0 1 476.496933 0.623734z" fill="#666666" ></path></symbol></svg>',
      t = (c = document.getElementsByTagName("script"))[c.length - 1].getAttribute("data-injectcss");if (t && !s.__iconfont__svg__cssinject__) {
    s.__iconfont__svg__cssinject__ = !0;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (c) {
      console && console.log(c);
    }
  }!function (c) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) setTimeout(c, 0);else {
        var t = function t() {
          document.removeEventListener("DOMContentLoaded", t, !1), c();
        };document.addEventListener("DOMContentLoaded", t, !1);
      }
    } else document.attachEvent && (o = c, l = s.document, i = !1, (_a = function a() {
      try {
        l.documentElement.doScroll("left");
      } catch (c) {
        return void setTimeout(_a, 50);
      }e();
    })(), l.onreadystatechange = function () {
      "complete" == l.readyState && (l.onreadystatechange = null, e());
    });function e() {
      i || (i = !0, o());
    }var o, l, i, _a;
  }(function () {
    var c, t;(c = document.createElement("div")).innerHTML = e, e = null, (t = c.getElementsByTagName("svg")[0]) && (t.setAttribute("aria-hidden", "true"), t.style.position = "absolute", t.style.width = 0, t.style.height = 0, t.style.overflow = "hidden", function (c, t) {
      t.firstChild ? function (c, t) {
        t.parentNode.insertBefore(c, t);
      }(c, t.firstChild) : t.appendChild(c);
    }(t, document.body));
  });
}(window);

/***/ }),
/* 889 */
/***/ (function(module, exports) {

!function (e) {
  var c,
      l = '<svg><symbol id="icon-chushihua" viewBox="0 0 1024 1024"><path d="M526.51008 92.51328l0-4.48L526.51008 32.55808c0-4.68992-2.66752-8.97024-6.88128-11.1104-4.20864-2.03776-9.2416-1.73056-13.04064 1.01888L391.38304 105.68192c-3.28704 2.34496-5.13536 6.1184-5.13536 10.09664 0 3.97312 1.95072 7.74656 5.13536 10.09664l115.20512 83.10784c3.79904 2.75456 8.832 3.15392 13.04064 1.01888 4.20864-2.14016 6.88128-6.4256 6.88128-11.12064l0-46.09024 0-9.07264c217.38496 0 394.24 176.85504 394.24 394.24s-176.85504 394.24-394.24 394.24-394.24-176.85504-394.24-394.24c0-114.37056 49.59232-222.94016 136.05888-297.93792 5.62176-4.72064 9.27232-11.70944 9.27232-19.62496 0-14.208-11.52-25.72288-25.72288-25.72288-7.296 0-13.8496 3.06688-18.52928 7.94624-96.7936 84.68992-152.27904 206.76096-152.27904 335.34464 0 245.61664 199.82336 445.44 445.44 445.44 245.61664 0 445.44-199.82336 445.44-445.44C971.95008 292.33664 772.12672 92.51328 526.51008 92.51328z"  ></path><path d="M526.51008 549.55008m-153.6 0a30 30 0 1 0 307.2 0 30 30 0 1 0-307.2 0Z"  ></path></symbol><symbol id="icon-iconyujing" viewBox="0 0 1024 1024"><path d="M799.284517 734.6438l-27.726481 0-0.554632 0.959861c-0.538259-0.313132-1.052982-0.645706-1.586125-0.959861L463.262484 734.6438c0 35.349089 28.655643 64.003709 64.002686 64.003709 12.479219 0 23.962761-3.76372 33.746592-9.980305 4.211928-12.755512 16.090467-22.022573 30.259164-22.022573 17.672498 0 31.999808 14.32731 31.999808 32.001855 0 8.837272-3.579525 16.836457-9.372461 22.629393l-1.591241 3.742231c-23.12672 23.197328-49.680493 37.633109-85.041862 37.633109-70.696132 0-128.007419-57.313334-128.007419-128.009466L253.113253 734.641753c-0.534166 0.315178-1.049912 0.647753-1.587148 0.959861l-0.553609-0.959861-27.727505 0c-17.674545 0-32.001855-14.329357-32.001855-32.001855 0-17.674545 14.32731-32.000831 32.001855-32.000831l11.128455 0c57.283658-40.435944 91.718935-107.839077 85.502349-174.659949l0.057305-3.112897c-0.372483-4.709255-0.680499-9.43693-0.680499-14.240329 0-95.183849 69.273736-174.145226 160.145373-189.33109-0.074701-0.887206-0.135076-1.77646-0.135076-2.682086l0-80.005149c0-17.675568 14.329357-32.002878 32.000831-32.002878 17.673521 0 32.001855 14.32731 32.001855 32.002878l0 80.005149c0 0.905626-0.061398 1.794879-0.134053 2.682086 90.870614 15.185864 160.14435 94.146217 160.14435 189.33109 0 4.803399-0.309038 9.531074-0.681522 14.240329l0.056282 3.112897c-6.216585 66.820871 28.218692 134.224004 85.503373 174.659949l11.129478 0c17.673521 0 32.000831 14.326287 32.000831 32.000831C831.286372 720.314443 816.959062 734.6438 799.284517 734.6438zM638.53744 494.628354l-0.369414 0c0.655939-5.254677 1.106194-10.56973 1.106194-16.000416 0-70.697155-57.311287-128.008442-128.009466-128.008442-70.696132 0-128.008442 57.311287-128.008442 128.008442 0 5.431709 0.450255 10.745738 1.107217 16.000416l-0.37146 0c4.723581 62.908772-19.314904 125.876895-58.060347 176.011736l370.666064 0C657.853367 620.505249 633.814882 557.537126 638.53744 494.628354z"  ></path></symbol><symbol id="icon-quanxian" viewBox="0 0 1025 1024"><path d="M292.629467 897.188883l-130.195353 0c13.140905-181.370281 164.906541-324.909163 349.568956-324.909163 43.341143 0 84.868901 7.90849 123.218117 22.355196l39.267166-39.267166c-2.039547-0.902599-4.075001-1.810316-6.132968-2.681191-11.344917-4.798513-22.852547-9.048507-34.5014-12.760217 18.548315-10.670526 35.812318-23.852365 51.349922-39.389968 46.263846-46.263846 71.742322-107.774662 71.742322-173.201859 0-65.427197-25.478477-126.938013-71.742322-173.201859-46.263846-46.263846-107.774662-71.742322-173.201859-71.742322s-126.93699 25.478477-173.200835 71.742322c-46.263846 46.263846-71.742322 107.774662-71.742322 173.201859 0 65.427197 25.478477 126.938013 71.742322 173.201859 15.537603 15.537603 32.801607 28.718419 51.349922 39.389968-11.648853 3.71171-23.156483 7.961704-34.5014 12.760217-47.831626 20.231734-90.784918 49.188595-127.663572 86.068273-36.879678 36.879678-65.837562 79.831946-86.068273 127.664595-20.952176 49.535513-31.574604 102.140068-31.574604 156.352314 0 14.129466 11.453392 25.583882 25.583882 25.583882l156.702302 0c14.13049 0 25.583882-11.454416 25.583882-25.583882S306.758934 897.188883 292.629467 897.188883zM318.226653 327.335539c0-106.848525 86.926868-193.776417 193.776417-193.776417s193.776417 86.927891 193.776417 193.776417-86.927891 193.776417-193.776417 193.776417S318.226653 434.184064 318.226653 327.335539zM882.089276 766.420451c-18.228004-43.095538-43.561164-82.21227-75.36807-116.513093l-36.322973 36.322973c51.762334 56.496375 85.30485 129.945654 91.173793 210.958552l-130.22196 0c-14.129466 0-25.583882 11.454416-25.583882 25.583882s11.454416 25.583882 25.583882 25.583882l156.729932 0c14.129466 0 25.583882-11.454416 25.583882-25.583882C913.66388 868.560519 903.040429 815.955964 882.089276 766.420451zM791.547917 551.013374c-9.992041-9.991018-26.189708-9.991018-36.180726 0l-244.12038 244.12038L404.215104 688.103071c-9.992041-9.991018-26.189708-9.991018-36.180726 0-9.991018 9.991018-9.991018 26.189708 0 36.180726l125.122581 125.121557c4.996021 4.994997 11.542424 7.493007 18.090875 7.493007s13.094854-2.49801 18.090875-7.493007l262.211255-262.211255C801.538934 577.204105 801.538934 561.004391 791.547917 551.013374z"  ></path></symbol><symbol id="icon-yaochi" viewBox="0 0 1024 1024"><path d="M111.373577 778.99082c-29.116131 29.076222-29.116131 76.399017 0 105.496729 29.097712 29.118178 76.419484 29.118178 105.314581 0l21.029966-20.827351 87.696318 87.676875c14.999622 15.015995 39.035038 15.015995 54.05308 0l130.690528-130.690528c15.015995-14.999622 15.015995-39.035038 0-54.05308l-87.676875-87.676875 156.194388-156.397003c33.425274 17.273409 71.52501 27.02654 111.714338 27.02654 134.798079 0 244.073878-109.257379 244.073878-244.073878 0-134.796032-109.275799-244.071831-244.073878-244.071831-134.817522 0-244.073878 109.275799-244.073878 244.071831 0 40.189328 9.753131 78.291111 27.02654 111.716384L111.373577 778.99082zM596.513836 305.47225c0-51.815109 42.059931-93.875041 93.875041-93.875041s93.875041 42.059931 93.875041 93.875041-42.059931 93.875041-93.875041 93.875041S596.513836 357.287359 596.513836 305.47225z"  ></path></symbol><symbol id="icon-tubiao02" viewBox="0 0 1024 1024"><path d="M511.04256 66.56C383.03232 66.56 286.464 168.38144 286.464 303.44192l0 83.24608-7.27552 0c-67.28704 0-122.05568 56.22272-122.05568 125.2864l0 320.1536c0 69.0688 54.76864 125.312 122.05568 125.312l465.62816 0c67.28704 0 122.05568-56.2432 122.05568-125.312l0-320.1536c0-69.06368-54.76864-125.2864-122.05568-125.2864l-3.99872 0c-1.07008-0.384-2.18112-0.49664-3.29728-0.68096l0-82.5856C737.5616 168.40192 640.18944 66.56 511.04256 66.56L511.04256 66.56 511.04256 66.56zM511.04256 103.7056c109.69088 0 189.37344 83.99872 189.37344 199.7568l0 82.0224L323.63008 385.4848l0-82.0224C323.63008 187.70432 402.44736 103.7056 511.04256 103.7056L511.04256 103.7056 511.04256 103.7056zM829.76768 511.97952l0 320.1536c0 48.60928-38.1184 88.16128-84.91008 88.16128L279.20896 920.2944c-46.83264 0-84.91008-39.55712-84.91008-88.16128l0-320.1536c0-48.57856 38.07744-88.1408 84.91008-88.1408l465.62304 0C791.64928 423.8592 829.76768 463.40096 829.76768 511.97952L829.76768 511.97952 829.76768 511.97952zM829.76768 511.97952"  ></path><path d="M507.93472 561.76128c-29.76256 0-53.88288 24.86784-53.88288 55.56224 0 20.53632 10.86976 38.48704 26.94144 48.10752l0 90.75712c0 15.31392 12.04736 27.8016 26.94144 27.8016 14.86848 0 26.93632-12.48256 26.93632-27.8016l0-90.73664c16.07168-9.61024 26.91584-27.55072 26.91584-48.10752C561.7408 586.65984 537.64096 561.76128 507.93472 561.76128L507.93472 561.76128 507.93472 561.76128zM507.93472 561.76128"  ></path></symbol><symbol id="icon-rfid" viewBox="0 0 1024 1024"><path d="M1004.304 479.899c-2.452-6.401-6.561-17.103-14.973-27.886-26.177-33.517-72.385-94.879-92.405-121.594-21.473-28.713-43.51-38.262-62.969-46.702-3.411-1.475-6.844-2.949-10.357-4.586-25.742-12.115-69.113-14.194-79.977-14.457l-213.062 10.379c-1.372 0.082-2.736 0.243-4.067 0.506l-179.798-236.605c-14.064-17.586-40.181-17.586-54.739-6.523l-248.75 189.317c-19.435 14.075-17.921 37.173-8.733 49.59l329.798 434.038c10.55 13.066 36.153 22.614 57.253 8.035l41.131-31.274c16.91 22.35 34.223 45.29 51.549 68.206 53.265 70.53 106.57 141.058 147.781 195.293 15.347 20.17 51.227 43.591 93.63 47.327 6.339 0.565 12.931 0.908 19.766 0.908 36.425 0 73.579-9.47 116.991-29.843 99.060-46.42 106.63-112.467 117.111-203.874l3.38-29.055c15.195-123.269 12.813-202.238-8.56-251.202zM955.46 723.996l-3.482 29.579c-10.169 88.662-14.378 125.349-84.161 158.1-35.426 16.599-64.813 24.333-92.436 24.333-5.076 0-9.945-0.263-14.678-0.666-25.614-2.263-46.965-17.226-52.669-24.735-41.18-54.174-94.428-124.643-147.651-195.133-55.303-73.214-110.61-146.409-152.173-201.046l-1.383-1.858c-3.634-5.37-6.341-11.227-7.997-17.545-4.058-14.983-2.018-30.612 5.714-44.038 7.713-13.408 20.211-23.039 35.174-27.058 4.935-1.311 9.994-1.998 15.013-1.998 18.142 0 35.467 8.723 46.571 23.502l85.371 108.106c4.663 6.116 11.57 10.135 19.202 11.166 7.593 0.908 15.385-1.070 21.466-5.775l42.593-32.77c2.353-1.817 4.435-3.979 6.129-6.422 2.636-3.795 15.467-24.087 10.198-50.842-3.171-16.074-16.731-32.651-20.778-37.031l-77.981-101.646 156.525-7.733c16.115 0.565 43.797 3.777 54.96 9.006 4.059 1.878 8.038 3.614 11.995 5.33 16.477 7.129 27.38 11.874 39.616 28.247 20.191 26.976 66.794 88.781 93.165 122.542 3.069 3.957 4.886 8.762 6.523 13.003l2.1 5.209c10.637 24.334 19.845 81.9 3.076 218.174z" fill="#333333" ></path><path d="M267.931 966.566c-119.894 2.82-230.151-77.858-259.806-198.987-12.992-52.995-9.102-107.84 11.21-158.67 6.58-16.494 25.255-24.528 41.769-17.949 16.474 6.581 24.489 25.295 17.938 41.79-15.335 38.313-18.281 79.665-8.485 119.525 25.811 105.427 132.722 170.107 238.022 144.42 17.242-4.123 34.657 6.334 38.859 23.584 4.203 17.251-6.334 34.649-23.565 38.848-18.705 4.583-37.461 7.003-55.942 7.44z" fill="#333333" ></path><path d="M308.86 824.967c-73.75 1.737-141.598-47.866-159.837-122.429-7.885-32.172-5.602-65.61 6.611-96.717 6.518-16.494 25.151-24.625 41.663-18.147 16.513 6.478 24.676 25.109 18.157 41.662-7.315 18.672-8.691 38.7-3.998 57.919 12.639 51.649 65.060 83.436 116.596 70.689 17.245-4.037 34.638 6.379 38.839 23.587 4.223 17.231-6.314 34.644-23.555 38.847-11.536 2.816-23.063 4.319-34.478 4.589z" fill="#333333" ></path><path d="" fill="#333333" ></path><path d="" fill="#333333" ></path></symbol><symbol id="icon-cheliang" viewBox="0 0 1024 1024"><path d="M838.656 878.08v-122.368H390.144v122.368H206.848V551.936l60.928-81.408h-30.72c-16.896 0-30.72-13.824-30.72-30.72s13.824-30.72 30.72-30.72h60.928c4.608 0 9.216 1.024 12.8 3.072L390.144 307.2h448.512l78.848 104.96c4.096-2.048 8.192-3.072 12.8-3.072h60.928c16.896 0 30.72 13.824 30.72 30.72s-13.824 30.72-30.72 30.72h-30.72l60.928 81.408V878.08h-182.784zM288.256 551.936c0 22.528 18.432 40.96 40.96 40.96h60.928c22.528 0 40.96-18.432 40.96-40.96s-18.432-40.96-40.96-40.96H329.216c-22.528 0-40.96 18.432-40.96 40.96zM808.96 348.16H415.744L324.096 470.528H901.12L808.96 348.16z m90.624 162.816h-60.928c-22.528 0-40.96 18.432-40.96 40.96s18.432 40.96 40.96 40.96h60.928c22.528 0 40.96-18.432 40.96-40.96s-18.432-40.96-40.96-40.96zM540.672 256h-20.992l22.528 30.208H487.936c-3.072-1.024-6.656-2.048-10.24-2.048h-41.984c-3.584 0-7.168 1.024-10.24 2.048H367.104L282.112 391.168c-4.096-2.048-8.704-3.072-13.824-3.072H202.752c-17.92 0-39.424 22.528-39.424 40.448 0 7.68 3.072 15.872 7.68 23.04h-47.616v78.848H3.072V311.808L44.544 256H23.552C11.776 256 2.56 246.784 2.56 235.008s9.216-20.992 20.992-20.992h41.984c3.072 0 6.144 1.024 8.704 2.048L128 143.872h307.2l53.76 72.192c2.56-1.024 5.632-2.048 8.704-2.048h41.984c11.776 0 20.992 9.216 20.992 20.992 1.024 11.776-8.704 20.992-19.968 20.992zM58.88 311.808c0 15.36 12.288 28.16 28.16 28.16h41.984c15.36 0 28.16-12.288 28.16-28.16 0-15.36-12.288-28.16-28.16-28.16H87.04c-15.872 0.512-28.16 12.8-28.16 28.16zM415.744 184.32H145.92l-49.152 63.488h371.712L415.744 184.32z"  ></path></symbol><symbol id="icon-zhuxiao" viewBox="0 0 1024 1024"><path d="M614.496 700v145.632H217.952V178.4h396.512v145.632h50.144v-156.48c0-21.664-17.632-39.264-39.264-39.264H207.104c-21.664 0-39.264 17.632-39.264 39.264v688.928c0 21.664 17.632 39.264 39.264 39.264h418.24c21.664 0 39.264-17.632 39.264-39.264v-156.48h-50.112z"  ></path><path d="M848.096 531.712a30.784 30.784 0 0 0 0-41.44l-122.464-130.496c-10.688-11.392-19.456-7.936-19.456 7.712v68.128a28.48 28.48 0 0 1-28.416 28.416h-194.752a28.48 28.48 0 0 0-28.416 28.416v37.152c0 15.648 12.8 28.416 28.416 28.416h194.752c15.648 0 28.416 12.8 28.416 28.416v68.128c0 15.648 8.768 19.104 19.456 7.712l122.464-130.56z"  ></path></symbol><symbol id="icon-yuechiquanxianchaxun" viewBox="0 0 1024 1024"><path d="M509.6 957.4C263.9 957.4 64 757.6 64 512 64 266.4 263.9 66.6 509.6 66.6c245.7 0 445.6 199.8 445.6 445.4-0.1 245.6-200 445.4-445.6 445.4z m0-838.4c-216.8 0-393.1 176.3-393.1 393s176.4 393 393.1 393c216.8 0 393.1-176.3 393.1-393S726.3 119 509.6 119z m265.9 487.4c0 9.5-7.7 17.1-17.2 17.1s-17.2-7.6-17.2-17.1v-85.8h-51.5v85.8c0 9.5-7.7 17.1-17.2 17.1s-17.2-7.6-17.2-17.1v-85.8H517.7c-4.5 86-75.5 154.4-162.6 154.4-90 0-163-73-163-163s73-163 163-163c81.2 0 148.4 59.5 160.8 137.3h294c9.5 0 17.2 7.7 17.2 17.2s-7.7 17.2-17.2 17.2h-34.3v85.7zM355.1 383.3c-71.1 0-128.7 57.6-128.7 128.7S284 640.7 355.1 640.7c71 0 128.7-57.6 128.7-128.7s-57.7-128.7-128.7-128.7z m533.2 441.4l61.4 54.4c11.9 10.6 13.8 27.9 4.2 38.8-9.6 10.8-27.1 11-39 0.4l-61.4-54.4c-11.9-10.6-13.8-27.9-4.2-38.8 9.6-10.8 27.1-11 39-0.4z" fill="#666666" ></path></symbol><symbol id="icon-baobiao" viewBox="0 0 1024 1024"><path d="M62.014 482.487c0-132.367-0.002-264.734 0.003-397.1 0-10.199 5.27-18.451 13.851-21.775 9.09-3.521 20.013-1.236 26.1 6.48 2.624 3.327 3.6 8.004 5.065 12.159 0.459 1.303 0.073 2.904 0.073 4.369 0 261.255 0.034 522.51-0.058 783.765-0.008 23.804 20.793 45.566 45.328 45.551 261.753-0.158 523.506-0.092 785.259-0.12 10.572-0.001 18.961 3.893 22.685 14.043 5.365 14.62-2.413 30.346-19.134 30.824-35.104 1.003-70.239 1.228-105.362 1.243-227.293 0.096-454.585 0.122-681.878-0.064-22.533-0.018-43.173-6.591-60.61-21.784C72.907 922.276 61.994 900.265 62 872.993c0.03-130.168 0.014-260.337 0.014-390.506z" fill="" ></path><path d="M563.365 372.171c11.628-11.036 23.214-22.095 34.868-33.081a26495.495 26495.495 0 0 1 55.734-52.376c10.62-9.953 21.322-19.818 31.963-29.75a16235.377 16235.377 0 0 0 35.078-32.851c1.293-1.214 2.458-2.565 4.503-4.717-12.285 0-23.543-0.137-34.797 0.039-10.802 0.169-20.337-8.528-21.409-20.748-0.889-10.138 5.096-20.625 16.853-23.21 2.789-0.613 5.679-1.059 8.525-1.071 21.078-0.089 42.156-0.122 63.234-0.029 24.438 0.108 40.862 14.099 46.29 37.16 0.369 1.567 0.173 3.276 0.173 4.92 0.009 23.616 0.012 47.231 0.003 70.847-0.005 12.514-9.389 22.041-21.601 22.192-13.357 0.164-23.258-9.908-23.457-22.263-0.18-11.163-0.093-22.33-0.133-33.495-0.001-0.156-0.117-0.312-0.36-0.919-3.087 2.521-6.242 4.787-9.036 7.435-10.2 9.666-20.207 19.536-30.421 29.187-18.132 17.131-36.355 34.165-54.553 51.226-11.554 10.831-23.145 21.622-34.695 32.458-12.617 11.838-24.834 24.134-37.902 35.451-14.877 12.883-35.836 14.53-52.127 4.034-8.285-5.338-15.463-12.487-22.775-19.214-9.936-9.14-19.416-18.772-29.281-27.992-15.949-14.907-32.051-29.649-48.154-44.521-4.742 4.209-9.694 8.38-14.392 12.818-9.815 9.274-19.426 18.763-29.247 28.029-17.877 16.868-35.839 33.645-53.778 50.447-11.425 10.701-22.96 21.285-34.284 32.092-12.948 12.357-25.282 25.399-38.749 37.154-6.524 5.695-11.493 13.499-20.766 16.135-13.462 3.827-29.456-5.302-29.515-21.032-0.035-9.359 3.788-15.844 10.899-21.582 5.472-4.415 9.692-10.341 14.759-15.3 9.638-9.434 19.425-18.718 29.262-27.944 6.218-5.832 12.728-11.354 18.947-17.184 8.782-8.233 17.357-16.686 26.126-24.933 17.371-16.337 34.801-32.611 52.232-48.883 10.372-9.683 20.874-19.227 31.167-28.992 10.434-9.899 22.392-16.25 37.065-16.25 13.98 0.001 25.908 5.367 35.97 14.866 15.776 14.893 31.402 29.946 47.161 44.857 11.504 10.884 23.102 21.668 34.709 32.442 1.697 1.572 3.674 2.841 5.911 4.548zM444.748 657.239c0 41.174 0.042 82.349-0.026 123.523-0.019 11.695-7.33 21.162-19.26 22.855-11.088 1.573-21.486-3.682-25.17-16.273-0.546-1.865-0.61-3.92-0.611-5.887-0.029-82.898-0.027-165.796-0.022-248.694 0.001-12.989 9.443-22.369 22.596-22.239 12.466 0.123 22.451 9.776 22.47 22.642 0.062 41.357 0.023 82.715 0.023 124.073zM804.386 657.711c0 41.35 0.005 82.701-0.003 124.051-0.003 12.192-9.391 21.818-21.168 22.062-13.755 0.285-23.812-9.742-23.835-21.819-0.161-83.249-0.178-166.499 0.017-249.749 0.029-12.277 9.903-21.688 22.746-21.734 12.819-0.046 22.238 9.371 22.241 22.04 0.007 41.716 0.002 83.433 0.002 125.149zM264.379 713.54c0 22.515-0.327 45.036 0.12 67.542 0.277 13.915-11.529 22.24-20.609 22.796-12.48 0.764-24.428-8.983-24.502-22.077-0.258-45.394-0.316-90.793 0.037-136.186 0.101-12.992 10.619-22.27 22.835-21.812 12.38 0.464 22.327 8.515 22.18 22.742-0.231 22.33-0.061 44.663-0.061 66.995zM580.024 713.123v-67.487c0.001-11.124 5.34-17.648 17.473-21.357 7.538-2.305 18.892 1.65 22.986 9.198 2.537 4.676 4.395 10.381 4.437 15.641 0.347 43.16 0.311 86.324 0.138 129.486-0.068 16.942-11.25 26.059-25.203 25.188-11.363-0.71-20.143-11.921-19.983-20.441 0.441-23.402 0.153-46.817 0.152-70.228z" fill="" ></path></symbol><symbol id="icon-safeboxkeyt" viewBox="0 0 1024 1024"><path d="M96.086 328.04c-17.644 0-31.992-14.356-31.992-31.994s14.348-31.994 31.992-31.994c17.646 0 31.994 14.358 31.994 31.994s-14.348 31.994-31.994 31.994z m0-47.992c-8.818 0-15.996 7.17-15.996 15.998s7.178 15.996 15.996 15.996 15.998-7.17 15.998-15.996-7.18-15.998-15.998-15.998z" fill="" ></path><path d="M96.562 304.044c-4.412 0-8.076-3.578-8.076-7.998 0-4.422 3.5-7.998 7.92-7.998h0.156c4.422 0 8 3.576 8 7.998a7.994 7.994 0 0 1-8 7.998zM96.086 567.988c-17.644 0-31.992-14.356-31.992-31.994 0-17.636 14.348-31.992 31.992-31.992 17.646 0 31.994 14.354 31.994 31.992s-14.348 31.994-31.994 31.994z m0-47.99c-8.818 0-15.996 7.17-15.996 15.996s7.178 15.998 15.996 15.998 15.998-7.172 15.998-15.998-7.18-15.996-15.998-15.996z" fill="" ></path><path d="M96.562 543.992c-4.412 0-8.076-3.576-8.076-7.998 0-4.42 3.5-7.998 7.92-7.998h0.156c4.422 0 8 3.578 8 7.998a7.994 7.994 0 0 1-8 7.998zM96.562 783.944c-4.412 0-8.076-3.576-8.076-7.998s3.5-7.998 7.92-7.998h0.156c4.422 0 8 3.576 8 7.998s-3.578 7.998-8 7.998zM416.02 807.938c-17.644 0-31.992-14.356-31.992-31.992s14.348-31.994 31.992-31.994c17.646 0 31.994 14.358 31.994 31.994s-14.348 31.992-31.994 31.992z m0-47.988c-8.818 0-15.996 7.17-15.996 15.996s7.178 15.996 15.996 15.996c8.82 0 15.998-7.17 15.998-15.996s-7.18-15.996-15.998-15.996z" fill="" ></path><path d="M416.496 783.944c-4.412 0-8.076-3.576-8.076-7.998s3.5-7.998 7.92-7.998h0.156c4.422 0 8 3.576 8 7.998s-3.578 7.998-8 7.998zM736.422 783.944c-4.404 0-8.06-3.576-8.06-7.998s3.5-7.998 7.904-7.998h0.156c4.438 0 7.998 3.576 7.998 7.998s-3.56 7.998-7.998 7.998zM735.956 328.04c-17.654 0-31.994-14.356-31.994-31.994s14.34-31.994 31.994-31.994c17.652 0 31.992 14.358 31.992 31.994s-14.34 31.994-31.992 31.994z m0-47.992c-8.812 0-15.998 7.17-15.998 15.998s7.186 15.996 15.998 15.996c8.808 0 15.996-7.17 15.996-15.996s-7.188-15.998-15.996-15.998z" fill="" ></path><path d="M736.422 304.044c-4.404 0-8.06-3.578-8.06-7.998 0-4.422 3.5-7.998 7.904-7.998h0.156a7.98 7.98 0 0 1 7.998 7.998c0 4.42-3.56 7.998-7.998 7.998zM416.496 304.044c-4.412 0-8.076-3.578-8.076-7.998 0-4.422 3.5-7.998 7.92-7.998h0.156c4.422 0 8 3.576 8 7.998a7.994 7.994 0 0 1-8 7.998z" fill="" ></path><path d="M967.906 903.918H8.106c-4.422 0-8-3.576-8-7.998V176.07a7.994 7.994 0 0 1 8-7.998h959.8a7.994 7.994 0 0 1 7.998 7.998V895.92a7.994 7.994 0 0 1-7.998 7.998zM16.104 887.922h943.804V184.07H16.104v703.852z" fill="" ></path><path d="M328.04 903.918c-4.422 0-8-3.576-8-7.998V176.07a7.994 7.994 0 0 1 8-7.998 7.994 7.994 0 0 1 7.998 7.998V895.92a7.994 7.994 0 0 1-7.998 7.998zM647.972 903.918a7.992 7.992 0 0 1-7.998-7.998V176.07a7.994 7.994 0 0 1 7.998-7.998 7.994 7.994 0 0 1 7.998 7.998V895.92a7.994 7.994 0 0 1-7.998 7.998z" fill="" ></path><path d="M408.022 424.018H8.106c-4.422 0-8-3.578-8-7.998s3.578-7.998 8-7.998h399.916c4.422 0 7.998 3.578 7.998 7.998s-3.576 7.998-7.998 7.998zM440.016 663.968H8.106c-4.422 0-8-3.578-8-8a7.994 7.994 0 0 1 8-7.996h431.91a7.992 7.992 0 0 1 7.998 7.996c0 4.422-3.578 8-7.998 8zM393.432 312.166a8.002 8.002 0 0 1-7.53-5.294 32.146 32.146 0 0 1-1.874-10.826c0-17.636 14.348-31.994 31.992-31.994 17.646 0 31.994 14.358 31.994 31.994 0 3.67-0.618 7.264-1.836 10.686-1.5 4.138-6.076 6.388-10.224 4.842a8.002 8.002 0 0 1-4.85-10.216 15.602 15.602 0 0 0 0.914-5.31c0-8.826-7.178-15.998-15.998-15.998-8.818 0-15.996 7.17-15.996 15.998 0 1.858 0.312 3.686 0.938 5.42a7.992 7.992 0 0 1-7.53 10.698z" fill="" ></path><path d="M416.02 395.9a7.98 7.98 0 0 1-5.654-2.342l-33.93-33.93a7.996 7.996 0 0 1 0-11.31l33.93-33.93a7.996 7.996 0 0 1 11.31 0l33.93 33.93a7.996 7.996 0 0 1 0 11.31l-33.93 33.93a7.982 7.982 0 0 1-5.656 2.342z m-22.62-41.928l22.62 22.62 22.622-22.62-22.622-22.622-22.62 22.622zM736.704 543.992c-4.42 0-8.092-3.576-8.092-7.998 0-4.42 3.5-7.998 7.936-7.998h0.156a8.004 8.004 0 0 1 7.998 7.998 8.002 8.002 0 0 1-7.998 7.998z" fill="" ></path><path d="M713.63 552.118a8.004 8.004 0 0 1-7.532-5.296 32.396 32.396 0 0 1-1.874-10.826c0-17.636 14.356-31.992 31.992-31.992 17.638 0 31.994 14.354 31.994 31.992a31.76 31.76 0 0 1-1.828 10.686c-1.5 4.14-6.092 6.344-10.232 4.844a8.014 8.014 0 0 1-4.858-10.216 15.288 15.288 0 0 0 0.922-5.312c0-8.826-7.172-15.996-15.998-15.996s-15.996 7.17-15.996 15.996c0 1.86 0.312 3.688 0.938 5.422a8.002 8.002 0 0 1-4.826 10.232 8.366 8.366 0 0 1-2.702 0.466z" fill="" ></path><path d="M736.218 631.974a8.054 8.054 0 0 1-5.014-1.766l-39.726-31.992a7.988 7.988 0 0 1-2.984-6.232c0-2.422 1.094-4.718 2.984-6.234l39.726-31.992a8.032 8.032 0 0 1 10.03 0l39.724 31.992a7.99 7.99 0 0 1 2.984 6.234c0 2.42-1.094 4.716-2.984 6.232l-39.724 31.992a8.05 8.05 0 0 1-5.016 1.766z m-26.978-39.99l26.978 21.728 26.978-21.728-26.978-21.73-26.978 21.73zM73.498 792.066a8 8 0 0 1-7.53-5.294 32.146 32.146 0 0 1-1.874-10.826c0-17.636 14.348-31.994 31.992-31.994 17.646 0 31.994 14.358 31.994 31.994 0 3.672-0.618 7.264-1.836 10.686-1.5 4.138-6.076 6.342-10.224 4.842a8 8 0 0 1-4.85-10.216 15.642 15.642 0 0 0 0.914-5.31c0-8.826-7.178-15.996-15.998-15.996s-15.996 7.17-15.996 15.996c0 1.86 0.312 3.688 0.938 5.42a7.992 7.992 0 0 1-7.53 10.698z" fill="" ></path><path d="M96.086 871.926a8.02 8.02 0 0 1-5.014-1.766l-39.726-31.994c-1.89-1.514-2.984-3.81-2.984-6.232s1.094-4.718 2.984-6.234l39.726-31.992a8.032 8.032 0 0 1 10.03 0l39.726 31.992c1.89 1.516 2.984 3.812 2.984 6.234s-1.094 4.718-2.984 6.232L101.102 870.16a8.02 8.02 0 0 1-5.016 1.766z m-26.97-39.992l26.97 21.73 26.972-21.73-26.972-21.73-26.97 21.73zM713.63 792.066a8.004 8.004 0 0 1-7.532-5.294 32.396 32.396 0 0 1-1.874-10.826c0-17.636 14.356-31.994 31.992-31.994 17.638 0 31.994 14.358 31.994 31.994a31.76 31.76 0 0 1-1.828 10.686c-1.5 4.138-6.092 6.342-10.232 4.842a8.014 8.014 0 0 1-4.858-10.216 15.27 15.27 0 0 0 0.922-5.31c0-8.826-7.172-15.996-15.998-15.996s-15.996 7.17-15.996 15.996c0 1.86 0.312 3.688 0.938 5.42a8 8 0 0 1-4.826 10.232 8.312 8.312 0 0 1-2.702 0.466z" fill="" ></path><path d="M736.218 871.926a8.054 8.054 0 0 1-5.014-1.766l-39.726-31.994c-1.89-1.514-2.984-3.81-2.984-6.232s1.094-4.718 2.984-6.234l39.726-31.992a8.032 8.032 0 0 1 10.03 0l39.724 31.992c1.89 1.516 2.984 3.812 2.984 6.234s-1.094 4.718-2.984 6.232l-39.724 31.994a8.05 8.05 0 0 1-5.016 1.766z m-26.978-39.992l26.978 21.73 26.978-21.73-26.978-21.73-26.978 21.73zM472.008 679.964a8 8 0 0 1-8-7.998V400.024c0-2.25 0.946-4.39 2.602-5.906 1.664-1.532 3.936-2.202 6.124-2.062l175.958 15.996a8 8 0 0 1 7.28 7.966v239.948a8 8 0 0 1-7.28 7.968l-175.958 15.996c-0.242 0.02-0.484 0.034-0.726 0.034z m7.998-271.176v254.416l159.968-14.542V423.332l-159.968-14.544z" fill="" ></path><path d="M967.906 424.018H647.972c-4.422 0-7.998-3.578-7.998-7.998s3.576-7.998 7.998-7.998h319.934c4.42 0 7.998 3.578 7.998 7.998s-3.578 7.998-7.998 7.998zM967.906 663.968H647.972a7.994 7.994 0 0 1-7.998-8 7.992 7.992 0 0 1 7.998-7.996h319.934a7.992 7.992 0 0 1 7.998 7.996c0 4.422-3.578 8-7.998 8zM535.994 567.988c-13.458 0-23.994-14.058-23.994-31.994 0-17.934 10.538-31.992 23.994-31.992 13.466 0 23.996 14.058 23.996 31.992 0 17.936-10.53 31.994-23.996 31.994z m0-47.99c-3.186 0-7.996 6.374-7.996 15.996s4.81 15.998 7.996 15.998c3.266 0 8-6.234 8-15.998s-4.734-15.996-8-15.996z" fill="" ></path><path d="M536.462 543.992c-4.404 0-8.058-3.576-8.058-7.998 0-4.42 3.498-7.998 7.902-7.998h0.156c4.438 0 8 3.578 8 7.998a7.984 7.984 0 0 1-8 7.998zM408.022 631.974h-47.99a7.994 7.994 0 0 1-7.998-7.998v-127.972a7.994 7.994 0 0 1 7.998-7.998h47.99c4.422 0 7.998 3.578 7.998 7.998s-3.576 8-7.998 8h-39.992v111.976h39.992c4.422 0 7.998 3.576 7.998 7.998s-3.576 7.996-7.998 7.996z" fill="" ></path><path d="M360.032 504.002a7.996 7.996 0 0 1-5.654-13.654l31.994-31.994a7.996 7.996 0 1 1 11.31 11.31l-31.992 31.994a7.98 7.98 0 0 1-5.658 2.344z" fill="" ></path><path d="M408.022 472.008h-15.996c-4.422 0-7.998-3.578-7.998-7.998s3.576-7.998 7.998-7.998h15.996c4.422 0 7.998 3.578 7.998 7.998s-3.576 7.998-7.998 7.998zM967.906 184.07a7.996 7.996 0 0 1-5.656-13.654l47.99-47.99a7.996 7.996 0 1 1 11.31 11.31L973.56 181.726a7.972 7.972 0 0 1-5.654 2.344zM8.106 184.07a7.996 7.996 0 0 1-5.656-13.654L50.44 122.424a7.996 7.996 0 1 1 11.31 11.31L13.76 181.726a7.972 7.972 0 0 1-5.654 2.344zM967.906 903.918a7.994 7.994 0 0 1-5.656-13.652l47.99-47.99a7.996 7.996 0 1 1 11.31 11.31l-47.99 47.988a7.972 7.972 0 0 1-5.654 2.344z" fill="" ></path><path d="M1015.896 855.93c-4.422 0-8-3.578-8-8V128.082c0-4.422 3.578-8 8-8a7.994 7.994 0 0 1 7.998 8v719.848c0 4.422-3.578 8-7.998 8z" fill="" ></path><path d="M1015.896 136.08H56.094a7.994 7.994 0 0 1-7.998-7.998c0-4.422 3.578-8 7.998-8h959.802a7.994 7.994 0 0 1 7.998 8 7.996 7.996 0 0 1-7.998 7.998zM472.008 408.022h-31.994a7.994 7.994 0 0 1-7.998-7.998 7.992 7.992 0 0 1 7.998-7.998h31.994a7.994 7.994 0 0 1 7.998 7.998 7.994 7.994 0 0 1-7.998 7.998zM472.008 679.964h-31.994c-4.422 0-7.998-3.578-7.998-7.998s3.576-7.998 7.998-7.998h31.994c4.42 0 7.998 3.578 7.998 7.998s-3.576 7.998-7.998 7.998z" fill="" ></path><path d="M440.016 679.964a7.994 7.994 0 0 1-7.998-7.998V400.024a7.992 7.992 0 0 1 7.998-7.998 7.994 7.994 0 0 1 7.998 7.998v271.942a7.994 7.994 0 0 1-7.998 7.998z" fill="" ></path></symbol><symbol id="icon-yonghuming" viewBox="0 0 1024 1024"><path d="M633.344 532.48c159.744 55.808 276.992 218.624 287.232 413.696 0.512 14.336-11.264 26.624-26.112 26.624H128.512c-14.336 0-26.624-12.288-26.112-26.624 9.728-195.584 128-357.888 287.744-413.696C310.272 488.96 256 404.48 256 307.2c0-141.312 114.688-256 256-256s256 114.688 256 256c0 97.28-54.784 182.272-134.656 225.28z m-121.856 30.72c-181.76 0-333.312 155.136-355.84 358.4h711.168c-22.016-203.264-173.568-358.4-355.328-358.4z m0.512-51.2c113.152 0 204.8-91.648 204.8-204.8s-91.648-204.8-204.8-204.8-204.8 91.648-204.8 204.8 91.648 204.8 204.8 204.8z"  ></path></symbol><symbol id="icon-shouye" viewBox="0 0 1024 1024"><path d="M512 181.384L114.552 532.96 77.448 491.04 512 106.616l434.552 384.416-37.104 41.936L512 181.384zM444 652v256h-280V528h56v324h168v-256h248v256h168V528h56v380h-280v-256h-136z m354.856-325.272V212.576H678.544v-56h176.312v170.16h-56z"  ></path></symbol><symbol id="icon-tuichu" viewBox="0 0 1039 1024"><path d="M845.288151 705.088444l-48.28429-48.277185L907.71663 546.12995H478.001982v-68.2599h426.497522L777.867544 351.275639l51.50446-51.494311L1039.02002 510.386363zM512.143096 68.26802c-245.136872 0-443.858838 198.665134-443.858838 443.73198S267.011298 955.72995 512.143096 955.72995c125.632317 0 238.527049-52.661407 319.276908-136.52995h89.745633C827.707623 943.348583 679.534113 1024 512.143096 1024 229.292781 1024 0 794.77217 0 512S229.292781 0 512.143096 0C679.534113 0 827.706609 80.648373 921.163608 204.8h-89.747664C750.668115 120.935516 637.774398 68.26802 512.143096 68.26802z"  ></path></symbol><symbol id="icon-guizi" viewBox="0 0 1024 1024"><path d="M540.444444 56.888889h284.444445a56.888889 56.888889 0 0 1 56.888889 56.888889v597.333333H540.444444V56.888889z m-56.888888 0v654.222222H142.222222V113.777778a56.888889 56.888889 0 0 1 56.888889-56.888889h284.444445z m398.222222 711.111111v142.222222a56.888889 56.888889 0 0 1-56.888889 56.888889H199.111111a56.888889 56.888889 0 0 1-56.888889-56.888889v-142.222222h739.555556z m-398.222222 99.555556h56.888888a28.444444 28.444444 0 0 0 0-56.888889h-56.888888a28.444444 28.444444 0 0 0 0 56.888889zM369.777778 398.222222v56.888889a28.444444 28.444444 0 0 0 56.888889 0v-56.888889a28.444444 28.444444 0 0 0-56.888889 0z m227.555555 0v56.888889a28.444444 28.444444 0 0 0 56.888889 0v-56.888889a28.444444 28.444444 0 0 0-56.888889 0z"  ></path></symbol></svg>',
      a = (c = document.getElementsByTagName("script"))[c.length - 1].getAttribute("data-injectcss");if (a && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (c) {
      console && console.log(c);
    }
  }!function (c) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) setTimeout(c, 0);else {
        var a = function a() {
          document.removeEventListener("DOMContentLoaded", a, !1), c();
        };document.addEventListener("DOMContentLoaded", a, !1);
      }
    } else document.attachEvent && (t = c, h = e.document, i = !1, (_s = function s() {
      try {
        h.documentElement.doScroll("left");
      } catch (c) {
        return void setTimeout(_s, 50);
      }l();
    })(), h.onreadystatechange = function () {
      "complete" == h.readyState && (h.onreadystatechange = null, l());
    });function l() {
      i || (i = !0, t());
    }var t, h, i, _s;
  }(function () {
    var c, a;(c = document.createElement("div")).innerHTML = l, l = null, (a = c.getElementsByTagName("svg")[0]) && (a.setAttribute("aria-hidden", "true"), a.style.position = "absolute", a.style.width = 0, a.style.height = 0, a.style.overflow = "hidden", function (c, a) {
      a.firstChild ? function (c, a) {
        a.parentNode.insertBefore(c, a);
      }(c, a.firstChild) : a.appendChild(c);
    }(a, document.body));
  });
}(window);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["timeAgo"] = timeAgo;
/* harmony export (immutable) */ __webpack_exports__["parseTime"] = parseTime;
/* harmony export (immutable) */ __webpack_exports__["formatTime"] = formatTime;
/* harmony export (immutable) */ __webpack_exports__["nFormatter"] = nFormatter;
/* harmony export (immutable) */ __webpack_exports__["html2Text"] = html2Text;
/* harmony export (immutable) */ __webpack_exports__["toThousandslsFilter"] = toThousandslsFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}
function timeAgo(time) {
  var between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

function parseTime(time, cFormat) {
  if (!time || time === 'undefined' || time == null) {
    return;
  }
  if (arguments.length === 0) {
    return null;
  }

  if ((time + '').length === 10) {
    time = +time * 1000;
  }

  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(time)) == 'object') {
    date = time;
  } else {
    date = new Date(parseInt(time));
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return 'Just Now';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + 'mintue(s) ago';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + 'hour(s) ago';
  } else if (diff < 3600 * 24 * 2) {
    return 'One day ago';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + 'month' + d.getDate() + 'day' + d.getHours() + 'hour' + d.getMinutes() + 'mintue';
  }
}

/* 数字 格式化*/
function nFormatter(num, digits) {
  var si = [{ value: 1E18, symbol: 'E' }, { value: 1E15, symbol: 'P' }, { value: 1E12, symbol: 'T' }, { value: 1E9, symbol: 'G' }, { value: 1E6, symbol: 'M' }, { value: 1E3, symbol: 'k' }];
  for (var i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}

function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, function (m) {
    return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
  });
}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(892)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(894),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__permission__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(86);




//批量注册指令(现在就一个permission)
var directives = {
    permission: __WEBPACK_IMPORTED_MODULE_1__permission__["a" /* default */]
    /**
     * 如果不是按钮，而是要隐藏某个页签可以使用自定义属性，通过v-if判断
     * 使用示例 <el-tab-pane  label="配置"  v-if="$has('Home')"></el-tab-pane>
     */
};__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$permission = function (val) {
    var pers = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.permission.functionCodeList;
    var perBool = false;
    pers.some(function (item) {
        if (item === val) {
            perBool = true;
        }
    });
    //最终的结果需要是boolean类型
    return perBool;
};
//注册的一般写法，循环遍历directives，通过vue.directive注册
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(directives).forEach(function (key) {
            Vue.directive(key, directives[key]);
        });
    }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(86);


/* harmony default export */ __webpack_exports__["a"] = ({
    inserted: function inserted(el, bindling) {
        //console.log(el,bindling,"99999999")
        //bindling.value为指令的绑定值
        var perVal = bindling.value;
        if (bindling.value) {
            //假设某用户对某模块只有添加和删除的权限
            //这个权限信息(即pers)应该是不同用户登录时从后台拿到的对应的信息
            //console.log(store.state.permission.functionCodeList,"90")
            var pers = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.permission.functionCodeList;
            //hasPer为true为有权限
            //hasPer为false为无权限
            var hasPer = pers.some(function (item) {
                return item == perVal;
            });
            //没有权限就先隐藏此元素吧
            if (!hasPer) {
                el.style.display = "none";
            }
        }
    }
});

/***/ }),
/* 897 */,
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(945),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__digitalFlop_src_main_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__digitalFlop_src_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__digitalFlop_src_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__);


//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvActiveRingChart',
  components: {
    dvDigitalFlop: __WEBPACK_IMPORTED_MODULE_3__digitalFlop_src_main_vue___default.a
  },
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        /**
         * @description Ring radius
         * @type {String|Number}
         * @default radius = '50%'
         * @example radius = '50%' | 100
         */
        radius: '50%',
        /**
         * @description Active ring radius
         * @type {String|Number}
         * @default activeRadius = '55%'
         * @example activeRadius = '55%' | 110
         */
        activeRadius: '55%',
        /**
         * @description Ring data
         * @type {Array<Object>}
         * @default data = [{ name: '', value: 0 }]
         */
        data: [{ name: '', value: 0 }],
        /**
         * @description Ring line width
         * @type {Number}
         * @default lineWidth = 20
         */
        lineWidth: 20,
        /**
         * @description Active time gap (ms)
         * @type {Number}
         * @default activeTimeGap = 3000
         */
        activeTimeGap: 3000,
        /**
         * @description Ring color (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default color = [Charts Default Color]
         * @example color = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        color: [],
        /**
         * @description Digital flop style
         * @type {Object}
         */
        digitalFlopStyle: {
          fontSize: 25,
          fill: '#fff'
        },
        /**
         * @description Digital flop toFixed
         * @type {Number}
         */
        digitalFlopToFixed: 0,
        /**
         * @description Digital flop unit
         * @type {String}
         */
        digitalFlopUnit: '',
        /**
         * @description CRender animationCurve
         * @type {String}
         * @default animationCurve = 'easeOutCubic'
         */
        animationCurve: 'easeOutCubic',
        /**
         * @description CRender animationFrame
         * @type {String}
         * @default animationFrame = 50
         */
        animationFrame: 50,
        /**
         * @description showOriginValue
         * @type {Boolean}
         * @default showOriginValue = false
         */
        showOriginValue: false
      },

      mergedConfig: null,

      chart: null,

      activeIndex: 0,

      animationHandler: ''
    };
  },

  computed: {
    digitalFlop: function digitalFlop() {
      var mergedConfig = this.mergedConfig,
          activeIndex = this.activeIndex;


      if (!mergedConfig) return {};

      var digitalFlopStyle = mergedConfig.digitalFlopStyle,
          digitalFlopToFixed = mergedConfig.digitalFlopToFixed,
          data = mergedConfig.data,
          showOriginValue = mergedConfig.showOriginValue,
          digitalFlopUnit = mergedConfig.digitalFlopUnit;


      var value = data.map(function (_ref) {
        var value = _ref.value;
        return value;
      });

      var displayValue = void 0;

      if (showOriginValue) {
        displayValue = value[activeIndex];
      } else {
        var sum = value.reduce(function (all, v) {
          return all + v;
        }, 0);

        var percent = parseFloat(value[activeIndex] / sum * 100) || 0;

        displayValue = percent;
      }

      return {
        content: showOriginValue ? '{nt}' + digitalFlopUnit : '{nt}' + (digitalFlopUnit || '%'),
        number: [displayValue],
        style: digitalFlopStyle,
        toFixed: digitalFlopToFixed
      };
    },
    ringName: function ringName() {
      var mergedConfig = this.mergedConfig,
          activeIndex = this.activeIndex;


      if (!mergedConfig) return '';

      return mergedConfig.data[activeIndex].name;
    },
    fontSize: function fontSize() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '';

      return 'font-size: ' + mergedConfig.digitalFlopStyle.fontSize + 'px;';
    }
  },
  watch: {
    config: function config() {
      var animationHandler = this.animationHandler,
          mergeConfig = this.mergeConfig,
          setRingOption = this.setRingOption;


      clearTimeout(animationHandler);

      this.activeIndex = 0;

      mergeConfig();

      setRingOption();
    }
  },
  methods: {
    init: function init() {
      var initChart = this.initChart,
          mergeConfig = this.mergeConfig,
          setRingOption = this.setRingOption;


      initChart();

      mergeConfig();

      setRingOption();
    },
    initChart: function initChart() {
      var $refs = this.$refs;


      this.chart = new __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts___default.a($refs['active-ring-chart']);
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});
    },
    setRingOption: function setRingOption() {
      var getRingOption = this.getRingOption,
          chart = this.chart,
          ringAnimation = this.ringAnimation;


      var option = getRingOption();

      chart.setOption(option, true);

      ringAnimation();
    },
    getRingOption: function getRingOption() {
      var mergedConfig = this.mergedConfig,
          getRealRadius = this.getRealRadius;


      var radius = getRealRadius();

      mergedConfig.data.forEach(function (dataItem) {
        dataItem.radius = radius;
      });

      return {
        series: [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          type: 'pie'
        }, mergedConfig, {
          outsideLabel: {
            show: false
          }
        })],
        color: mergedConfig.color
      };
    },
    getRealRadius: function getRealRadius() {
      var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var mergedConfig = this.mergedConfig,
          chart = this.chart;
      var radius = mergedConfig.radius,
          activeRadius = mergedConfig.activeRadius,
          lineWidth = mergedConfig.lineWidth;


      var maxRadius = Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(chart.render.area)) / 2;

      var halfLineWidth = lineWidth / 2;

      var realRadius = active ? activeRadius : radius;

      if (typeof realRadius !== 'number') realRadius = parseInt(realRadius) / 100 * maxRadius;

      var insideRadius = realRadius - halfLineWidth;
      var outSideRadius = realRadius + halfLineWidth;

      return [insideRadius, outSideRadius];
    },
    ringAnimation: function ringAnimation() {
      var _this = this;

      var activeIndex = this.activeIndex,
          getRingOption = this.getRingOption,
          chart = this.chart,
          getRealRadius = this.getRealRadius;


      var radius = getRealRadius();
      var active = getRealRadius(true);

      var option = getRingOption();

      var data = option.series[0].data;


      data.forEach(function (dataItem, i) {
        if (i === activeIndex) {
          dataItem.radius = active;
        } else {
          dataItem.radius = radius;
        }
      });

      chart.setOption(option, true);

      var activeTimeGap = option.series[0].activeTimeGap;


      this.animationHandler = setTimeout(function (foo) {
        activeIndex += 1;

        if (activeIndex >= data.length) activeIndex = 0;

        _this.activeIndex = activeIndex;

        _this.ringAnimation();
      }, activeTimeGap);
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  },
  beforeDestroy: function beforeDestroy() {
    var animationHandler = this.animationHandler;


    clearTimeout(animationHandler);
  }
});

/***/ }),
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return a; });
var a = /* @__PURE__ */function (f) {
  return f.transparent = "rgba(0,0,0,0)", f.black = "#000000", f.silver = "#C0C0C0", f.gray = "#808080", f.white = "#FFFFFF", f.maroon = "#800000", f.red = "#FF0000", f.purple = "#800080", f.fuchsia = "#FF00FF", f.green = "#008000", f.lime = "#00FF00", f.olive = "#808000", f.yellow = "#FFFF00", f.navy = "#000080", f.blue = "#0000FF", f.teal = "#008080", f.aqua = "#00FFFF", f.aliceblue = "#f0f8ff", f.antiquewhite = "#faebd7", f.aquamarine = "#7fffd4", f.azure = "#f0ffff", f.beige = "#f5f5dc", f.bisque = "#ffe4c4", f.blanchedalmond = "#ffebcd", f.blueviolet = "#8a2be2", f.brown = "#a52a2a", f.burlywood = "#deb887", f.cadetblue = "#5f9ea0", f.chartreuse = "#7fff00", f.chocolate = "#d2691e", f.coral = "#ff7f50", f.cornflowerblue = "#6495ed", f.cornsilk = "#fff8dc", f.crimson = "#dc143c", f.cyan = "#00ffff", f.darkblue = "#00008b", f.darkcyan = "#008b8b", f.darkgoldenrod = "#b8860b", f.darkgray = "#a9a9a9", f.darkgreen = "#006400", f.darkgrey = "#a9a9a9", f.darkkhaki = "#bdb76b", f.darkmagenta = "#8b008b", f.darkolivegreen = "#556b2f", f.darkorange = "#ff8c00", f.darkorchid = "#9932cc", f.darkred = "#8b0000", f.darksalmon = "#e9967a", f.darkseagreen = "#8fbc8f", f.darkslateblue = "#483d8b", f.darkslategray = "#2f4f4f", f.darkslategrey = "#2f4f4f", f.darkturquoise = "#00ced1", f.darkviolet = "#9400d3", f.deeppink = "#ff1493", f.deepskyblue = "#00bfff", f.dimgray = "#696969", f.dimgrey = "#696969", f.dodgerblue = "#1e90ff", f.firebrick = "#b22222", f.floralwhite = "#fffaf0", f.forestgreen = "#228b22", f.gainsboro = "#dcdcdc", f.ghostwhite = "#f8f8ff", f.gold = "#ffd700", f.goldenrod = "#daa520", f.greenyellow = "#adff2f", f.grey = "#808080", f.honeydew = "#f0fff0", f.hotpink = "#ff69b4", f.indianred = "#cd5c5c", f.indigo = "#4b0082", f.ivory = "#fffff0", f.khaki = "#f0e68c", f.lavender = "#e6e6fa", f.lavenderblush = "#fff0f5", f.lawngreen = "#7cfc00", f.lemonchiffon = "#fffacd", f.lightblue = "#add8e6", f.lightcoral = "#f08080", f.lightcyan = "#e0ffff", f.lightgoldenrodyellow = "#fafad2", f.lightgray = "#d3d3d3", f.lightgreen = "#90ee90", f.lightgrey = "#d3d3d3", f.lightpink = "#ffb6c1", f.lightsalmon = "#ffa07a", f.lightseagreen = "#20b2aa", f.lightskyblue = "#87cefa", f.lightslategray = "#778899", f.lightslategrey = "#778899", f.lightsteelblue = "#b0c4de", f.lightyellow = "#ffffe0", f.limegreen = "#32cd32", f.linen = "#faf0e6", f.magenta = "#ff00ff", f.mediumaquamarine = "#66cdaa", f.mediumblue = "#0000cd", f.mediumorchid = "#ba55d3", f.mediumpurple = "#9370db", f.mediumseagreen = "#3cb371", f.mediumslateblue = "#7b68ee", f.mediumspringgreen = "#00fa9a", f.mediumturquoise = "#48d1cc", f.mediumvioletred = "#c71585", f.midnightblue = "#191970", f.mintcream = "#f5fffa", f.mistyrose = "#ffe4e1", f.moccasin = "#ffe4b5", f.navajowhite = "#ffdead", f.oldlace = "#fdf5e6", f.olivedrab = "#6b8e23", f.orange = "#ffa500", f.orangered = "#ff4500", f.orchid = "#da70d6", f.palegoldenrod = "#eee8aa", f.palegreen = "#98fb98", f.paleturquoise = "#afeeee", f.palevioletred = "#db7093", f.papayawhip = "#ffefd5", f.peachpuff = "#ffdab9", f.peru = "#cd853f", f.pink = "#ffc0cb", f.plum = "#dda0dd", f.powderblue = "#b0e0e6", f.rosybrown = "#bc8f8f", f.royalblue = "#4169e1", f.saddlebrown = "#8b4513", f.salmon = "#fa8072", f.sandybrown = "#f4a460", f.seagreen = "#2e8b57", f.seashell = "#fff5ee", f.sienna = "#a0522d", f.skyblue = "#87ceeb", f.slateblue = "#6a5acd", f.slategray = "#708090", f.snow = "#fffafa", f.springgreen = "#00ff7f", f.steelblue = "#4682b4", f.tan = "#d2b48c", f.thistle = "#d8bfd8", f.tomato = "#ff6347", f.turquoise = "#40e0d0", f.violet = "#ee82ee", f.wheat = "#f5deb3", f.whitesmoke = "#f5f5f5", f.yellowgreen = "#9acd32", f;
}(a || {});


/***/ }),
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_c_render__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_c_render___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_c_render__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_extend_index__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_extend_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_extend_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__);

//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDigitalFlop',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      renderer: null,

      defaultConfig: {
        /**
         * @description Number for digital flop
         * @type {Array<Number>}
         * @default number = []
         * @example number = [10]
         */
        number: [],
        /**
         * @description Content formatter
         * @type {String}
         * @default content = ''
         * @example content = '{nt}个'
         */
        content: '',
        /**
         * @description Number toFixed
         * @type {Number}
         * @default toFixed = 0
         */
        toFixed: 0,
        /**
         * @description Text align
         * @type {String}
         * @default textAlign = 'center'
         * @example textAlign = 'center' | 'left' | 'right'
         */
        textAlign: 'center',
        /**
         * @description rowGap
         * @type {Number}
         @default rowGap = 0
         */
        rowGap: 0,
        /**
         * @description Text style configuration
         * @type {Object} {CRender Class Style}
         */
        style: {
          fontSize: 30,
          fill: '#3de7c9'
        },
        /**
         * @description Number formatter
         * @type {Null|Function}
         */
        formatter: undefined,
        /**
         * @description CRender animationCurve
         * @type {String}
         * @default animationCurve = 'easeOutCubic'
         */
        animationCurve: 'easeOutCubic',
        /**
         * @description CRender animationFrame
         * @type {String}
         * @default animationFrame = 50
         */
        animationFrame: 50
      },

      mergedConfig: null,

      graph: null
    };
  },

  watch: {
    config: function config() {
      var update = this.update;


      update();
    }
  },
  methods: {
    init: function init() {
      var initRender = this.initRender,
          mergeConfig = this.mergeConfig,
          initGraph = this.initGraph;


      initRender();

      mergeConfig();

      initGraph();
    },
    initRender: function initRender() {
      var $refs = this.$refs;


      this.renderer = new __WEBPACK_IMPORTED_MODULE_1__jiaminghi_c_render___default.a($refs['digital-flop']);
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});
    },
    initGraph: function initGraph() {
      var getShape = this.getShape,
          getStyle = this.getStyle,
          renderer = this.renderer,
          mergedConfig = this.mergedConfig;
      var animationCurve = mergedConfig.animationCurve,
          animationFrame = mergedConfig.animationFrame;


      var shape = getShape();
      var style = getStyle();

      this.graph = renderer.add({
        name: 'numberText',
        animationCurve: animationCurve,
        animationFrame: animationFrame,
        shape: shape,
        style: style
      });
    },
    getShape: function getShape() {
      var _mergedConfig = this.mergedConfig,
          number = _mergedConfig.number,
          content = _mergedConfig.content,
          toFixed = _mergedConfig.toFixed,
          textAlign = _mergedConfig.textAlign,
          rowGap = _mergedConfig.rowGap,
          formatter = _mergedConfig.formatter;

      var _renderer$area = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(this.renderer.area, 2),
          w = _renderer$area[0],
          h = _renderer$area[1];

      var position = [w / 2, h / 2];

      if (textAlign === 'left') position[0] = 0;
      if (textAlign === 'right') position[0] = w;

      return {
        number: number,
        content: content,
        toFixed: toFixed,
        position: position,
        rowGap: rowGap,
        formatter: formatter
      };
    },
    getStyle: function getStyle() {
      var _mergedConfig2 = this.mergedConfig,
          style = _mergedConfig2.style,
          textAlign = _mergedConfig2.textAlign;


      return Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__["deepMerge"])(style, {
        textAlign: textAlign,
        textBaseline: 'middle'
      });
    },
    update: function update() {
      var mergeConfig = this.mergeConfig,
          mergeShape = this.mergeShape,
          getShape = this.getShape,
          getStyle = this.getStyle,
          graph = this.graph,
          mergedConfig = this.mergedConfig;


      graph.animationEnd();

      mergeConfig();

      if (!graph) return;

      var animationCurve = mergedConfig.animationCurve,
          animationFrame = mergedConfig.animationFrame;


      var shape = getShape();
      var style = getStyle();

      mergeShape(graph, shape);

      graph.animationCurve = animationCurve;
      graph.animationFrame = animationFrame;

      graph.animation('style', style, true);
      graph.animation('shape', shape);
    },
    mergeShape: function mergeShape(graph, shape) {
      var cacheNum = graph.shape.number.length;
      var shapeNum = shape.number.length;

      if (cacheNum !== shapeNum) graph.shape.number = shape.number;
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  }
});

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dv-digital-flop"
  }, [_c('canvas', {
    ref: "digital-flop"
  })])
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dv-active-ring-chart"
  }, [_c('div', {
    ref: "active-ring-chart",
    staticClass: "active-ring-chart-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "active-ring-info"
  }, [_c('dv-digital-flop', {
    attrs: {
      "config": _vm.digitalFlop
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "active-ring-name",
    style: (_vm.fontSize)
  }, [_vm._v(_vm._s(_vm.ringName))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(949),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox1',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-1',

      border: ['left-top', 'right-top', 'left-bottom', 'right-bottom'],

      defaultColor: ['#4fd2dd', '#235fa7'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-1"
  }, [_c('svg', {
    staticClass: "border",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("10, 27 10, " + (_vm.height - 27) + " 13, " + (_vm.height - 24) + " 13, " + (_vm.height - 21) + " 24, " + (_vm.height - 11) + "\n    38, " + (_vm.height - 11) + " 41, " + (_vm.height - 8) + " 73, " + (_vm.height - 8) + " 75, " + (_vm.height - 10) + " 81, " + (_vm.height - 10) + "\n    85, " + (_vm.height - 6) + " " + (_vm.width - 85) + ", " + (_vm.height - 6) + " " + (_vm.width - 81) + ", " + (_vm.height - 10) + " " + (_vm.width - 75) + ", " + (_vm.height - 10) + "\n    " + (_vm.width - 73) + ", " + (_vm.height - 8) + " " + (_vm.width - 41) + ", " + (_vm.height - 8) + " " + (_vm.width - 38) + ", " + (_vm.height - 11) + "\n    " + (_vm.width - 24) + ", " + (_vm.height - 11) + " " + (_vm.width - 13) + ", " + (_vm.height - 21) + " " + (_vm.width - 13) + ", " + (_vm.height - 24) + "\n    " + (_vm.width - 10) + ", " + (_vm.height - 27) + " " + (_vm.width - 10) + ", 27 " + (_vm.width - 13) + ", 25 " + (_vm.width - 13) + ", 21\n    " + (_vm.width - 24) + ", 11 " + (_vm.width - 38) + ", 11 " + (_vm.width - 41) + ", 8 " + (_vm.width - 73) + ", 8 " + (_vm.width - 75) + ", 10\n    " + (_vm.width - 81) + ", 10 " + (_vm.width - 85) + ", 6 85, 6 81, 10 75, 10 73, 8 41, 8 38, 11 24, 11 13, 21 13, 24")
    }
  })]), _vm._v(" "), _vm._l((_vm.border), function(item) {
    return _c('svg', {
      key: item,
      class: (item + " border"),
      attrs: {
        "width": "150px",
        "height": "150px"
      }
    }, [_c('polygon', {
      attrs: {
        "fill": _vm.mergedColor[0],
        "points": "6,66 6,18 12,12 18,12 24,6 27,6 30,9 36,9 39,6 84,6 81,9 75,9 73.2,7 40.8,7 37.8,10.2 24,10.2 12,21 12,24 9,27 9,51 7.8,54 7.8,63"
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "fill",
        "values": ((_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),
        "dur": "0.5s",
        "begin": "0s",
        "repeatCount": "indefinite"
      }
    })]), _vm._v(" "), _c('polygon', {
      attrs: {
        "fill": _vm.mergedColor[1],
        "points": "27.599999999999998,4.8 38.4,4.8 35.4,7.8 30.599999999999998,7.8"
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "fill",
        "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1])),
        "dur": "0.5s",
        "begin": "0s",
        "repeatCount": "indefinite"
      }
    })]), _vm._v(" "), _c('polygon', {
      attrs: {
        "fill": _vm.mergedColor[0],
        "points": "9,54 9,63 7.199999999999999,66 7.199999999999999,75 7.8,78 7.8,110 8.4,110 8.4,66 9.6,66 9.6,54"
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "fill",
        "values": ((_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1]) + ";transparent"),
        "dur": "1s",
        "begin": "0s",
        "repeatCount": "indefinite"
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(953),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox10',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-10',

      border: ['left-top', 'right-top', 'left-bottom', 'right-bottom'],

      defaultColor: ['#1d48c4', '#d3e1f8'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-10",
    style: (("box-shadow: inset 0 0 25px 3px " + (_vm.mergedColor[0])))
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("\n      4, 0 " + (_vm.width - 4) + ", 0 " + _vm.width + ", 4 " + _vm.width + ", " + (_vm.height - 4) + " " + (_vm.width - 4) + ", " + _vm.height + "\n      4, " + _vm.height + " 0, " + (_vm.height - 4) + " 0, 4\n    ")
    }
  })]), _vm._v(" "), _vm._l((_vm.border), function(item) {
    return _c('svg', {
      key: item,
      class: (item + " dv-border-svg-container"),
      attrs: {
        "width": "150px",
        "height": "150px"
      }
    }, [_c('polygon', {
      attrs: {
        "fill": _vm.mergedColor[1],
        "points": "40, 0 5, 0 0, 5 0, 16 3, 19 3, 7 7, 3 35, 3"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(957),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_color__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox11',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleWidth: {
      type: Number,
      default: 250
    },
    title: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_1__util_index__["e" /* uuid */])();
    return {
      ref: 'border-box-11',
      filterId: 'border-box-11-filterId-' + id,

      defaultColor: ['#8aaafb', '#1f33a2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    },

    fade: __WEBPACK_IMPORTED_MODULE_4__jiaminghi_color__["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-11"
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": _vm.filterId,
      "height": "150%",
      "width": "150%",
      "x": "-25%",
      "y": "-25%"
    }
  }, [_c('feMorphology', {
    attrs: {
      "operator": "dilate",
      "radius": "2",
      "in": "SourceAlpha",
      "result": "thicken"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "thicken",
      "stdDeviation": "3",
      "result": "blurred"
    }
  }), _vm._v(" "), _c('feFlood', {
    attrs: {
      "flood-color": _vm.mergedColor[1],
      "result": "glowColor"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "glowColor",
      "in2": "blurred",
      "operator": "in",
      "result": "softGlowColored"
    }
  }), _vm._v(" "), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "softGlowColored"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1)], 1)]), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("\n      20, 32 " + (_vm.width * 0.5 - _vm.titleWidth / 2) + ", 32 " + (_vm.width * 0.5 - _vm.titleWidth / 2 + 20) + ", 53\n      " + (_vm.width * 0.5 + _vm.titleWidth / 2 - 20) + ", 53 " + (_vm.width * 0.5 + _vm.titleWidth / 2) + ", 32\n      " + (_vm.width - 20) + ", 32 " + (_vm.width - 8) + ", 48 " + (_vm.width - 8) + ", " + (_vm.height - 25) + " " + (_vm.width - 20) + ", " + (_vm.height - 8) + "\n      20, " + (_vm.height - 8) + " 8, " + (_vm.height - 25) + " 8, 50\n    ")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "filter": ("url(#" + _vm.filterId + ")"),
      "points": ("\n        " + ((_vm.width - _vm.titleWidth) / 2) + ", 30\n        20, 30 7, 50 7, " + (50 + (_vm.height - 167) / 2) + "\n        13, " + (55 + (_vm.height - 167) / 2) + " 13, " + (135 + (_vm.height - 167) / 2) + "\n        7, " + (140 + (_vm.height - 167) / 2) + " 7, " + (_vm.height - 27) + "\n        20, " + (_vm.height - 7) + " " + (_vm.width - 20) + ", " + (_vm.height - 7) + " " + (_vm.width - 7) + ", " + (_vm.height - 27) + "\n        " + (_vm.width - 7) + ", " + (140 + (_vm.height - 167) / 2) + " " + (_vm.width - 13) + ", " + (135 + (_vm.height - 167) / 2) + "\n        " + (_vm.width - 13) + ", " + (55 + (_vm.height - 167) / 2) + " " + (_vm.width - 7) + ", " + (50 + (_vm.height - 167) / 2) + "\n        " + (_vm.width - 7) + ", 50 " + (_vm.width - 20) + ", 30 " + ((_vm.width + _vm.titleWidth) / 2) + ", 30\n        " + ((_vm.width + _vm.titleWidth) / 2 - 20) + ", 7 " + ((_vm.width - _vm.titleWidth) / 2 + 20) + ", 7\n        " + ((_vm.width - _vm.titleWidth) / 2) + ", 30 " + ((_vm.width - _vm.titleWidth) / 2 + 20) + ", 52\n        " + ((_vm.width + _vm.titleWidth) / 2 - 20) + ", 52 " + ((_vm.width + _vm.titleWidth) / 2) + ", 30\n      ")
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "fill": "transparent",
      "points": ("\n        " + ((_vm.width + _vm.titleWidth) / 2 - 5) + ", 30 " + ((_vm.width + _vm.titleWidth) / 2 - 21) + ", 11\n        " + ((_vm.width + _vm.titleWidth) / 2 - 27) + ", 11 " + ((_vm.width + _vm.titleWidth) / 2 - 8) + ", 34\n      ")
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "fill": "transparent",
      "points": ("\n        " + ((_vm.width - _vm.titleWidth) / 2 + 5) + ", 30 " + ((_vm.width - _vm.titleWidth) / 2 + 22) + ", 49\n        " + ((_vm.width - _vm.titleWidth) / 2 + 28) + ", 49 " + ((_vm.width - _vm.titleWidth) / 2 + 8) + ", 26\n      ")
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "fill": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30),
      "filter": ("url(#" + _vm.filterId + ")"),
      "points": ("\n        " + ((_vm.width + _vm.titleWidth) / 2 - 11) + ", 37 " + ((_vm.width + _vm.titleWidth) / 2 - 32) + ", 11\n        " + ((_vm.width - _vm.titleWidth) / 2 + 23) + ", 11 " + ((_vm.width - _vm.titleWidth) / 2 + 11) + ", 23\n        " + ((_vm.width - _vm.titleWidth) / 2 + 33) + ", 49 " + ((_vm.width + _vm.titleWidth) / 2 - 22) + ", 49\n      ")
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "filter": ("url(#" + _vm.filterId + ")"),
      "fill": _vm.mergedColor[0],
      "opacity": "1",
      "points": ("\n        " + ((_vm.width - _vm.titleWidth) / 2 - 10) + ", 37 " + ((_vm.width - _vm.titleWidth) / 2 - 31) + ", 37\n        " + ((_vm.width - _vm.titleWidth) / 2 - 25) + ", 46 " + ((_vm.width - _vm.titleWidth) / 2 - 4) + ", 46\n      ")
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "values": "1;0.7;1",
      "dur": "2s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('polygon', {
    attrs: {
      "filter": ("url(#" + _vm.filterId + ")"),
      "fill": _vm.mergedColor[0],
      "opacity": "0.7",
      "points": ("\n        " + ((_vm.width - _vm.titleWidth) / 2 - 40) + ", 37 " + ((_vm.width - _vm.titleWidth) / 2 - 61) + ", 37\n        " + ((_vm.width - _vm.titleWidth) / 2 - 55) + ", 46 " + ((_vm.width - _vm.titleWidth) / 2 - 34) + ", 46\n      ")
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "values": "0.7;0.4;0.7",
      "dur": "2s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('polygon', {
    attrs: {
      "filter": ("url(#" + _vm.filterId + ")"),
      "fill": _vm.mergedColor[0],
      "opacity": "0.5",
      "points": ("\n        " + ((_vm.width - _vm.titleWidth) / 2 - 70) + ", 37 " + ((_vm.width - _vm.titleWidth) / 2 - 91) + ", 37\n        " + ((_vm.width - _vm.titleWidth) / 2 - 85) + ", 46 " + ((_vm.width - _vm.titleWidth) / 2 - 64) + ", 46\n      ")
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "values": "0.5;0.2;0.5",
      "dur": "2s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('polygon', {
    attrs: {
      "filter": ("url(#" + _vm.filterId + ")"),
      "fill": _vm.mergedColor[0],
      "opacity": "1",
      "points": ("\n        " + ((_vm.width + _vm.titleWidth) / 2 + 30) + ", 37 " + ((_vm.width + _vm.titleWidth) / 2 + 9) + ", 37\n        " + ((_vm.width + _vm.titleWidth) / 2 + 3) + ", 46 " + ((_vm.width + _vm.titleWidth) / 2 + 24) + ", 46\n      ")
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "values": "1;0.7;1",
      "dur": "2s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('polygon', {
    attrs: {
      "filter": ("url(#" + _vm.filterId + ")"),
      "fill": _vm.mergedColor[0],
      "opacity": "0.7",
      "points": ("\n        " + ((_vm.width + _vm.titleWidth) / 2 + 60) + ", 37 " + ((_vm.width + _vm.titleWidth) / 2 + 39) + ", 37\n        " + ((_vm.width + _vm.titleWidth) / 2 + 33) + ", 46 " + ((_vm.width + _vm.titleWidth) / 2 + 54) + ", 46\n      ")
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "values": "0.7;0.4;0.7",
      "dur": "2s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('polygon', {
    attrs: {
      "filter": ("url(#" + _vm.filterId + ")"),
      "fill": _vm.mergedColor[0],
      "opacity": "0.5",
      "points": ("\n        " + ((_vm.width + _vm.titleWidth) / 2 + 90) + ", 37 " + ((_vm.width + _vm.titleWidth) / 2 + 69) + ", 37\n        " + ((_vm.width + _vm.titleWidth) / 2 + 63) + ", 46 " + ((_vm.width + _vm.titleWidth) / 2 + 84) + ", 46\n      ")
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "values": "0.5;0.2;0.5",
      "dur": "2s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('text', {
    staticClass: "dv-border-box-11-title",
    attrs: {
      "x": ("" + (_vm.width / 2)),
      "y": "32",
      "fill": "#fff",
      "font-size": "18",
      "text-anchor": "middle",
      "dominant-baseline": "middle"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.mergedColor[0],
      "filter": ("url(#" + _vm.filterId + ")"),
      "points": ("\n        7, " + (53 + (_vm.height - 167) / 2) + " 11, " + (57 + (_vm.height - 167) / 2) + "\n        11, " + (133 + (_vm.height - 167) / 2) + " 7, " + (137 + (_vm.height - 167) / 2) + "\n      ")
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.mergedColor[0],
      "filter": ("url(#" + _vm.filterId + ")"),
      "points": ("\n        " + (_vm.width - 7) + ", " + (53 + (_vm.height - 167) / 2) + " " + (_vm.width - 11) + ", " + (57 + (_vm.height - 167) / 2) + "\n        " + (_vm.width - 11) + ", " + (133 + (_vm.height - 167) / 2) + " " + (_vm.width - 7) + ", " + (137 + (_vm.height - 167) / 2) + "\n      ")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(960),
  /* template */
  __webpack_require__(961),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_color__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox12',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_1__util_index__["e" /* uuid */])();
    return {
      ref: 'border-box-12',
      filterId: 'borderr-box-12-filterId-' + id,

      defaultColor: ['#2e6099', '#7ce7fd'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    },

    fade: __WEBPACK_IMPORTED_MODULE_4__jiaminghi_color__["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-12"
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": _vm.filterId,
      "height": "150%",
      "width": "150%",
      "x": "-25%",
      "y": "-25%"
    }
  }, [_c('feMorphology', {
    attrs: {
      "operator": "dilate",
      "radius": "1",
      "in": "SourceAlpha",
      "result": "thicken"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "thicken",
      "stdDeviation": "2",
      "result": "blurred"
    }
  }), _vm._v(" "), _c('feFlood', {
    attrs: {
      "flood-color": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 70),
      "result": "glowColor"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "flood-color",
      "values": ("\n              " + (_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 70)) + ";\n              " + (_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30)) + ";\n              " + (_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 70)) + ";\n            "),
      "dur": "3s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "glowColor",
      "in2": "blurred",
      "operator": "in",
      "result": "softGlowColored"
    }
  }), _vm._v(" "), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "softGlowColored"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.width && _vm.height) ? _c('path', {
    attrs: {
      "fill": _vm.backgroundColor,
      "stroke-width": "2",
      "stroke": _vm.mergedColor[0],
      "d": ("\n        M15 5 L " + (_vm.width - 15) + " 5 Q " + (_vm.width - 5) + " 5, " + (_vm.width - 5) + " 15\n        L " + (_vm.width - 5) + " " + (_vm.height - 15) + " Q " + (_vm.width - 5) + " " + (_vm.height - 5) + ", " + (_vm.width - 15) + " " + (_vm.height - 5) + "\n        L 15, " + (_vm.height - 5) + " Q 5 " + (_vm.height - 5) + " 5 " + (_vm.height - 15) + " L 5 15\n        Q 5 5 15 5\n      ")
    }
  }) : _vm._e(), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "2",
      "fill": "transparent",
      "stroke-linecap": "round",
      "filter": ("url(#" + _vm.filterId + ")"),
      "stroke": _vm.mergedColor[1],
      "d": "M 20 5 L 15 5 Q 5 5 5 15 L 5 20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "2",
      "fill": "transparent",
      "stroke-linecap": "round",
      "filter": ("url(#" + _vm.filterId + ")"),
      "stroke": _vm.mergedColor[1],
      "d": ("M " + (_vm.width - 20) + " 5 L " + (_vm.width - 15) + " 5 Q " + (_vm.width - 5) + " 5 " + (_vm.width - 5) + " 15 L " + (_vm.width - 5) + " 20")
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "2",
      "fill": "transparent",
      "stroke-linecap": "round",
      "filter": ("url(#" + _vm.filterId + ")"),
      "stroke": _vm.mergedColor[1],
      "d": ("\n        M " + (_vm.width - 20) + " " + (_vm.height - 5) + " L " + (_vm.width - 15) + " " + (_vm.height - 5) + "\n        Q " + (_vm.width - 5) + " " + (_vm.height - 5) + " " + (_vm.width - 5) + " " + (_vm.height - 15) + "\n        L " + (_vm.width - 5) + " " + (_vm.height - 20) + "\n      ")
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "2",
      "fill": "transparent",
      "stroke-linecap": "round",
      "filter": ("url(#" + _vm.filterId + ")"),
      "stroke": _vm.mergedColor[1],
      "d": ("\n        M 20 " + (_vm.height - 5) + " L 15 " + (_vm.height - 5) + "\n        Q 5 " + (_vm.height - 5) + " 5 " + (_vm.height - 15) + "\n        L 5 " + (_vm.height - 20) + "\n      ")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(964),
  /* template */
  __webpack_require__(965),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox13',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-13',

      defaultColor: ['#6586ec', '#2cf7fe'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-13"
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('path', {
    attrs: {
      "fill": _vm.backgroundColor,
      "stroke": _vm.mergedColor[0],
      "d": ("\n        M 5 20 L 5 10 L 12 3  L 60 3 L 68 10\n        L " + (_vm.width - 20) + " 10 L " + (_vm.width - 5) + " 25\n        L " + (_vm.width - 5) + " " + (_vm.height - 5) + " L 20 " + (_vm.height - 5) + "\n        L 5 " + (_vm.height - 20) + " L 5 20\n      ")
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "transparent",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-dasharray": "10, 5",
      "stroke": _vm.mergedColor[0],
      "d": "M 16 9 L 61 9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "transparent",
      "stroke": _vm.mergedColor[1],
      "d": "M 5 20 L 5 10 L 12 3  L 60 3 L 68 10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "transparent",
      "stroke": _vm.mergedColor[1],
      "d": ("M " + (_vm.width - 5) + " " + (_vm.height - 30) + " L " + (_vm.width - 5) + " " + (_vm.height - 5) + " L " + (_vm.width - 30) + " " + (_vm.height - 5))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(969),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox2',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-2',

      defaultColor: ['#fff', 'rgba(255, 255, 255, 0.6)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-2"
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("\n      7, 7 " + (_vm.width - 7) + ", 7 " + (_vm.width - 7) + ", " + (_vm.height - 7) + " 7, " + (_vm.height - 7) + "\n    ")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("2, 2 " + (_vm.width - 2) + " ,2 " + (_vm.width - 2) + ", " + (_vm.height - 2) + " 2, " + (_vm.height - 2) + " 2, 2")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("6, 6 " + (_vm.width - 6) + ", 6 " + (_vm.width - 6) + ", " + (_vm.height - 6) + " 6, " + (_vm.height - 6) + " 6, 6")
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": _vm.mergedColor[0],
      "cx": "11",
      "cy": "11",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": _vm.mergedColor[0],
      "cx": _vm.width - 11,
      "cy": "11",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": _vm.mergedColor[0],
      "cx": _vm.width - 11,
      "cy": _vm.height - 11,
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": _vm.mergedColor[0],
      "cx": "11",
      "cy": _vm.height - 11,
      "r": "1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(972),
  /* template */
  __webpack_require__(973),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox3',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-3',

      defaultColor: ['#2862b7', '#2862b7'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-3"
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("\n      23, 23 " + (_vm.width - 24) + ", 23 " + (_vm.width - 24) + ", " + (_vm.height - 24) + " 23, " + (_vm.height - 24) + "\n    ")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb3-line1",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("4, 4 " + (_vm.width - 22) + " ,4 " + (_vm.width - 22) + ", " + (_vm.height - 22) + " 4, " + (_vm.height - 22) + " 4, 4")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb3-line2",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("10, 10 " + (_vm.width - 16) + ", 10 " + (_vm.width - 16) + ", " + (_vm.height - 16) + " 10, " + (_vm.height - 16) + " 10, 10")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb3-line2",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("16, 16 " + (_vm.width - 10) + ", 16 " + (_vm.width - 10) + ", " + (_vm.height - 10) + " 16, " + (_vm.height - 10) + " 16, 16")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb3-line2",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("22, 22 " + (_vm.width - 4) + ", 22 " + (_vm.width - 4) + ", " + (_vm.height - 4) + " 22, " + (_vm.height - 4) + " 22, 22")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(976),
  /* template */
  __webpack_require__(977),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox4',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-4',

      defaultColor: ['red', 'rgba(0,0,255,0.8)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-4"
  }, [_c('svg', {
    class: ("dv-border-svg-container " + (_vm.reverse && 'dv-reverse')),
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("\n      " + (_vm.width - 15) + ", 22 170, 22 150, 7 40, 7 28, 21 32, 24\n      16, 42 16, " + (_vm.height - 32) + " 41, " + (_vm.height - 7) + " " + (_vm.width - 15) + ", " + (_vm.height - 7) + "\n    ")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-1",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("145, " + (_vm.height - 5) + " 40, " + (_vm.height - 5) + " 10, " + (_vm.height - 35) + "\n        10, 40 40, 5 150, 5 170, 20 " + (_vm.width - 15) + ", 20")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-2",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("245, " + (_vm.height - 1) + " 36, " + (_vm.height - 1) + " 14, " + (_vm.height - 23) + "\n        14, " + (_vm.height - 100))
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-3",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("7, " + (_vm.height - 40) + " 7, " + (_vm.height - 75))
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-4",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": "28, 24 13, 41 13, 64"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-5",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": "5, 45 5, 140"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-6",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": "14, 75 14, 180"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-7",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": "55, 11 147, 11 167, 26 250, 26"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-8",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": "158, 5 173, 16"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-9",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("200, 17 " + (_vm.width - 10) + ", 17")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb4-line-10",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("385, 17 " + (_vm.width - 10) + ", 17")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(980),
  /* template */
  __webpack_require__(981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox5',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-5',

      defaultColor: ['rgba(255, 255, 255, 0.35)', 'rgba(255, 255, 255, 0.20)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-5"
  }, [_c('svg', {
    class: ("dv-border-svg-container  " + (_vm.reverse && 'dv-reverse')),
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("\n      10, 22 " + (_vm.width - 22) + ", 22 " + (_vm.width - 22) + ", " + (_vm.height - 86) + " " + (_vm.width - 84) + ", " + (_vm.height - 24) + " 10, " + (_vm.height - 24) + "\n    ")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb5-line-1",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("8, 5 " + (_vm.width - 5) + ", 5 " + (_vm.width - 5) + ", " + (_vm.height - 100) + "\n        " + (_vm.width - 100) + ", " + (_vm.height - 5) + " 8, " + (_vm.height - 5) + " 8, 5")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb5-line-2",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("3, 5 " + (_vm.width - 20) + ", 5 " + (_vm.width - 20) + ", " + (_vm.height - 60) + "\n        " + (_vm.width - 74) + ", " + (_vm.height - 5) + " 3, " + (_vm.height - 5) + " 3, 5")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb5-line-3",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("50, 13 " + (_vm.width - 35) + ", 13")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb5-line-4",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("15, 20 " + (_vm.width - 35) + ", 20")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb5-line-5",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("15, " + (_vm.height - 20) + " " + (_vm.width - 110) + ", " + (_vm.height - 20))
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb5-line-6",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("15, " + (_vm.height - 13) + " " + (_vm.width - 110) + ", " + (_vm.height - 13))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(984),
  /* template */
  __webpack_require__(985),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox6',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize_js__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-6',

      defaultColor: ['rgba(255, 255, 255, 0.35)', 'gray'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-6"
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("\n      9, 7 " + (_vm.width - 9) + ", 7 " + (_vm.width - 9) + ", " + (_vm.height - 7) + " 9, " + (_vm.height - 7) + "\n    ")
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": _vm.mergedColor[1],
      "cx": "5",
      "cy": "5",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": _vm.mergedColor[1],
      "cx": _vm.width - 5,
      "cy": "5",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": _vm.mergedColor[1],
      "cx": _vm.width - 5,
      "cy": _vm.height - 5,
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": _vm.mergedColor[1],
      "cx": "5",
      "cy": _vm.height - 5,
      "r": "2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("10, 4 " + (_vm.width - 10) + ", 4")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("10, " + (_vm.height - 4) + " " + (_vm.width - 10) + ", " + (_vm.height - 4))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("5, 70 5, " + (_vm.height - 70))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ((_vm.width - 5) + ", 70 " + (_vm.width - 5) + ", " + (_vm.height - 70))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": "3, 10, 3, 50"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": "7, 30 7, 80"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ((_vm.width - 3) + ", 10 " + (_vm.width - 3) + ", 50")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ((_vm.width - 7) + ", 30 " + (_vm.width - 7) + ", 80")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("3, " + (_vm.height - 10) + " 3, " + (_vm.height - 50))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("7, " + (_vm.height - 30) + " 7, " + (_vm.height - 80))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ((_vm.width - 3) + ", " + (_vm.height - 10) + " " + (_vm.width - 3) + ", " + (_vm.height - 50))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ((_vm.width - 7) + ", " + (_vm.height - 30) + " " + (_vm.width - 7) + ", " + (_vm.height - 80))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(988),
  /* template */
  __webpack_require__(989),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox7',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-7',

      defaultColor: ['rgba(128,128,128,0.3)', 'rgba(128,128,128,0.5)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-7",
    style: (("box-shadow: inset 0 0 40px " + (_vm.mergedColor[0]) + "; border: 1px solid " + (_vm.mergedColor[0]) + "; background-color: " + _vm.backgroundColor))
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polyline', {
    staticClass: "dv-bb7-line-width-2",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": "0, 25 0, 0 25, 0"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb7-line-width-2",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ((_vm.width - 25) + ", 0 " + _vm.width + ", 0 " + _vm.width + ", 25")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb7-line-width-2",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ((_vm.width - 25) + ", " + _vm.height + " " + _vm.width + ", " + _vm.height + " " + _vm.width + ", " + (_vm.height - 25))
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb7-line-width-2",
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": ("0, " + (_vm.height - 25) + " 0, " + _vm.height + " 25, " + _vm.height)
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb7-line-width-5",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": "0, 10 0, 0 10, 0"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb7-line-width-5",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ((_vm.width - 10) + ", 0 " + _vm.width + ", 0 " + _vm.width + ", 10")
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb7-line-width-5",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ((_vm.width - 10) + ", " + _vm.height + " " + _vm.width + ", " + _vm.height + " " + _vm.width + ", " + (_vm.height - 10))
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "dv-bb7-line-width-5",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "points": ("0, " + (_vm.height - 10) + " 0, " + _vm.height + " 10, " + _vm.height)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(992),
  /* template */
  __webpack_require__(993),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox8',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 3
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_1__util_index__["e" /* uuid */])();
    return {
      ref: 'border-box-8',
      path: 'border-box-8-path-' + id,
      gradient: 'border-box-8-gradient-' + id,
      mask: 'border-box-8-mask-' + id,

      defaultColor: ['#235fa7', '#4fd2dd'],

      mergedColor: []
    };
  },

  computed: {
    length: function length() {
      var width = this.width,
          height = this.height;


      return (width + height - 5) * 2;
    },
    pathD: function pathD() {
      var reverse = this.reverse,
          width = this.width,
          height = this.height;


      if (reverse) return 'M 2.5, 2.5 L 2.5, ' + (height - 2.5) + ' L ' + (width - 2.5) + ', ' + (height - 2.5) + ' L ' + (width - 2.5) + ', 2.5 L 2.5, 2.5';

      return 'M2.5, 2.5 L' + (width - 2.5) + ', 2.5 L' + (width - 2.5) + ', ' + (height - 2.5) + ' L2.5, ' + (height - 2.5) + ' L2.5, 2.5';
    }
  },
  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-8"
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": _vm.path,
      "d": _vm.pathD,
      "fill": "transparent"
    }
  }), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": _vm.gradient,
      "cx": "50%",
      "cy": "50%",
      "r": "50%"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#fff",
      "stop-opacity": "1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#fff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('mask', {
    attrs: {
      "id": _vm.mask
    }
  }, [_c('circle', {
    attrs: {
      "cx": "0",
      "cy": "0",
      "r": "150",
      "fill": ("url(#" + _vm.gradient + ")")
    }
  }, [_c('animateMotion', {
    attrs: {
      "dur": (_vm.dur + "s"),
      "path": _vm.pathD,
      "rotate": "auto",
      "repeatCount": "indefinite"
    }
  })], 1)])], 1), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("5, 5 " + (_vm.width - 5) + ", 5 " + (_vm.width - 5) + " " + (_vm.height - 5) + " 5, " + (_vm.height - 5))
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "stroke-width": "1",
      "xlink:href": ("#" + _vm.path)
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "stroke": _vm.mergedColor[1],
      "stroke-width": "3",
      "xlink:href": ("#" + _vm.path),
      "mask": ("url(#" + _vm.mask + ")")
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dasharray",
      "from": ("0, " + _vm.length),
      "to": (_vm.length + ", 0"),
      "dur": (_vm.dur + "s"),
      "repeatCount": "indefinite"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(996),
  /* template */
  __webpack_require__(997),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvBorderBox9',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_1__util_index__["e" /* uuid */])();
    return {
      ref: 'border-box-9',

      gradientId: 'border-box-9-gradient-' + id,
      maskId: 'border-box-9-mask-' + id,

      defaultColor: ['#11eefd', '#0078d2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-border-box-9"
  }, [_c('svg', {
    staticClass: "dv-border-svg-container",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": _vm.gradientId,
      "x1": "0%",
      "y1": "0%",
      "x2": "100%",
      "y2": "100%"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "x1",
      "values": "0%;100%;0%",
      "dur": "10s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "x2",
      "values": "100%;0%;100%",
      "dur": "10s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": _vm.mergedColor[0]
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stop-color",
      "values": ((_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),
      "dur": "10s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": _vm.mergedColor[1]
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stop-color",
      "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1])),
      "dur": "10s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })])], 1), _vm._v(" "), _c('mask', {
    attrs: {
      "id": _vm.maskId
    }
  }, [_c('polyline', {
    attrs: {
      "stroke": "#fff",
      "stroke-width": "3",
      "fill": "transparent",
      "points": ("8, " + (_vm.height * 0.4) + " 8, 3, " + (_vm.width * 0.4 + 7) + ", 3")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "#fff",
      "points": ("8, " + (_vm.height * 0.15) + " 8, 3, " + (_vm.width * 0.1 + 7) + ", 3\n            " + (_vm.width * 0.1) + ", 8 14, 8 14, " + (_vm.height * 0.15 - 7) + "\n          ")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": "#fff",
      "stroke-width": "3",
      "fill": "transparent",
      "points": ((_vm.width * 0.5) + ", 3 " + (_vm.width - 3) + ", 3, " + (_vm.width - 3) + ", " + (_vm.height * 0.25))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "#fff",
      "points": ("\n            " + (_vm.width * 0.52) + ", 3 " + (_vm.width * 0.58) + ", 3\n            " + (_vm.width * 0.58 - 7) + ", 9 " + (_vm.width * 0.52 + 7) + ", 9\n          ")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "#fff",
      "points": ("\n            " + (_vm.width * 0.9) + ", 3 " + (_vm.width - 3) + ", 3 " + (_vm.width - 3) + ", " + (_vm.height * 0.1) + "\n            " + (_vm.width - 9) + ", " + (_vm.height * 0.1 - 7) + " " + (_vm.width - 9) + ", 9 " + (_vm.width * 0.9 + 7) + ", 9\n          ")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": "#fff",
      "stroke-width": "3",
      "fill": "transparent",
      "points": ("8, " + (_vm.height * 0.5) + " 8, " + (_vm.height - 3) + " " + (_vm.width * 0.3 + 7) + ", " + (_vm.height - 3))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "#fff",
      "points": ("\n            8, " + (_vm.height * 0.55) + " 8, " + (_vm.height * 0.7) + "\n            2, " + (_vm.height * 0.7 - 7) + " 2, " + (_vm.height * 0.55 + 7) + "\n          ")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": "#fff",
      "stroke-width": "3",
      "fill": "transparent",
      "points": ((_vm.width * 0.35) + ", " + (_vm.height - 3) + " " + (_vm.width - 3) + ", " + (_vm.height - 3) + " " + (_vm.width - 3) + ", " + (_vm.height * 0.35))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "#fff",
      "points": ("\n            " + (_vm.width * 0.92) + ", " + (_vm.height - 3) + " " + (_vm.width - 3) + ", " + (_vm.height - 3) + " " + (_vm.width - 3) + ", " + (_vm.height * 0.8) + "\n            " + (_vm.width - 9) + ", " + (_vm.height * 0.8 + 7) + " " + (_vm.width - 9) + ", " + (_vm.height - 9) + " " + (_vm.width * 0.92 + 7) + ", " + (_vm.height - 9) + "\n          ")
    }
  })])], 1), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.backgroundColor,
      "points": ("\n      15, 9 " + (_vm.width * 0.1 + 1) + ", 9 " + (_vm.width * 0.1 + 4) + ", 6 " + (_vm.width * 0.52 + 2) + ", 6\n      " + (_vm.width * 0.52 + 6) + ", 10 " + (_vm.width * 0.58 - 7) + ", 10 " + (_vm.width * 0.58 - 2) + ", 6\n      " + (_vm.width * 0.9 + 2) + ", 6 " + (_vm.width * 0.9 + 6) + ", 10 " + (_vm.width - 10) + ", 10 " + (_vm.width - 10) + ", " + (_vm.height * 0.1 - 6) + "\n      " + (_vm.width - 6) + ", " + (_vm.height * 0.1 - 1) + " " + (_vm.width - 6) + ", " + (_vm.height * 0.8 + 1) + " " + (_vm.width - 10) + ", " + (_vm.height * 0.8 + 6) + "\n      " + (_vm.width - 10) + ", " + (_vm.height - 10) + " " + (_vm.width * 0.92 + 7) + ", " + (_vm.height - 10) + "  " + (_vm.width * 0.92 + 2) + ", " + (_vm.height - 6) + "\n      11, " + (_vm.height - 6) + " 11, " + (_vm.height * 0.15 - 2) + " 15, " + (_vm.height * 0.15 - 7) + "\n    ")
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.width,
      "height": _vm.height,
      "fill": ("url(#" + _vm.gradientId + ")"),
      "mask": ("url(#" + _vm.maskId + ")")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "border-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1000),
  /* template */
  __webpack_require__(1001),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvCapsuleChart',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        /**
         * @description Capsule chart data
         * @type {Array<Object>}
         * @default data = []
         * @example data = [{ name: 'foo1', value: 100 }, { name: 'foo2', value: 100 }]
         */
        data: [],
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default color = ['#37a2da', '#32c5e9', '#67e0e3', '#9fe6b8', '#ffdb5c', '#ff9f7f', '#fb7293']
         * @example color = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#37a2da', '#32c5e9', '#67e0e3', '#9fe6b8', '#ffdb5c', '#ff9f7f', '#fb7293'],
        /**
         * @description Chart unit
         * @type {String}
         * @default unit = ''
         */
        unit: '',
        /**
         * @description Show item value
         * @type {Boolean}
         * @default showValue = false
         */
        showValue: false
      },

      mergedConfig: null,

      capsuleLength: [],
      capsuleValue: [],
      labelData: [],
      labelDataLength: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcCapsuleLengthAndLabelData = this.calcCapsuleLengthAndLabelData;


      mergeConfig();

      calcCapsuleLengthAndLabelData();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});
    },
    calcCapsuleLengthAndLabelData: function calcCapsuleLengthAndLabelData() {
      var data = this.mergedConfig.data;


      if (!data.length) return;

      var capsuleValue = data.map(function (_ref) {
        var value = _ref.value;
        return value;
      });

      var maxValue = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(capsuleValue));

      this.capsuleValue = capsuleValue;

      this.capsuleLength = capsuleValue.map(function (v) {
        return maxValue ? v / maxValue : 0;
      });

      var oneFifth = maxValue / 5;

      var labelData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(new Array(6).fill(0).map(function (v, i) {
        return Math.ceil(i * oneFifth);
      })));

      this.labelData = labelData;

      this.labelDataLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(labelData).map(function (v) {
        return maxValue ? v / maxValue : 0;
      });
    }
  },
  mounted: function mounted() {
    var calcData = this.calcData;


    calcData();
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dv-capsule-chart"
  }, [(_vm.mergedConfig) ? [_c('div', {
    staticClass: "label-column"
  }, [_vm._l((_vm.mergedConfig.data), function(item) {
    return _c('div', {
      key: item.name
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('div', [_vm._v(" ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "capsule-container"
  }, [_vm._l((_vm.capsuleLength), function(capsule, index) {
    return _c('div', {
      key: index,
      staticClass: "capsule-item"
    }, [_c('div', {
      staticClass: "capsule-item-column",
      style: (("width: " + (capsule * 100) + "%; background-color: " + (_vm.mergedConfig.colors[index % _vm.mergedConfig.colors.length]) + ";"))
    }, [(_vm.mergedConfig.showValue) ? _c('div', {
      staticClass: "capsule-item-value"
    }, [_vm._v(_vm._s(_vm.capsuleValue[index]))]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "unit-label"
  }, _vm._l((_vm.labelData), function(label, index) {
    return _c('div', {
      key: label + index
    }, [_vm._v(_vm._s(label))])
  }), 0)], 2), _vm._v(" "), (_vm.mergedConfig.unit) ? _c('div', {
    staticClass: "unit-text"
  }, [_vm._v(_vm._s(_vm.mergedConfig.unit))]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1004),
  /* template */
  __webpack_require__(1005),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts__);
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvCharts',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_autoResize__["a" /* default */]],
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_0__util_index__["e" /* uuid */])();
    return {
      ref: 'charts-container-' + id,
      chartRef: 'chart-' + id,

      chart: null
    };
  },

  watch: {
    option: function option() {
      var chart = this.chart,
          option = this.option;


      if (!chart) return;

      if (!option) option = {};

      chart.setOption(option, true);
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var initChart = this.initChart;


      initChart();
    },
    initChart: function initChart() {
      var $refs = this.$refs,
          chartRef = this.chartRef,
          option = this.option;


      var chart = this.chart = new __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts___default.a($refs[chartRef]);

      if (!option) return;

      chart.setOption(option);
    },
    onResize: function onResize() {
      var chart = this.chart;


      if (!chart) return;

      chart.resize();
    }
  }
});

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-charts-container"
  }, [_c('div', {
    ref: _vm.chartRef,
    staticClass: "charts-canvas-container"
  })])
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1008),
  /* template */
  __webpack_require__(1009),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvConicalColumnChart',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_autoResize__["a" /* default */]],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'conical-column-chart',

      defaultConfig: {
        /**
         * @description Chart data
         * @type {Array<Object>}
         * @default data = []
         */
        data: [],
        /**
         * @description Chart img
         * @type {Array<String>}
         * @default img = []
         */
        img: [],
        /**
         * @description Chart font size
         * @type {Number}
         * @default fontSize = 12
         */
        fontSize: 12,
        /**
         * @description Img side length
         * @type {Number}
         * @default imgSideLength = 30
         */
        imgSideLength: 30,
        /**
         * @description Column color
         * @type {String}
         * @default columnColor = 'rgba(0, 194, 255, 0.4)'
         */
        columnColor: 'rgba(0, 194, 255, 0.4)',
        /**
         * @description Text color
         * @type {String}
         * @default textColor = '#fff'
         */
        textColor: '#fff',
        /**
         * @description Show value
         * @type {Boolean}
         * @default showValue = false
         */
        showValue: false
      },

      mergedConfig: null,

      column: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          initData = this.initData,
          calcSVGPath = this.calcSVGPath;


      mergeConfig();

      initData();

      calcSVGPath();
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});
    },
    initData: function initData() {
      var mergedConfig = this.mergedConfig;
      var data = mergedConfig.data;


      data = Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__["deepClone"])(data, true);

      data.sort(function (_ref, _ref2) {
        var a = _ref.value;
        var b = _ref2.value;

        if (a > b) return -1;
        if (a < b) return 1;
        if (a === b) return 0;
      });

      var max = data[0] ? data[0].value : 10;

      data = data.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          percent: item.value / max
        });
      });

      mergedConfig.data = data;
    },
    calcSVGPath: function calcSVGPath() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var imgSideLength = mergedConfig.imgSideLength,
          fontSize = mergedConfig.fontSize,
          data = mergedConfig.data;


      var itemNum = data.length;
      var gap = width / (itemNum + 1);

      var useAbleHeight = height - imgSideLength - fontSize - 5;
      var svgBottom = height - fontSize - 5;

      this.column = data.map(function (item, i) {
        var percent = item.percent;


        var middleXPos = gap * (i + 1);
        var leftXPos = gap * i;
        var rightXpos = gap * (i + 2);

        var middleYPos = svgBottom - useAbleHeight * percent;
        var controlYPos = useAbleHeight * percent * 0.6 + middleYPos;

        var d = '\n          M' + leftXPos + ', ' + svgBottom + '\n          Q' + middleXPos + ', ' + controlYPos + ' ' + middleXPos + ',' + middleYPos + '\n          M' + middleXPos + ',' + middleYPos + '\n          Q' + middleXPos + ', ' + controlYPos + ' ' + rightXpos + ',' + svgBottom + '\n          L' + leftXPos + ', ' + svgBottom + '\n          Z\n        ';

        var textY = (svgBottom + middleYPos) / 2 + fontSize / 2;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          d: d,
          x: middleXPos,
          y: middleYPos,
          textY: textY
        });
      });
    }
  }
});

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-conical-column-chart"
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, _vm._l((_vm.column), function(item, i) {
    return _c('g', {
      key: i
    }, [_c('path', {
      attrs: {
        "d": item.d,
        "fill": _vm.mergedConfig.columnColor
      }
    }), _vm._v(" "), _c('text', {
      style: (("fontSize:" + (_vm.mergedConfig.fontSize) + "px")),
      attrs: {
        "fill": _vm.mergedConfig.textColor,
        "x": item.x,
        "y": _vm.height - 4
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]), _vm._v(" "), (_vm.mergedConfig.img.length) ? _c('image', {
      attrs: {
        "xlink:href": _vm.mergedConfig.img[i % _vm.mergedConfig.img.length],
        "width": _vm.mergedConfig.imgSideLength,
        "height": _vm.mergedConfig.imgSideLength,
        "x": item.x - _vm.mergedConfig.imgSideLength / 2,
        "y": item.y - _vm.mergedConfig.imgSideLength
      }
    }) : _vm._e(), _vm._v(" "), (_vm.mergedConfig.showValue) ? _c('text', {
      style: (("fontSize:" + (_vm.mergedConfig.fontSize) + "px")),
      attrs: {
        "fill": _vm.mergedConfig.textColor,
        "x": item.x,
        "y": item.textY
      }
    }, [_vm._v("\n        " + _vm._s(item.value) + "\n      ")]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1012),
  /* template */
  __webpack_require__(1013),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration1',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var pointSideLength = 2.5;

    return {
      ref: 'decoration-1',

      svgWH: [200, 50],

      svgScale: [1, 1],

      rowNum: 4,
      rowPoints: 20,

      pointSideLength: pointSideLength,
      halfPointSideLength: pointSideLength / 2,

      points: [],

      rects: [],

      defaultColor: ['#fff', '#0de7c2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcRectsPosition = this.calcRectsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcRectsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(all), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item));
      }, []);
    },
    calcRectsPosition: function calcRectsPosition() {
      var points = this.points,
          rowPoints = this.rowPoints;


      var rect1 = points[rowPoints * 2 - 1];
      var rect2 = points[rowPoints * 2 - 3];

      this.rects = [rect1, rect2];
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-1"
  }, [_c('svg', {
    style: (("transform:scale(" + (_vm.svgScale[0]) + "," + (_vm.svgScale[1]) + ");")),
    attrs: {
      "width": ((_vm.svgWH[0]) + "px"),
      "height": ((_vm.svgWH[1]) + "px")
    }
  }, [_vm._l((_vm.points), function(point, i) {
    return [(Math.random() > 0.6) ? _c('rect', {
      key: i,
      attrs: {
        "fill": _vm.mergedColor[0],
        "x": point[0] - _vm.halfPointSideLength,
        "y": point[1] - _vm.halfPointSideLength,
        "width": _vm.pointSideLength,
        "height": _vm.pointSideLength
      }
    }, [(Math.random() > 0.6) ? _c('animate', {
      attrs: {
        "attributeName": "fill",
        "values": ((_vm.mergedColor[0]) + ";transparent"),
        "dur": "1s",
        "begin": Math.random() * 2,
        "repeatCount": "indefinite"
      }
    }) : _vm._e()]) : _vm._e()]
  }), _vm._v(" "), (_vm.rects[0]) ? _c('rect', {
    attrs: {
      "fill": _vm.mergedColor[1],
      "x": _vm.rects[0][0] - _vm.pointSideLength,
      "y": _vm.rects[0][1] - _vm.pointSideLength,
      "width": _vm.pointSideLength * 2,
      "height": _vm.pointSideLength * 2
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "width",
      "values": ("0;" + (_vm.pointSideLength * 2)),
      "dur": "2s",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "height",
      "values": ("0;" + (_vm.pointSideLength * 2)),
      "dur": "2s",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "x",
      "values": ((_vm.rects[0][0]) + ";" + (_vm.rects[0][0] - _vm.pointSideLength)),
      "dur": "2s",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "y",
      "values": ((_vm.rects[0][1]) + ";" + (_vm.rects[0][1] - _vm.pointSideLength)),
      "dur": "2s",
      "repeatCount": "indefinite"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.rects[1]) ? _c('rect', {
    attrs: {
      "fill": _vm.mergedColor[1],
      "x": _vm.rects[1][0] - 40,
      "y": _vm.rects[1][1] - _vm.pointSideLength,
      "width": 40,
      "height": _vm.pointSideLength * 2
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "width",
      "values": "0;40;0",
      "dur": "2s",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "x",
      "values": ((_vm.rects[1][0]) + ";" + (_vm.rects[1][0] - 40) + ";" + (_vm.rects[1][0])),
      "dur": "2s",
      "repeatCount": "indefinite"
    }
  })]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1016),
  /* template */
  __webpack_require__(1017),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration10',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_1__util_index__["e" /* uuid */])();
    return {
      ref: 'decoration-10',

      animationId1: 'd10ani1' + id,
      animationId2: 'd10ani2' + id,
      animationId3: 'd10ani3' + id,
      animationId4: 'd10ani4' + id,
      animationId5: 'd10ani5' + id,
      animationId6: 'd10ani6' + id,
      animationId7: 'd10ani7' + id,

      defaultColor: ['#00c2ff', 'rgba(0, 194, 255, 0.3)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-10"
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[1],
      "stroke-width": "2",
      "points": ("0, " + (_vm.height / 2) + " " + _vm.width + ", " + (_vm.height / 2))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "stroke-width": "2",
      "points": ("5, " + (_vm.height / 2) + " " + (_vm.width * 0.2 - 3) + ", " + (_vm.height / 2)),
      "stroke-dasharray": ("0, " + (_vm.width * 0.2)),
      "fill": "freeze"
    }
  }, [_c('animate', {
    attrs: {
      "id": _vm.animationId2,
      "attributeName": "stroke-dasharray",
      "values": ("0, " + (_vm.width * 0.2) + ";" + (_vm.width * 0.2) + ", 0;"),
      "dur": "3s",
      "begin": (_vm.animationId1 + ".end"),
      "fill": "freeze"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "stroke-dasharray",
      "values": ((_vm.width * 0.2) + ", 0;0, " + (_vm.width * 0.2)),
      "dur": "0.01s",
      "begin": (_vm.animationId7 + ".end"),
      "fill": "freeze"
    }
  })]), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "stroke-width": "2",
      "points": ((_vm.width * 0.2 + 3) + ", " + (_vm.height / 2) + " " + (_vm.width * 0.8 - 3) + ", " + (_vm.height / 2)),
      "stroke-dasharray": ("0, " + (_vm.width * 0.6))
    }
  }, [_c('animate', {
    attrs: {
      "id": _vm.animationId4,
      "attributeName": "stroke-dasharray",
      "values": ("0, " + (_vm.width * 0.6) + ";" + (_vm.width * 0.6) + ", 0"),
      "dur": "3s",
      "begin": (_vm.animationId3 + ".end + 1s"),
      "fill": "freeze"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "stroke-dasharray",
      "values": ((_vm.width * 0.6) + ", 0;0, " + (_vm.width * 0.6)),
      "dur": "0.01s",
      "begin": (_vm.animationId7 + ".end"),
      "fill": "freeze"
    }
  })]), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "stroke-width": "2",
      "points": ((_vm.width * 0.8 + 3) + ", " + (_vm.height / 2) + " " + (_vm.width - 5) + ", " + (_vm.height / 2)),
      "stroke-dasharray": ("0, " + (_vm.width * 0.2))
    }
  }, [_c('animate', {
    attrs: {
      "id": _vm.animationId6,
      "attributeName": "stroke-dasharray",
      "values": ("0, " + (_vm.width * 0.2) + ";" + (_vm.width * 0.2) + ", 0"),
      "dur": "3s",
      "begin": (_vm.animationId5 + ".end + 1s"),
      "fill": "freeze"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "stroke-dasharray",
      "values": ((_vm.width * 0.2) + ", 0;0, " + (_vm.width * 0.3)),
      "dur": "0.01s",
      "begin": (_vm.animationId7 + ".end"),
      "fill": "freeze"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "2",
      "cy": _vm.height / 2,
      "r": "2",
      "fill": _vm.mergedColor[1]
    }
  }, [_c('animate', {
    attrs: {
      "id": _vm.animationId1,
      "attributeName": "fill",
      "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),
      "begin": ("0s;" + _vm.animationId7 + ".end"),
      "dur": "0.3s",
      "fill": "freeze"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": _vm.width * 0.2,
      "cy": _vm.height / 2,
      "r": "2",
      "fill": _vm.mergedColor[1]
    }
  }, [_c('animate', {
    attrs: {
      "id": _vm.animationId3,
      "attributeName": "fill",
      "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),
      "begin": (_vm.animationId2 + ".end"),
      "dur": "0.3s",
      "fill": "freeze"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[1])),
      "dur": "0.01s",
      "begin": (_vm.animationId7 + ".end"),
      "fill": "freeze"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": _vm.width * 0.8,
      "cy": _vm.height / 2,
      "r": "2",
      "fill": _vm.mergedColor[1]
    }
  }, [_c('animate', {
    attrs: {
      "id": _vm.animationId5,
      "attributeName": "fill",
      "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),
      "begin": (_vm.animationId4 + ".end"),
      "dur": "0.3s",
      "fill": "freeze"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[1])),
      "dur": "0.01s",
      "begin": (_vm.animationId7 + ".end"),
      "fill": "freeze"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": _vm.width - 2,
      "cy": _vm.height / 2,
      "r": "2",
      "fill": _vm.mergedColor[1]
    }
  }, [_c('animate', {
    attrs: {
      "id": _vm.animationId7,
      "attributeName": "fill",
      "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),
      "begin": (_vm.animationId6 + ".end"),
      "dur": "0.3s",
      "fill": "freeze"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "fill",
      "values": ((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[1])),
      "dur": "0.01s",
      "begin": (_vm.animationId7 + ".end"),
      "fill": "freeze"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1020),
  /* template */
  __webpack_require__(1021),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_color__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration11',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      ref: 'decoration-11',

      defaultColor: ['#1a98fc', '#2cf7fe'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    },

    fade: __WEBPACK_IMPORTED_MODULE_3__jiaminghi_color__["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-11"
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 10),
      "stroke": _vm.mergedColor[1],
      "points": "20 10, 25 4, 55 4 60 10"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 10),
      "stroke": _vm.mergedColor[1],
      "points": ("20 " + (_vm.height - 10) + ", 25 " + (_vm.height - 4) + ", 55 " + (_vm.height - 4) + " 60 " + (_vm.height - 10))
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 10),
      "stroke": _vm.mergedColor[1],
      "points": ((_vm.width - 20) + " 10, " + (_vm.width - 25) + " 4, " + (_vm.width - 55) + " 4 " + (_vm.width - 60) + " 10")
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 10),
      "stroke": _vm.mergedColor[1],
      "points": ((_vm.width - 20) + " " + (_vm.height - 10) + ", " + (_vm.width - 25) + " " + (_vm.height - 4) + ", " + (_vm.width - 55) + " " + (_vm.height - 4) + " " + (_vm.width - 60) + " " + (_vm.height - 10))
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.fade(_vm.mergedColor[0] || _vm.defaultColor[0], 20),
      "stroke": _vm.mergedColor[0],
      "points": ("\n        20 10, 5 " + (_vm.height / 2) + " 20 " + (_vm.height - 10) + "\n        " + (_vm.width - 20) + " " + (_vm.height - 10) + " " + (_vm.width - 5) + " " + (_vm.height / 2) + " " + (_vm.width - 20) + " 10\n      ")
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "transparent",
      "stroke": _vm.fade(_vm.mergedColor[0] || _vm.defaultColor[0], 70),
      "points": ("25 18, 15 " + (_vm.height / 2) + " 25 " + (_vm.height - 18))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "transparent",
      "stroke": _vm.fade(_vm.mergedColor[0] || _vm.defaultColor[0], 70),
      "points": ((_vm.width - 25) + " 18, " + (_vm.width - 15) + " " + (_vm.height / 2) + " " + (_vm.width - 25) + " " + (_vm.height - 18))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "decoration-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1024),
  /* template */
  __webpack_require__(1025),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_color__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration12',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * @description Scan animation dur
     */
    scanDur: {
      type: Number,
      default: 3
    },
    /**
     * @description Halo animation dur
     */
    haloDur: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_2__util_index__["e" /* uuid */])();
    return {
      ref: 'decoration-12',
      gId: 'decoration-12-g-' + id,
      gradientId: 'decoration-12-gradient-' + id,

      defaultColor: ['#2783ce', '#2cf7fe'],

      mergedColor: [],

      pathD: [],

      pathColor: [],

      circleR: [],

      splitLinePoints: [],

      arcD: [],

      segment: 30,

      sectorAngle: Math.PI / 3,

      ringNum: 3,

      ringWidth: 1,

      showSplitLine: true
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  computed: {
    x: function x() {
      var width = this.width;


      return width / 2;
    },
    y: function y() {
      var height = this.height;


      return height / 2;
    }
  },
  methods: {
    init: function init() {
      var mergeColor = this.mergeColor,
          calcPathD = this.calcPathD,
          calcPathColor = this.calcPathColor,
          calcCircleR = this.calcCircleR,
          calcSplitLinePoints = this.calcSplitLinePoints,
          calcArcD = this.calcArcD;


      mergeColor();

      calcPathD();

      calcPathColor();

      calcCircleR();

      calcSplitLinePoints();

      calcArcD();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    },
    calcPathD: function calcPathD() {
      var x = this.x,
          y = this.y,
          width = this.width,
          segment = this.segment,
          sectorAngle = this.sectorAngle;


      var startAngle = -Math.PI / 2;
      var angleGap = sectorAngle / segment;
      var r = width / 4;
      var lastEndPoints = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["getCircleRadianPoint"])(x, y, r, startAngle);

      this.pathD = new Array(segment).fill('').map(function (_, i) {
        var endPoints = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["getCircleRadianPoint"])(x, y, r, startAngle - (i + 1) * angleGap).map(function (_) {
          return _.toFixed(5);
        });
        var d = 'M' + lastEndPoints.join(',') + ' A' + r + ', ' + r + ' 0 0 0 ' + endPoints.join(',');
        lastEndPoints = endPoints;

        return d;
      });
    },
    calcPathColor: function calcPathColor() {
      var _mergedColor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(this.mergedColor, 1),
          color = _mergedColor[0],
          segment = this.segment;

      var colorGap = 100 / (segment - 1);

      this.pathColor = new Array(segment).fill(color).map(function (_, i) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_color__["fade"])(color, 100 - i * colorGap);
      });
    },
    calcCircleR: function calcCircleR() {
      var segment = this.segment,
          ringNum = this.ringNum,
          width = this.width,
          ringWidth = this.ringWidth;


      var radiusGap = (width / 2 - ringWidth / 2) / ringNum;

      this.circleR = new Array(ringNum).fill(0).map(function (_, i) {
        return radiusGap * (i + 1);
      });
    },
    calcSplitLinePoints: function calcSplitLinePoints() {
      var x = this.x,
          y = this.y,
          width = this.width;


      var angleGap = Math.PI / 6;
      var r = width / 2;

      this.splitLinePoints = new Array(6).fill('').map(function (_, i) {
        var startAngle = angleGap * (i + 1);
        var endAngle = startAngle + Math.PI;
        var startPoint = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["getCircleRadianPoint"])(x, y, r, startAngle);
        var endPoint = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["getCircleRadianPoint"])(x, y, r, endAngle);

        return startPoint.join(',') + ' ' + endPoint.join(',');
      });
    },
    calcArcD: function calcArcD() {
      var x = this.x,
          y = this.y,
          width = this.width;


      var angleGap = Math.PI / 6;
      var r = width / 2 - 1;

      this.arcD = new Array(4).fill('').map(function (_, i) {
        var startAngle = angleGap * (3 * i + 1);
        var endAngle = startAngle + angleGap;
        var startPoint = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["getCircleRadianPoint"])(x, y, r, startAngle);
        var endPoint = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["getCircleRadianPoint"])(x, y, r, endAngle);

        return 'M' + startPoint.join(',') + ' A' + x + ', ' + y + ' 0 0 1 ' + endPoint.join(',');
      });
    },
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var init = this.init;


      init();
    },

    fade: __WEBPACK_IMPORTED_MODULE_5__jiaminghi_color__["fade"]
  }
});

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-12"
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('g', {
    attrs: {
      "id": _vm.gId
    }
  }, _vm._l((_vm.pathD), function(d, i) {
    return _c('path', {
      key: d,
      attrs: {
        "stroke": _vm.pathColor[i],
        "stroke-width": _vm.width / 2,
        "fill": "transparent",
        "d": d
      }
    })
  }), 0), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": _vm.gradientId,
      "cx": "50%",
      "cy": "50%",
      "r": "50%"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "transparent",
      "stop-opacity": "1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30),
      "stop-opacity": "1"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.circleR), function(r) {
    return _c('circle', {
      key: r,
      attrs: {
        "r": r,
        "cx": _vm.x,
        "cy": _vm.y,
        "stroke": _vm.mergedColor[1],
        "stroke-width": 0.5,
        "fill": "transparent"
      }
    })
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "r": "1",
      "cx": _vm.x,
      "cy": _vm.y,
      "stroke": "transparent",
      "fill": ("url(#" + _vm.gradientId + ")")
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "r",
      "values": ("1;" + (_vm.width / 2)),
      "dur": (_vm.haloDur + "s"),
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "opacity",
      "values": "1;0",
      "dur": (_vm.haloDur + "s"),
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "r": "2",
      "cx": _vm.x,
      "cy": _vm.y,
      "fill": _vm.mergedColor[1]
    }
  }), _vm._v(" "), (_vm.showSplitLine) ? _c('g', _vm._l((_vm.splitLinePoints), function(p) {
    return _c('polyline', {
      key: p,
      attrs: {
        "points": p,
        "stroke": _vm.mergedColor[1],
        "stroke-width": 0.5,
        "opacity": "0.5"
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.arcD), function(d) {
    return _c('path', {
      key: d,
      attrs: {
        "d": d,
        "stroke": _vm.mergedColor[1],
        "stroke-width": "2",
        "fill": "transparent"
      }
    })
  }), _vm._v(" "), _c('use', {
    attrs: {
      "xlink:href": ("#" + _vm.gId)
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "values": ("0, " + _vm.x + " " + _vm.y + ";360, " + _vm.x + " " + _vm.y),
      "dur": (_vm.scanDur + "s"),
      "repeatCount": "indefinite"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "decoration-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1028),
  /* template */
  __webpack_require__(1029),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration2',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    dur: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      ref: 'decoration-2',

      x: 0,
      y: 0,

      w: 0,
      h: 0,

      defaultColor: ['#3faacb', '#fff'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    },
    reverse: function reverse() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var reverse = this.reverse,
          width = this.width,
          height = this.height;


      if (reverse) {
        this.w = 1;
        this.h = height;
        this.x = width / 2;
        this.y = 0;
      } else {
        this.w = width;
        this.h = 1;
        this.x = 0;
        this.y = height / 2;
      }
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-2"
  }, [_c('svg', {
    attrs: {
      "width": (_vm.width + "px"),
      "height": (_vm.height + "px")
    }
  }, [_c('rect', {
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.w,
      "height": _vm.h,
      "fill": _vm.mergedColor[0]
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": _vm.reverse ? 'height' : 'width',
      "from": "0",
      "to": _vm.reverse ? _vm.height : _vm.width,
      "dur": (_vm.dur + "s"),
      "calcMode": "spline",
      "keyTimes": "0;1",
      "keySplines": ".42,0,.58,1",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "width": "1",
      "height": "1",
      "fill": _vm.mergedColor[1]
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": _vm.reverse ? 'y' : 'x',
      "from": "0",
      "to": _vm.reverse ? _vm.height : _vm.width,
      "dur": (_vm.dur + "s"),
      "calcMode": "spline",
      "keyTimes": "0;1",
      "keySplines": "0.42,0,0.58,1",
      "repeatCount": "indefinite"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1032),
  /* template */
  __webpack_require__(1033),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration3',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var pointSideLength = 7;

    return {
      ref: 'decoration-3',

      svgWH: [300, 35],

      svgScale: [1, 1],

      rowNum: 2,
      rowPoints: 25,

      pointSideLength: pointSideLength,
      halfPointSideLength: pointSideLength / 2,

      points: [],

      defaultColor: ['#7acaec', 'transparent'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(all), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item));
      }, []);
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-3"
  }, [_c('svg', {
    style: (("transform:scale(" + (_vm.svgScale[0]) + "," + (_vm.svgScale[1]) + ");")),
    attrs: {
      "width": ((_vm.svgWH[0]) + "px"),
      "height": ((_vm.svgWH[1]) + "px")
    }
  }, [_vm._l((_vm.points), function(point, i) {
    return [_c('rect', {
      key: i,
      attrs: {
        "fill": _vm.mergedColor[0],
        "x": point[0] - _vm.halfPointSideLength,
        "y": point[1] - _vm.halfPointSideLength,
        "width": _vm.pointSideLength,
        "height": _vm.pointSideLength
      }
    }, [(Math.random() > 0.6) ? _c('animate', {
      attrs: {
        "attributeName": "fill",
        "values": ("" + (_vm.mergedColor.join(';'))),
        "dur": Math.random() + 1 + 's',
        "begin": Math.random() * 2,
        "repeatCount": "indefinite"
      }
    }) : _vm._e()])]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1036),
  /* template */
  __webpack_require__(1037),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration4',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    dur: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    return {
      ref: 'decoration-4',

      defaultColor: ['rgba(255, 255, 255, 0.3)', 'rgba(255, 255, 255, 0.3)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-4"
  }, [_c('div', {
    class: ("container " + (_vm.reverse ? 'reverse' : 'normal')),
    style: (_vm.reverse ? ("width:" + _vm.width + "px;height:5px;animation-duration:" + _vm.dur + "s") : ("width:5px;height:" + _vm.height + "px;animation-duration:" + _vm.dur + "s"))
  }, [_c('svg', {
    attrs: {
      "width": _vm.reverse ? _vm.width : 5,
      "height": _vm.reverse ? 5 : _vm.height
    }
  }, [_c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "points": _vm.reverse ? ("0, 2.5 " + _vm.width + ", 2.5") : ("2.5, 0 2.5, " + _vm.height)
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "bold-line",
    attrs: {
      "stroke": _vm.mergedColor[1],
      "stroke-width": "3",
      "stroke-dasharray": "20, 80",
      "stroke-dashoffset": "-30",
      "points": _vm.reverse ? ("0, 2.5 " + _vm.width + ", 2.5") : ("2.5, 0 2.5, " + _vm.height)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1040),
  /* template */
  __webpack_require__(1041),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration5',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 1.2
    }
  },
  data: function data() {
    return {
      ref: 'decoration-5',

      line1Points: '',
      line2Points: '',

      line1Length: 0,
      line2Length: 0,

      defaultColor: ['#3f96a5', '#3f96a5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var width = this.width,
          height = this.height;


      var line1Points = [[0, height * 0.2], [width * 0.18, height * 0.2], [width * 0.2, height * 0.4], [width * 0.25, height * 0.4], [width * 0.27, height * 0.6], [width * 0.72, height * 0.6], [width * 0.75, height * 0.4], [width * 0.8, height * 0.4], [width * 0.82, height * 0.2], [width, height * 0.2]];

      var line2Points = [[width * 0.3, height * 0.8], [width * 0.7, height * 0.8]];

      var line1Length = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util__["getPolylineLength"])(line1Points);
      var line2Length = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util__["getPolylineLength"])(line2Points);

      line1Points = line1Points.map(function (point) {
        return point.join(',');
      }).join(' ');
      line2Points = line2Points.map(function (point) {
        return point.join(',');
      }).join(' ');

      this.line1Points = line1Points;
      this.line2Points = line2Points;

      this.line1Length = line1Length;
      this.line2Length = line2Length;
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-5"
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polyline', {
    attrs: {
      "fill": "transparent",
      "stroke": _vm.mergedColor[0],
      "stroke-width": "3",
      "points": _vm.line1Points
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dasharray",
      "attributeType": "XML",
      "from": ("0, " + (_vm.line1Length / 2) + ", 0, " + (_vm.line1Length / 2)),
      "to": ("0, 0, " + _vm.line1Length + ", 0"),
      "dur": (_vm.dur + "s"),
      "begin": "0s",
      "calcMode": "spline",
      "keyTimes": "0;1",
      "keySplines": "0.4,1,0.49,0.98",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "transparent",
      "stroke": _vm.mergedColor[1],
      "stroke-width": "2",
      "points": _vm.line2Points
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dasharray",
      "attributeType": "XML",
      "from": ("0, " + (_vm.line2Length / 2) + ", 0, " + (_vm.line2Length / 2)),
      "to": ("0, 0, " + _vm.line2Length + ", 0"),
      "dur": (_vm.dur + "s"),
      "begin": "0s",
      "calcMode": "spline",
      "keyTimes": "0;1",
      "keySplines": ".4,1,.49,.98",
      "repeatCount": "indefinite"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1044),
  /* template */
  __webpack_require__(1045),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration6',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var rectWidth = 7;

    return {
      ref: 'decoration-6',

      svgWH: [300, 35],

      svgScale: [1, 1],

      rowNum: 1,
      rowPoints: 40,

      rectWidth: rectWidth,
      halfRectWidth: rectWidth / 2,

      points: [],
      heights: [],
      minHeights: [],
      randoms: [],

      defaultColor: ['#7acaec', '#7acaec'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(all), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item));
      }, []);
      var heights = this.heights = new Array(rowNum * rowPoints).fill(0).map(function (foo) {
        return Math.random() > 0.8 ? Object(__WEBPACK_IMPORTED_MODULE_3__util__["d" /* randomExtend */])(0.7 * h, h) : Object(__WEBPACK_IMPORTED_MODULE_3__util__["d" /* randomExtend */])(0.2 * h, 0.5 * h);
      });

      this.minHeights = new Array(rowNum * rowPoints).fill(0).map(function (foo, i) {
        return heights[i] * Math.random();
      });

      this.randoms = new Array(rowNum * rowPoints).fill(0).map(function (foo) {
        return Math.random() + 1.5;
      });
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-6"
  }, [_c('svg', {
    style: (("transform:scale(" + (_vm.svgScale[0]) + "," + (_vm.svgScale[1]) + ");")),
    attrs: {
      "width": ((_vm.svgWH[0]) + "px"),
      "height": ((_vm.svgWH[1]) + "px")
    }
  }, [_vm._l((_vm.points), function(point, i) {
    return [_c('rect', {
      key: i,
      attrs: {
        "fill": _vm.mergedColor[Math.random() > 0.5 ? 0 : 1],
        "x": point[0] - _vm.halfRectWidth,
        "y": point[1] - _vm.heights[i] / 2,
        "width": _vm.rectWidth,
        "height": _vm.heights[i]
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "y",
        "values": ((point[1] - _vm.minHeights[i] / 2) + ";" + (point[1] - _vm.heights[i] / 2) + ";" + (point[1] - _vm.minHeights[i] / 2)),
        "dur": ((_vm.randoms[i]) + "s"),
        "keyTimes": "0;0.5;1",
        "calcMode": "spline",
        "keySplines": "0.42,0,0.58,1;0.42,0,0.58,1",
        "begin": "0s",
        "repeatCount": "indefinite"
      }
    }), _vm._v(" "), _c('animate', {
      attrs: {
        "attributeName": "height",
        "values": ((_vm.minHeights[i]) + ";" + (_vm.heights[i]) + ";" + (_vm.minHeights[i])),
        "dur": ((_vm.randoms[i]) + "s"),
        "keyTimes": "0;0.5;1",
        "calcMode": "spline",
        "keySplines": "0.42,0,0.58,1;0.42,0,0.58,1",
        "begin": "0s",
        "repeatCount": "indefinite"
      }
    })])]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1048),
  /* template */
  __webpack_require__(1049),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration7',
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      defaultColor: ['#1dc1f5', '#1dc1f5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_0__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dv-decoration-7"
  }, [_c('svg', {
    attrs: {
      "width": "21px",
      "height": "20px"
    }
  }, [_c('polyline', {
    attrs: {
      "stroke-width": "4",
      "fill": "transparent",
      "stroke": _vm.mergedColor[0],
      "points": "10, 0 19, 10 10, 20"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke-width": "2",
      "fill": "transparent",
      "stroke": _vm.mergedColor[1],
      "points": "2, 0 11, 10 2, 20"
    }
  })]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "21px",
      "height": "20px"
    }
  }, [_c('polyline', {
    attrs: {
      "stroke-width": "4",
      "fill": "transparent",
      "stroke": _vm.mergedColor[0],
      "points": "11, 0 2, 10 11, 20"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke-width": "2",
      "fill": "transparent",
      "stroke": _vm.mergedColor[1],
      "points": "19, 0 10, 10 19, 20"
    }
  })])], 2)
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1052),
  /* template */
  __webpack_require__(1053),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration8',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ref: 'decoration-8',

      defaultColor: ['#3f96a5', '#3f96a5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    xPos: function xPos(pos) {
      var reverse = this.reverse,
          width = this.width;


      if (!reverse) return pos;

      return width - pos;
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_1__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_2__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-8"
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "stroke-width": "2",
      "fill": "transparent",
      "points": ((_vm.xPos(0)) + ", 0 " + (_vm.xPos(30)) + ", " + (_vm.height / 2))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[0],
      "stroke-width": "2",
      "fill": "transparent",
      "points": ((_vm.xPos(20)) + ", 0 " + (_vm.xPos(50)) + ", " + (_vm.height / 2) + " " + (_vm.xPos(_vm.width)) + ", " + (_vm.height / 2))
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke": _vm.mergedColor[1],
      "fill": "transparent",
      "stroke-width": "3",
      "points": ((_vm.xPos(0)) + ", " + (_vm.height - 3) + ", " + (_vm.xPos(200)) + ", " + (_vm.height - 3))
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1056),
  /* template */
  __webpack_require__(1057),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_color__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvDecoration9',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_autoResize__["a" /* default */]],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_2__util_index__["e" /* uuid */])();
    return {
      ref: 'decoration-9',

      polygonId: 'decoration-9-polygon-' + id,

      svgWH: [100, 100],

      svgScale: [1, 1],

      defaultColor: ['rgba(3, 166, 224, 0.8)', 'rgba(3, 166, 224, 0.5)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcScale = this.calcScale;


      calcScale();
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcScale = this.calcScale;


      calcScale();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultColor, true), color || []);
    },

    fade: __WEBPACK_IMPORTED_MODULE_5__jiaminghi_color__["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-decoration-9"
  }, [_c('svg', {
    style: (("transform:scale(" + (_vm.svgScale[0]) + "," + (_vm.svgScale[1]) + ");")),
    attrs: {
      "width": ((_vm.svgWH[0]) + "px"),
      "height": ((_vm.svgWH[1]) + "px")
    }
  }, [_c('defs', [_c('polygon', {
    attrs: {
      "id": _vm.polygonId,
      "points": "15, 46.5, 21, 47.5, 21, 52.5, 15, 53.5"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "45",
      "fill": "transparent",
      "stroke": _vm.mergedColor[1],
      "stroke-width": "10",
      "stroke-dasharray": "80, 100, 30, 100"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "values": "0 50 50;360 50 50",
      "dur": (_vm.dur + "s"),
      "repeatCount": "indefinite"
    }
  })], 1), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "45",
      "fill": "transparent",
      "stroke": _vm.mergedColor[0],
      "stroke-width": "6",
      "stroke-dasharray": "50, 66, 100, 66"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "values": "0 50 50;-360 50 50",
      "dur": (_vm.dur + "s"),
      "repeatCount": "indefinite"
    }
  })], 1), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "fill": "transparent",
      "stroke": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30),
      "stroke-width": "1",
      "stroke-dasharray": "5, 1"
    }
  }), _vm._v(" "), _vm._l((new Array(20).fill(0)), function(foo, i) {
    return _c('use', {
      key: i,
      attrs: {
        "xlink:href": ("#" + _vm.polygonId),
        "stroke": _vm.mergedColor[1],
        "fill": Math.random() > 0.4 ? 'transparent' : _vm.mergedColor[0]
      }
    }, [_c('animateTransform', {
      attrs: {
        "attributeName": "transform",
        "type": "rotate",
        "values": "0 50 50;360 50 50",
        "dur": (_vm.dur + "s"),
        "begin": ((i * _vm.dur / 20) + "s"),
        "repeatCount": "indefinite"
      }
    })], 1)
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "26",
      "fill": "transparent",
      "stroke": _vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30),
      "stroke-width": "1",
      "stroke-dasharray": "5, 1"
    }
  })], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1061),
  /* template */
  __webpack_require__(1062),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixin_autoResize__ = __webpack_require__(9);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvFlylineChart',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixin_autoResize__["a" /* default */]],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dev: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["e" /* uuid */])();
    return {
      ref: 'dv-flyline-chart',
      unique: Math.random(),
      maskId: 'flyline-mask-id-' + id,
      maskCircleId: 'mask-circle-id-' + id,
      gradientId: 'gradient-id-' + id,
      gradient2Id: 'gradient2-id-' + id,

      defaultConfig: {
        /**
         * @description Flyline chart center point
         * @type {Array<Number>}
         * @default centerPoint = [0, 0]
         */
        centerPoint: [0, 0],
        /**
         * @description Flyline start points
         * @type {Array<Array<Number>>}
         * @default points = []
         * @example points = [[10, 10], [100, 100]]
         */
        points: [],
        /**
         * @description Flyline width
         * @type {Number}
         * @default lineWidth = 1
         */
        lineWidth: 1,
        /**
         * @description Orbit color
         * @type {String}
         * @default orbitColor = 'rgba(103, 224, 227, .2)'
         */
        orbitColor: 'rgba(103, 224, 227, .2)',
        /**
         * @description Flyline color
         * @type {String}
         * @default orbitColor = '#ffde93'
         */
        flylineColor: '#ffde93',
        /**
         * @description K value
         * @type {Number}
         * @default k = -0.5
         * @example k = -1 ~ 1
         */
        k: -0.5,
        /**
         * @description Flyline curvature
         * @type {Number}
         * @default curvature = 5
         */
        curvature: 5,
        /**
         * @description Flyline radius
         * @type {Number}
         * @default flylineRadius = 100
         */
        flylineRadius: 100,
        /**
         * @description Flyline animation duration
         * @type {Array<Number>}
         * @default duration = [20, 30]
         */
        duration: [20, 30],
        /**
         * @description Relative points position
         * @type {Boolean}
         * @default relative = true
         */
        relative: true,
        /**
         * @description Back ground image url
         * @type {String}
         * @default bgImgUrl = ''
         * @example bgImgUrl = './img/bg.jpg'
         */
        bgImgUrl: '',
        /**
         * @description Text configuration
         * @type {Object}
         */
        text: {
          /**
           * @description Text offset
           * @type {Array<Number>}
           * @default offset = [0, 15]
           */
          offset: [0, 15],
          /**
           * @description Text color
           * @type {String}
           * @default color = '#ffdb5c'
           */
          color: '#ffdb5c',
          /**
           * @description Text font size
           * @type {Number}
           * @default fontSize = 12
           */
          fontSize: 12
        },
        /**
         * @description Halo configuration
         * @type {Object}
         */
        halo: {
          /**
           * @description Weather to show halo
           * @type {Boolean}
           * @default show = true
           * @example show = true | false
           */
          show: true,
          /**
           * @description Halo animation duration (10 = 1s)
           * @type {Number}
           * @default duration = 30
           */
          duration: 30,
          /**
           * @description Halo color
           * @type {String}
           * @default color = '#fb7293'
           */
          color: '#fb7293',
          /**
           * @description Halo max radius
           * @type {Number}
           * @default radius = 120
           */
          radius: 120
        },
        /**
         * @description Center point img configuration
         * @type {Object}
         */
        centerPointImg: {
          /**
           * @description Center point img width
           * @type {Number}
           * @default width = 40
           */
          width: 40,
          /**
           * @description Center point img height
           * @type {Number}
           * @default height = 40
           */
          height: 40,
          /**
           * @description Center point img url
           * @type {String}
           * @default url = ''
           */
          url: ''
        },
        /**
         * @description Points img configuration
         * @type {Object}
         * @default radius = 120
         */
        pointsImg: {
          /**
           * @description Points img width
           * @type {Number}
           * @default width = 15
           */
          width: 15,
          /**
           * @description Points img height
           * @type {Number}
           * @default height = 15
           */
          height: 15,
          /**
           * @description Points img url
           * @type {String}
           * @default url = ''
           */
          url: ''
        }
      },

      mergedConfig: null,

      paths: [],
      lengths: [],
      times: [],
      texts: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var mergeConfig, createFlylinePaths, calcLineLengths, calcTimes, calcTexts;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mergeConfig = _this.mergeConfig, createFlylinePaths = _this.createFlylinePaths, calcLineLengths = _this.calcLineLengths;


                mergeConfig();

                createFlylinePaths();

                _context.next = 5;
                return calcLineLengths();

              case 5:
                calcTimes = _this.calcTimes, calcTexts = _this.calcTexts;


                calcTimes();

                calcTexts();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      var mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});

      var points = mergedConfig.points;


      mergedConfig.points = points.map(function (item) {
        if (item instanceof Array) {
          return { position: item, text: '' };
        }

        return item;
      });

      this.mergedConfig = mergedConfig;
    },
    createFlylinePaths: function createFlylinePaths() {
      var getPath = this.getPath,
          mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var centerPoint = mergedConfig.centerPoint,
          points = mergedConfig.points,
          relative = mergedConfig.relative;


      points = points.map(function (_ref) {
        var position = _ref.position;
        return position;
      });

      if (relative) {
        centerPoint = [width * centerPoint[0], height * centerPoint[1]];
        points = points.map(function (_ref2) {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
              x = _ref3[0],
              y = _ref3[1];

          return [width * x, height * y];
        });
      }

      this.paths = points.map(function (point) {
        return getPath(centerPoint, point);
      });
    },
    getPath: function getPath(center, point) {
      var getControlPoint = this.getControlPoint;


      var controlPoint = getControlPoint(center, point);

      return [point, controlPoint, center];
    },
    getControlPoint: function getControlPoint(_ref4, _ref5) {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
          sx = _ref7[0],
          sy = _ref7[1];

      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
          ex = _ref6[0],
          ey = _ref6[1];

      var getKLinePointByx = this.getKLinePointByx,
          mergedConfig = this.mergedConfig;
      var curvature = mergedConfig.curvature,
          k = mergedConfig.k;
      var mx = (sx + ex) / 2,
          my = (sy + ey) / 2;


      var distance = Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["b" /* getPointDistance */])([sx, sy], [ex, ey]);

      var targetLength = distance / curvature;
      var disDived = targetLength / 2;

      var dx = mx,
          dy = my;


      do {
        dx += disDived;
        dy = getKLinePointByx(k, [mx, my], dx)[1];
      } while (Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["b" /* getPointDistance */])([mx, my], [dx, dy]) < targetLength);

      return [dx, dy];
    },
    getKLinePointByx: function getKLinePointByx(k, _ref8, x) {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
          lx = _ref9[0],
          ly = _ref9[1];

      var y = ly - k * lx + k * x;

      return [x, y];
    },
    calcLineLengths: function calcLineLengths() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var $nextTick, paths, $refs;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, paths = _this2.paths, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:

                _this2.lengths = paths.map(function (foo, i) {
                  return $refs['path' + i][0].getTotalLength();
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    calcTimes: function calcTimes() {
      var _mergedConfig = this.mergedConfig,
          duration = _mergedConfig.duration,
          points = _mergedConfig.points;


      this.times = points.map(function (foo) {
        return __WEBPACK_IMPORTED_MODULE_6__util_index__["d" /* randomExtend */].apply(undefined, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(duration)) / 10;
      });
    },
    calcTexts: function calcTexts() {
      var points = this.mergedConfig.points;


      this.texts = points.map(function (_ref10) {
        var text = _ref10.text;
        return text;
      });
    },
    consoleClickPos: function consoleClickPos(_ref11) {
      var offsetX = _ref11.offsetX,
          offsetY = _ref11.offsetY;
      var width = this.width,
          height = this.height,
          dev = this.dev;


      if (!dev) return;

      var relativeX = (offsetX / width).toFixed(2);
      var relativeY = (offsetY / height).toFixed(2);

      console.warn('dv-flyline-chart DEV: \n Click Position is [' + offsetX + ', ' + offsetY + '] \n Relative Position is [' + relativeX + ', ' + relativeY + ']');
    }
  }
});

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dv-flyline-chart",
    staticClass: "dv-flyline-chart",
    style: (("background-image: url(" + (_vm.mergedConfig ? _vm.mergedConfig.bgImgUrl : '') + ")")),
    on: {
      "click": _vm.consoleClickPos
    }
  }, [(_vm.mergedConfig) ? _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('radialGradient', {
    attrs: {
      "id": _vm.gradientId,
      "cx": "50%",
      "cy": "50%",
      "r": "50%"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#fff",
      "stop-opacity": "1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#fff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": _vm.gradient2Id,
      "cx": "50%",
      "cy": "50%",
      "r": "50%"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#fff",
      "stop-opacity": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#fff",
      "stop-opacity": "1"
    }
  })], 1), _vm._v(" "), (_vm.paths[0]) ? _c('circle', {
    attrs: {
      "id": ("circle" + (_vm.paths[0].toString())),
      "cx": _vm.paths[0][2][0],
      "cy": _vm.paths[0][2][1]
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "r",
      "values": ("1;" + (_vm.mergedConfig.halo.radius)),
      "dur": _vm.mergedConfig.halo.duration / 10 + 's',
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "opacity",
      "values": "1;0",
      "dur": _vm.mergedConfig.halo.duration / 10 + 's',
      "repeatCount": "indefinite"
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.paths[0]) ? _c('image', {
    attrs: {
      "xlink:href": _vm.mergedConfig.centerPointImg.url,
      "width": _vm.mergedConfig.centerPointImg.width,
      "height": _vm.mergedConfig.centerPointImg.height,
      "x": _vm.paths[0][2][0] - _vm.mergedConfig.centerPointImg.width / 2,
      "y": _vm.paths[0][2][1] - _vm.mergedConfig.centerPointImg.height / 2
    }
  }) : _vm._e(), _vm._v(" "), _c('mask', {
    attrs: {
      "id": ("maskhalo" + (_vm.paths[0].toString()))
    }
  }, [(_vm.paths[0]) ? _c('use', {
    attrs: {
      "xlink:href": ("#circle" + (_vm.paths[0].toString())),
      "fill": ("url(#" + _vm.gradient2Id + ")")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.paths[0] && _vm.mergedConfig.halo.show) ? _c('use', {
    attrs: {
      "xlink:href": ("#circle" + (_vm.paths[0].toString())),
      "fill": _vm.mergedConfig.halo.color,
      "mask": ("url(#maskhalo" + (_vm.paths[0].toString()) + ")")
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.paths), function(path, i) {
    return _c('g', {
      key: i
    }, [_c('defs', [_c('path', {
      ref: ("path" + i),
      refInFor: true,
      attrs: {
        "id": ("path" + (path.toString())),
        "d": ("M" + (path[0].toString()) + " Q" + (path[1].toString()) + " " + (path[2].toString())),
        "fill": "transparent"
      }
    })]), _vm._v(" "), _c('use', {
      attrs: {
        "xlink:href": ("#path" + (path.toString())),
        "stroke-width": _vm.mergedConfig.lineWidth,
        "stroke": _vm.mergedConfig.orbitColor
      }
    }), _vm._v(" "), (_vm.lengths[i]) ? _c('use', {
      attrs: {
        "xlink:href": ("#path" + (path.toString())),
        "stroke-width": _vm.mergedConfig.lineWidth,
        "stroke": _vm.mergedConfig.flylineColor,
        "mask": ("url(#mask" + _vm.unique + (path.toString()) + ")")
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "stroke-dasharray",
        "from": ("0, " + (_vm.lengths[i])),
        "to": ((_vm.lengths[i]) + ", 0"),
        "dur": _vm.times[i] || 0,
        "repeatCount": "indefinite"
      }
    })]) : _vm._e(), _vm._v(" "), _c('mask', {
      attrs: {
        "id": ("mask" + _vm.unique + (path.toString()))
      }
    }, [_c('circle', {
      attrs: {
        "cx": "0",
        "cy": "0",
        "r": _vm.mergedConfig.flylineRadius,
        "fill": ("url(#" + _vm.gradientId + ")")
      }
    }, [_c('animateMotion', {
      attrs: {
        "dur": _vm.times[i] || 0,
        "path": ("M" + (path[0].toString()) + " Q" + (path[1].toString()) + " " + (path[2].toString())),
        "rotate": "auto",
        "repeatCount": "indefinite"
      }
    })], 1)]), _vm._v(" "), _c('image', {
      attrs: {
        "xlink:href": _vm.mergedConfig.pointsImg.url,
        "width": _vm.mergedConfig.pointsImg.width,
        "height": _vm.mergedConfig.pointsImg.height,
        "x": path[0][0] - _vm.mergedConfig.pointsImg.width / 2,
        "y": path[0][1] - _vm.mergedConfig.pointsImg.height / 2
      }
    }), _vm._v(" "), _c('text', {
      style: (("fontSize:" + (_vm.mergedConfig.text.fontSize) + "px;")),
      attrs: {
        "fill": _vm.mergedConfig.text.color,
        "x": path[0][0] + _vm.mergedConfig.text.offset[0],
        "y": path[0][1] + _vm.mergedConfig.text.offset[1]
      }
    }, [_vm._v("\n        " + _vm._s(_vm.texts[i]) + "\n      ")])])
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1065),
  /* template */
  __webpack_require__(1066),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixin_autoResize__ = __webpack_require__(9);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvFlylineChartEnhanced',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixin_autoResize__["a" /* default */]],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dev: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["e" /* uuid */])();
    return {
      ref: 'dv-flyline-chart-enhanced',
      unique: Math.random(),
      flylineGradientId: 'flyline-gradient-id-' + id,
      haloGradientId: 'halo-gradient-id-' + id,
      /**
       * @description Type Declaration
       * 
       * interface Halo {
       *    show?: boolean
       *    duration?: [number, number]
       *    color?: string
       *    radius?: number
       * }
       * 
       * interface Text {
       *    show?: boolean
       *    offset?: [number, number]
       *    color?: string
       *    fontSize?: number
       * }
       * 
       * interface Icon {
       *    show?: boolean
       *    src?: string
       *    width?: number
       *    height?: number
       * }
       * 
       * interface Point {
       *    name: string
       *    coordinate: [number, number]
       *    halo?: Halo
       *    text?: Text
       *    icon?: Icon
       * }
       * 
       * interface Line {
       *    width?: number
       *    color?: string
       *    orbitColor?: string
       *    duration?: [number, number]
       *    radius?: string
       * }
       * 
       * interface Flyline extends Line {
       *    source: string
       *    target: string
       * }
       * 
       * interface FlylineWithPath extends Flyline {
       *    d: string
       *    path: [[number, number], [number, number], [number, number]]
       *    key: string
       * }
       */
      defaultConfig: {
        /**
         * @description Flyline chart points
         * @type {Point[]}
         * @default points = []
         */
        points: [],
        /**
         * @description Lines
         * @type {Flyline[]}
         * @default lines = []
         */
        lines: [],
        /**
         * @description Global halo configuration
         * @type {Halo}
         */
        halo: {
          /**
           * @description Whether to show halo
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Halo animation duration (1s = 10)
           * @type {[number, number]}
           */
          duration: [20, 30],
          /**
           * @description Halo color
           * @type {String}
           * @default color = '#fb7293'
           */
          color: '#fb7293',
          /**
           * @description Halo radius
           * @type {Number}
           * @default radius = 120
           */
          radius: 120
        },
        /**
         * @description Global text configuration
         * @type {Text}
         */
        text: {
          /**
           * @description Whether to show text
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Text offset
           * @type {[number, number]}
           * @default offset = [0, 15]
           */
          offset: [0, 15],
          /**
           * @description Text color
           * @type {String}
           * @default color = '#ffdb5c'
           */
          color: '#ffdb5c',
          /**
           * @description Text font size
           * @type {Number}
           * @default fontSize = 12
           */
          fontSize: 12
        },
        /**
         * @description Global icon configuration
         * @type {Icon}
         */
        icon: {
          /**
           * @description Whether to show icon
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Icon src
           * @type {String}
           * @default src = ''
           */
          src: '',
          /**
           * @description Icon width
           * @type {Number}
           * @default width = 15
           */
          width: 15,
          /**
           * @description Icon height
           * @type {Number}
           * @default width = 15
           */
          height: 15
        },
        /**
         * @description Global line configuration
         * @type {Line}
         */
        line: {
          /**
           * @description Line width
           * @type {Number}
           * @default width = 1
           */
          width: 1,
          /**
           * @description Flyline color
           * @type {String}
           * @default color = '#ffde93'
           */
          color: '#ffde93',
          /**
           * @description Orbit color
           * @type {String}
           * @default orbitColor = 'rgba(103, 224, 227, .2)'
           */
          orbitColor: 'rgba(103, 224, 227, .2)',
          /**
           * @description Flyline animation duration
           * @type {[number, number]}
           * @default duration = [20, 30]
           */
          duration: [20, 30],
          /**
           * @description Flyline radius
           * @type {Number}
           * @default radius = 100
           */
          radius: 100
        },
        /**
         * @description Back ground image url
         * @type {String}
         * @default bgImgSrc = ''
         */
        bgImgSrc: '',
        /**
         * @description K value
         * @type {Number}
         * @default k = -0.5
         * @example k = -1 ~ 1
         */
        k: -0.5,
        /**
         * @description Flyline curvature
         * @type {Number}
         * @default curvature = 5
         */
        curvature: 5,
        /**
         * @description Relative points position
         * @type {Boolean}
         * @default relative = true
         */
        relative: true
      },
      /**
       * @description Fly line data
       * @type {FlylineWithPath[]}
       * @default flylines = []
       */
      flylines: [],
      /**
       * @description Fly line lengths
       * @type {Number[]}
       * @default flylineLengths = []
       */
      flylineLengths: [],
      /**
       * @description Fly line points
       * @default flylinePoints = []
       */
      flylinePoints: [],

      mergedConfig: null
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var mergeConfig, calcflylinePoints, calcLinePaths, calcLineLengths;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mergeConfig = _this.mergeConfig, calcflylinePoints = _this.calcflylinePoints, calcLinePaths = _this.calcLinePaths;


                mergeConfig();

                calcflylinePoints();

                calcLinePaths();

                calcLineLengths = _this.calcLineLengths;
                _context.next = 7;
                return calcLineLengths();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      var mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});

      var points = mergedConfig.points,
          lines = mergedConfig.lines,
          halo = mergedConfig.halo,
          text = mergedConfig.text,
          icon = mergedConfig.icon,
          line = mergedConfig.line;


      mergedConfig.points = points.map(function (item) {
        item.halo = Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__["deepClone"])(halo, true), item.halo || {});
        item.text = Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__["deepClone"])(text, true), item.text || {});
        item.icon = Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__["deepClone"])(icon, true), item.icon || {});

        return item;
      });

      mergedConfig.lines = lines.map(function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__["deepClone"])(line, true), item);
      });

      this.mergedConfig = mergedConfig;
    },
    calcflylinePoints: function calcflylinePoints() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var relative = mergedConfig.relative,
          points = mergedConfig.points;


      this.flylinePoints = points.map(function (item, i) {
        var _item$coordinate = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(item.coordinate, 2),
            x = _item$coordinate[0],
            y = _item$coordinate[1],
            halo = item.halo,
            icon = item.icon,
            text = item.text;

        if (relative) item.coordinate = [x * width, y * height];

        item.halo.time = __WEBPACK_IMPORTED_MODULE_7__util_index__["d" /* randomExtend */].apply(undefined, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(halo.duration)) / 10;

        var iw = icon.width,
            ih = icon.height;

        item.icon.x = item.coordinate[0] - iw / 2;
        item.icon.y = item.coordinate[1] - ih / 2;

        var _text$offset = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(text.offset, 2),
            ox = _text$offset[0],
            oy = _text$offset[1];

        item.text.x = item.coordinate[0] + ox;
        item.text.y = item.coordinate[1] + oy;

        item.key = '' + item.coordinate.toString() + i;

        return item;
      });
    },
    calcLinePaths: function calcLinePaths() {
      var getPath = this.getPath,
          mergedConfig = this.mergedConfig;
      var points = mergedConfig.points,
          lines = mergedConfig.lines;


      this.flylines = lines.map(function (item) {
        var source = item.source,
            target = item.target,
            duration = item.duration;


        var sourcePoint = points.find(function (_ref) {
          var name = _ref.name;
          return name === source;
        }).coordinate;
        var targetPoint = points.find(function (_ref2) {
          var name = _ref2.name;
          return name === target;
        }).coordinate;

        var path = getPath(sourcePoint, targetPoint).map(function (item) {
          return item.map(function (v) {
            return parseFloat(v.toFixed(10));
          });
        });
        var d = 'M' + path[0].toString() + ' Q' + path[1].toString() + ' ' + path[2].toString();
        var key = 'path' + path.toString();
        var time = __WEBPACK_IMPORTED_MODULE_7__util_index__["d" /* randomExtend */].apply(undefined, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(duration)) / 10;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { path: path, key: key, d: d, time: time });
      });
    },
    getPath: function getPath(start, end) {
      var getControlPoint = this.getControlPoint;


      var controlPoint = getControlPoint(start, end);

      return [start, controlPoint, end];
    },
    getControlPoint: function getControlPoint(_ref3, _ref4) {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          sx = _ref6[0],
          sy = _ref6[1];

      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
          ex = _ref5[0],
          ey = _ref5[1];

      var getKLinePointByx = this.getKLinePointByx,
          mergedConfig = this.mergedConfig;
      var curvature = mergedConfig.curvature,
          k = mergedConfig.k;
      var mx = (sx + ex) / 2,
          my = (sy + ey) / 2;


      var distance = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["b" /* getPointDistance */])([sx, sy], [ex, ey]);

      var targetLength = distance / curvature;
      var disDived = targetLength / 2;

      var dx = mx,
          dy = my;


      do {
        dx += disDived;
        dy = getKLinePointByx(k, [mx, my], dx)[1];
      } while (Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["b" /* getPointDistance */])([mx, my], [dx, dy]) < targetLength);

      return [dx, dy];
    },
    getKLinePointByx: function getKLinePointByx(k, _ref7, x) {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
          lx = _ref8[0],
          ly = _ref8[1];

      var y = ly - k * lx + k * x;

      return [x, y];
    },
    calcLineLengths: function calcLineLengths() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var $nextTick, flylines, $refs;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, flylines = _this2.flylines, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:

                _this2.flylineLengths = flylines.map(function (_ref9) {
                  var key = _ref9.key;
                  return $refs[key][0].getTotalLength();
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    consoleClickPos: function consoleClickPos(_ref10) {
      var offsetX = _ref10.offsetX,
          offsetY = _ref10.offsetY;
      var width = this.width,
          height = this.height,
          dev = this.dev;


      if (!dev) return;

      var relativeX = (offsetX / width).toFixed(2);
      var relativeY = (offsetY / height).toFixed(2);

      console.warn('dv-flyline-chart-enhanced DEV: \n Click Position is [' + offsetX + ', ' + offsetY + '] \n Relative Position is [' + relativeX + ', ' + relativeY + ']');
    }
  }
});

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-flyline-chart-enhanced",
    style: (("background-image: url(" + (_vm.mergedConfig ? _vm.mergedConfig.bgImgSrc : '') + ")")),
    on: {
      "click": _vm.consoleClickPos
    }
  }, [(_vm.flylines.length) ? _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('radialGradient', {
    attrs: {
      "id": _vm.flylineGradientId,
      "cx": "50%",
      "cy": "50%",
      "r": "50%"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#fff",
      "stop-opacity": "1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#fff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": _vm.haloGradientId,
      "cx": "50%",
      "cy": "50%",
      "r": "50%"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#fff",
      "stop-opacity": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#fff",
      "stop-opacity": "1"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.flylinePoints), function(point) {
    return _c('g', {
      key: point.key + Math.random()
    }, [_c('defs', [(point.halo.show) ? _c('circle', {
      attrs: {
        "id": ("halo" + _vm.unique + (point.key)),
        "cx": point.coordinate[0],
        "cy": point.coordinate[1]
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "r",
        "values": ("1;" + (point.halo.radius)),
        "dur": ((point.halo.time) + "s"),
        "repeatCount": "indefinite"
      }
    }), _vm._v(" "), _c('animate', {
      attrs: {
        "attributeName": "opacity",
        "values": "1;0",
        "dur": ((point.halo.time) + "s"),
        "repeatCount": "indefinite"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('mask', {
      attrs: {
        "id": ("mask" + _vm.unique + (point.key))
      }
    }, [(point.halo.show) ? _c('use', {
      attrs: {
        "xlink:href": ("#halo" + _vm.unique + (point.key)),
        "fill": ("url(#" + _vm.haloGradientId + ")")
      }
    }) : _vm._e()]), _vm._v(" "), (point.halo.show) ? _c('use', {
      attrs: {
        "xlink:href": ("#halo" + _vm.unique + (point.key)),
        "fill": point.halo.color,
        "mask": ("url(#mask" + _vm.unique + (point.key) + ")")
      }
    }) : _vm._e(), _vm._v(" "), (point.icon.show) ? _c('image', {
      attrs: {
        "xlink:href": point.icon.src,
        "width": point.icon.width,
        "height": point.icon.height,
        "x": point.icon.x,
        "y": point.icon.y
      }
    }) : _vm._e(), _vm._v(" "), (point.text.show) ? _c('text', {
      style: (("fontSize:" + (point.text.fontSize) + "px;color:" + (point.text.color))),
      attrs: {
        "fill": point.text.color,
        "x": point.text.x,
        "y": point.text.y
      }
    }, [_vm._v("\n        " + _vm._s(point.name) + "\n      ")]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.flylines), function(line, i) {
    return _c('g', {
      key: line.key + Math.random()
    }, [_c('defs', [_c('path', {
      ref: line.key,
      refInFor: true,
      attrs: {
        "id": line.key,
        "d": line.d,
        "fill": "transparent"
      }
    })]), _vm._v(" "), _c('use', {
      attrs: {
        "xlink:href": ("#" + (line.key)),
        "stroke-width": line.width,
        "stroke": line.orbitColor
      }
    }), _vm._v(" "), _c('mask', {
      attrs: {
        "id": ("mask" + _vm.unique + (line.key))
      }
    }, [_c('circle', {
      attrs: {
        "cx": "0",
        "cy": "0",
        "r": line.radius,
        "fill": ("url(#" + _vm.flylineGradientId + ")")
      }
    }, [_c('animateMotion', {
      attrs: {
        "dur": line.time,
        "path": line.d,
        "rotate": "auto",
        "repeatCount": "indefinite"
      }
    })], 1)]), _vm._v(" "), (_vm.flylineLengths[i]) ? _c('use', {
      attrs: {
        "xlink:href": ("#" + (line.key)),
        "stroke-width": line.width,
        "stroke": line.color,
        "mask": ("url(#mask" + _vm.unique + (line.key) + ")")
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "stroke-dasharray",
        "from": ("0, " + (_vm.flylineLengths[i])),
        "to": ((_vm.flylineLengths[i]) + ", 0"),
        "dur": line.time,
        "repeatCount": "indefinite"
      }
    })]) : _vm._e()])
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1069),
  /* template */
  __webpack_require__(1070),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_autoResize_js__ = __webpack_require__(9);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvFullScreenContainer',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_autoResize_js__["a" /* default */]],
  data: function data() {
    return {
      ref: 'full-screen-container',
      allWidth: 0,
      scale: 0,
      datavRoot: '',
      ready: false
    };
  },

  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var initConfig = this.initConfig,
          setAppScale = this.setAppScale;


      initConfig();

      setAppScale();

      this.ready = true;
    },
    initConfig: function initConfig() {
      var dom = this.dom;
      var _screen = screen,
          width = _screen.width,
          height = _screen.height;


      this.allWidth = width;

      dom.style.width = width + 'px';
      dom.style.height = height + 'px';
    },
    setAppScale: function setAppScale() {
      var allWidth = this.allWidth,
          dom = this.dom;


      var currentWidth = document.body.clientWidth;

      dom.style.transform = 'scale(' + currentWidth / allWidth + ')';
    },
    onResize: function onResize() {
      var setAppScale = this.setAppScale;


      setAppScale();
    }
  }
});

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    attrs: {
      "id": "dv-full-screen-container"
    }
  }, [(_vm.ready) ? [_vm._t("default")] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1073),
  /* template */
  __webpack_require__(1074),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvLoading'
});

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dv-loading"
  }, [_c('svg', {
    attrs: {
      "width": "50px",
      "height": "50px"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "20",
      "fill": "transparent",
      "stroke-width": "3",
      "stroke-dasharray": "31.415, 31.415",
      "stroke": "#02bcfe",
      "stroke-linecap": "round"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "values": "0, 25 25;360, 25 25",
      "dur": "1.5s",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "stroke",
      "values": "#02bcfe;#3be6cb;#02bcfe",
      "dur": "3s",
      "repeatCount": "indefinite"
    }
  })], 1), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "10",
      "fill": "transparent",
      "stroke-width": "3",
      "stroke-dasharray": "15.7, 15.7",
      "stroke": "#3be6cb",
      "stroke-linecap": "round"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "values": "360, 25 25;0, 25 25",
      "dur": "1.5s",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "stroke",
      "values": "#3be6cb;#02bcfe;#3be6cb",
      "dur": "3s",
      "repeatCount": "indefinite"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "loading-tip"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1077),
  /* template */
  __webpack_require__(1078),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvPercentPond',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_2__util_index__["e" /* uuid */])();
    return {
      gradientId1: 'percent-pond-gradientId1-' + id,
      gradientId2: 'percent-pond-gradientId2-' + id,

      width: 0,
      height: 0,

      defaultConfig: {
        /**
         * @description Value
         * @type {Number}
         * @default value = 0
         */
        value: 0,
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default colors = ['#00BAFF', '#3DE7C9']
         * @example colors = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#3DE7C9', '#00BAFF'],
        /**
         * @description Border width
         * @type {Number}
         * @default borderWidth = 3
         */
        borderWidth: 3,
        /**
         * @description Gap between border and pond
         * @type {Number}
         * @default borderGap = 3
         */
        borderGap: 3,
        /**
         * @description Line dash
         * @type {Array<Number>}
         * @default lineDash = [5, 1]
         */
        lineDash: [5, 1],
        /**
         * @description Text color
         * @type {String}
         * @default textColor = '#fff'
         */
        textColor: '#fff',
        /**
         * @description Border radius
         * @type {Number}
         * @default borderRadius = 5
         */
        borderRadius: 5,
        /**
         * @description Local Gradient
         * @type {Boolean}
         * @default localGradient = false
         * @example localGradient = false | true
         */
        localGradient: false,
        /**
         * @description Formatter
         * @type {String}
         * @default formatter = '{value}%'
         */
        formatter: '{value}%'
      },

      mergedConfig: null
    };
  },

  computed: {
    rectWidth: function rectWidth() {
      var mergedConfig = this.mergedConfig,
          width = this.width;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth;


      return width - borderWidth;
    },
    rectHeight: function rectHeight() {
      var mergedConfig = this.mergedConfig,
          height = this.height;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth;


      return height - borderWidth;
    },
    points: function points() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;


      var halfHeight = height / 2;

      if (!mergedConfig) return '0, ' + halfHeight + ' 0, ' + halfHeight;

      var borderWidth = mergedConfig.borderWidth,
          borderGap = mergedConfig.borderGap,
          value = mergedConfig.value;


      var polylineLength = (width - (borderWidth + borderGap) * 2) / 100 * value;

      return '\n        ' + (borderWidth + borderGap) + ', ' + halfHeight + '\n        ' + (borderWidth + borderGap + polylineLength) + ', ' + (halfHeight + 0.001) + '\n      ';
    },
    polylineWidth: function polylineWidth() {
      var mergedConfig = this.mergedConfig,
          height = this.height;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth,
          borderGap = mergedConfig.borderGap;


      return height - (borderWidth + borderGap) * 2;
    },
    linearGradient: function linearGradient() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return [];

      var colors = mergedConfig.colors;


      var colorNum = colors.length;

      var colorOffsetGap = 100 / (colorNum - 1);

      return colors.map(function (c, i) {
        return [colorOffsetGap * i, c];
      });
    },
    polylineGradient: function polylineGradient() {
      var gradientId1 = this.gradientId1,
          gradientId2 = this.gradientId2,
          mergedConfig = this.mergedConfig;


      if (!mergedConfig) return gradientId2;

      if (mergedConfig.localGradient) return gradientId1;

      return gradientId2;
    },
    gradient2XPos: function gradient2XPos() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '100%';

      var value = mergedConfig.value;


      return 200 - value + '%';
    },
    details: function details() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '';

      var value = mergedConfig.value,
          formatter = mergedConfig.formatter;


      return formatter.replace('{value}', value);
    }
  },
  watch: {
    config: function config() {
      var mergeConfig = this.mergeConfig;


      mergeConfig();
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var initWH, config, mergeConfig;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                initWH = _this.initWH, config = _this.config, mergeConfig = _this.mergeConfig;
                _context.next = 3;
                return initWH();

              case 3:
                if (config) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:

                mergeConfig();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    initWH: function initWH() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var $nextTick, $refs, _$refs$percentPond, clientWidth, clientHeight;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:
                _$refs$percentPond = $refs['percent-pond'], clientWidth = _$refs$percentPond.clientWidth, clientHeight = _$refs$percentPond.clientHeight;


                _this2.width = clientWidth;
                _this2.height = clientHeight;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_3__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_4__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  }
});

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "percent-pond",
    staticClass: "dv-percent-pond"
  }, [_c('svg', [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": _vm.gradientId1,
      "x1": "0%",
      "y1": "0%",
      "x2": "100%",
      "y2": "0%"
    }
  }, _vm._l((_vm.linearGradient), function(lc) {
    return _c('stop', {
      key: lc[0],
      attrs: {
        "offset": ((lc[0]) + "%"),
        "stop-color": lc[1]
      }
    })
  }), 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": _vm.gradientId2,
      "x1": "0%",
      "y1": "0%",
      "x2": _vm.gradient2XPos,
      "y2": "0%"
    }
  }, _vm._l((_vm.linearGradient), function(lc) {
    return _c('stop', {
      key: lc[0],
      attrs: {
        "offset": ((lc[0]) + "%"),
        "stop-color": lc[1]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('rect', {
    attrs: {
      "x": _vm.mergedConfig ? _vm.mergedConfig.borderWidth / 2 : '0',
      "y": _vm.mergedConfig ? _vm.mergedConfig.borderWidth / 2 : '0',
      "rx": _vm.mergedConfig ? _vm.mergedConfig.borderRadius : '0',
      "ry": _vm.mergedConfig ? _vm.mergedConfig.borderRadius : '0',
      "fill": "transparent",
      "stroke-width": _vm.mergedConfig ? _vm.mergedConfig.borderWidth : '0',
      "stroke": ("url(#" + _vm.gradientId1 + ")"),
      "width": _vm.rectWidth > 0 ? _vm.rectWidth : 0,
      "height": _vm.rectHeight > 0 ? _vm.rectHeight : 0
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "stroke-width": _vm.polylineWidth,
      "stroke-dasharray": _vm.mergedConfig ? _vm.mergedConfig.lineDash.join(',') : '0',
      "stroke": ("url(#" + _vm.polylineGradient + ")"),
      "points": _vm.points
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "stroke": _vm.mergedConfig ? _vm.mergedConfig.textColor : '#fff',
      "fill": _vm.mergedConfig ? _vm.mergedConfig.textColor : '#fff',
      "x": _vm.width / 2,
      "y": _vm.height / 2
    }
  }, [_vm._v("\n      " + _vm._s(_vm.details) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1081),
  /* template */
  __webpack_require__(1082),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render_lib_plugin_util__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvScrollBoard',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixin_autoResize__["a" /* default */]],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'scroll-board',

      defaultConfig: {
        /**
         * @description Board header
         * @type {Array<String>}
         * @default header = []
         * @example header = ['column1', 'column2', 'column3']
         */
        header: [],
        /**
         * @description Board data
         * @type {Array<Array>}
         * @default data = []
         */
        data: [],
        /**
         * @description Row num
         * @type {Number}
         * @default rowNum = 5
         */
        rowNum: 5,
        /**
         * @description Header background color
         * @type {String}
         * @default headerBGC = '#00BAFF'
         */
        headerBGC: '#00BAFF',
        /**
         * @description Odd row background color
         * @type {String}
         * @default oddRowBGC = '#003B51'
         */
        oddRowBGC: '#003B51',
        /**
         * @description Even row background color
         * @type {String}
         * @default evenRowBGC = '#003B51'
         */
        evenRowBGC: '#0A2732',
        /**
         * @description Scroll wait time
         * @type {Number}
         * @default waitTime = 2000
         */
        waitTime: 2000,
        /**
         * @description Header height
         * @type {Number}
         * @default headerHeight = 35
         */
        headerHeight: 35,
        /**
         * @description Column width
         * @type {Array<Number>}
         * @default columnWidth = []
         */
        columnWidth: [],
        /**
         * @description Column align
         * @type {Array<String>}
         * @default align = []
         * @example align = ['left', 'center', 'right']
         */
        align: [],
        /**
         * @description Show index
         * @type {Boolean}
         * @default index = false
         */
        index: false,
        /**
         * @description index Header
         * @type {String}
         * @default indexHeader = '#'
         */
        indexHeader: '#',
        /**
         * @description Carousel type
         * @type {String}
         * @default carousel = 'single'
         * @example carousel = 'single' | 'page'
         */
        carousel: 'single',
        /**
         * @description Pause scroll when mouse hovered
         * @type {Boolean}
         * @default hoverPause = true
         * @example hoverPause = true | false
         */
        hoverPause: true
      },

      mergedConfig: null,

      header: [],

      rowsData: [],

      rows: [],

      widths: [],

      heights: [],

      avgHeight: 0,

      aligns: [],

      animationIndex: 0,

      animationHandler: '',

      updater: 0,

      needCalc: false
    };
  },

  watch: {
    config: function config() {
      var stopAnimation = this.stopAnimation,
          calcData = this.calcData;


      stopAnimation();

      this.animationIndex = 0;

      calcData();
    }
  },
  methods: {
    handleHover: function handleHover(enter, ri, ci, row, ceil) {
      var mergedConfig = this.mergedConfig,
          emitEvent = this.emitEvent,
          stopAnimation = this.stopAnimation,
          animation = this.animation;


      if (enter) emitEvent('mouseover', ri, ci, row, ceil);
      if (!mergedConfig.hoverPause) return;

      if (enter) {
        stopAnimation();
      } else {
        animation(true);
      }
    },
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var mergedConfig = this.mergedConfig,
          calcWidths = this.calcWidths,
          calcHeights = this.calcHeights;


      if (!mergedConfig) return;

      calcWidths();

      calcHeights();
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcHeaderData = this.calcHeaderData,
          calcRowsData = this.calcRowsData;


      mergeConfig();

      calcHeaderData();

      calcRowsData();

      var calcWidths = this.calcWidths,
          calcHeights = this.calcHeights,
          calcAligns = this.calcAligns;


      calcWidths();

      calcHeights();

      calcAligns();

      var animation = this.animation;


      animation(true);
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});
    },
    calcHeaderData: function calcHeaderData() {
      var _mergedConfig = this.mergedConfig,
          header = _mergedConfig.header,
          index = _mergedConfig.index,
          indexHeader = _mergedConfig.indexHeader;


      if (!header.length) {
        this.header = [];

        return;
      }

      header = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(header));

      if (index) header.unshift(indexHeader);

      this.header = header;
    },
    calcRowsData: function calcRowsData() {
      var _mergedConfig2 = this.mergedConfig,
          data = _mergedConfig2.data,
          index = _mergedConfig2.index,
          headerBGC = _mergedConfig2.headerBGC,
          rowNum = _mergedConfig2.rowNum;


      if (index) {
        data = data.map(function (row, i) {
          row = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(row));

          var indexTag = '<span class="index" style="background-color: ' + headerBGC + ';">' + (i + 1) + '</span>';

          row.unshift(indexTag);

          return row;
        });
      }

      data = data.map(function (ceils, i) {
        return { ceils: ceils, rowIndex: i };
      });

      var rowLength = data.length;

      if (rowLength > rowNum && rowLength < 2 * rowNum) {
        data = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(data), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(data));
      }

      data = data.map(function (d, i) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, d, { scroll: i });
      });

      this.rowsData = data;
      this.rows = data;
    },
    calcWidths: function calcWidths() {
      var width = this.width,
          mergedConfig = this.mergedConfig,
          rowsData = this.rowsData;
      var columnWidth = mergedConfig.columnWidth,
          header = mergedConfig.header;


      var usedWidth = columnWidth.reduce(function (all, w) {
        return all + w;
      }, 0);

      var columnNum = 0;
      if (rowsData[0]) {
        columnNum = rowsData[0].ceils.length;
      } else if (header.length) {
        columnNum = header.length;
      }

      var avgWidth = (width - usedWidth) / (columnNum - columnWidth.length);

      var widths = new Array(columnNum).fill(avgWidth);

      this.widths = Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index__["deepMerge"])(widths, columnWidth);
    },
    calcHeights: function calcHeights() {
      var onresize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var height = this.height,
          mergedConfig = this.mergedConfig,
          header = this.header;
      var headerHeight = mergedConfig.headerHeight,
          rowNum = mergedConfig.rowNum,
          data = mergedConfig.data;


      var allHeight = height;

      if (header.length) allHeight -= headerHeight;

      var avgHeight = allHeight / rowNum;

      this.avgHeight = avgHeight;

      if (!onresize) this.heights = new Array(data.length).fill(avgHeight);
    },
    calcAligns: function calcAligns() {
      var header = this.header,
          mergedConfig = this.mergedConfig;


      var columnNum = header.length;

      var aligns = new Array(columnNum).fill('left');

      var align = mergedConfig.align;


      this.aligns = Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index__["deepMerge"])(aligns, align);
    },
    animation: function animation() {
      var _this = this;

      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _heights;

        var needCalc, calcHeights, calcRowsData, avgHeight, animationIndex, mergedConfig, rowsData, animation, updater, waitTime, carousel, rowNum, rowLength, animationNum, rows, back;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                needCalc = _this.needCalc, calcHeights = _this.calcHeights, calcRowsData = _this.calcRowsData;


                if (needCalc) {
                  calcRowsData();
                  calcHeights();
                  _this.needCalc = false;
                }

                avgHeight = _this.avgHeight, animationIndex = _this.animationIndex, mergedConfig = _this.mergedConfig, rowsData = _this.rowsData, animation = _this.animation, updater = _this.updater;
                waitTime = mergedConfig.waitTime, carousel = mergedConfig.carousel, rowNum = mergedConfig.rowNum;
                rowLength = rowsData.length;

                if (!(rowNum >= rowLength)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return');

              case 7:
                if (!start) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, waitTime);
                });

              case 10:
                if (!(updater !== _this.updater)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt('return');

              case 12:
                animationNum = carousel === 'single' ? 1 : rowNum;
                rows = rowsData.slice(animationIndex);

                rows.push.apply(rows, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(rowsData.slice(0, animationIndex)));

                _this.rows = rows.slice(0, carousel === 'page' ? rowNum * 2 : rowNum + 1);
                _this.heights = new Array(rowLength).fill(avgHeight);

                _context.next = 19;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, 300);
                });

              case 19:
                if (!(updater !== _this.updater)) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt('return');

              case 21:

                (_heights = _this.heights).splice.apply(_heights, [0, animationNum].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new Array(animationNum).fill(0))));

                animationIndex += animationNum;

                back = animationIndex - rowLength;

                if (back >= 0) animationIndex = back;

                _this.animationIndex = animationIndex;
                _this.animationHandler = setTimeout(animation, waitTime - 300);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    stopAnimation: function stopAnimation() {
      var animationHandler = this.animationHandler,
          updater = this.updater;


      this.updater = (updater + 1) % 999999;

      if (!animationHandler) return;

      clearTimeout(animationHandler);
    },
    emitEvent: function emitEvent(type, ri, ci, row, ceil) {
      var ceils = row.ceils,
          rowIndex = row.rowIndex;


      this.$emit(type, {
        row: ceils,
        ceil: ceil,
        rowIndex: rowIndex,
        columnIndex: ci
      });
    },
    updateRows: function updateRows(rows, animationIndex) {
      var mergedConfig = this.mergedConfig,
          animationHandler = this.animationHandler,
          animation = this.animation;


      this.mergedConfig = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mergedConfig, {
        data: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(rows))
      });

      this.needCalc = true;

      if (typeof animationIndex === 'number') this.animationIndex = animationIndex;
      if (!animationHandler) animation(true);
    }
  },
  destroyed: function destroyed() {
    var stopAnimation = this.stopAnimation;


    stopAnimation();
  }
});

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-scroll-board"
  }, [(_vm.header.length && _vm.mergedConfig) ? _c('div', {
    staticClass: "header",
    style: (("background-color: " + (_vm.mergedConfig.headerBGC) + ";"))
  }, _vm._l((_vm.header), function(headerItem, i) {
    return _c('div', {
      key: ("" + headerItem + i),
      staticClass: "header-item",
      style: (("\n        height: " + (_vm.mergedConfig.headerHeight) + "px;\n        line-height: " + (_vm.mergedConfig.headerHeight) + "px;\n        width: " + (_vm.widths[i]) + "px;\n      ")),
      attrs: {
        "align": _vm.aligns[i]
      },
      domProps: {
        "innerHTML": _vm._s(headerItem)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.mergedConfig) ? _c('div', {
    staticClass: "rows",
    style: (("height: " + (_vm.height - (_vm.header.length ? _vm.mergedConfig.headerHeight : 0)) + "px;"))
  }, _vm._l((_vm.rows), function(row, ri) {
    return _c('div', {
      key: ("" + (row.toString()) + (row.scroll)),
      staticClass: "row-item",
      style: (("\n        height: " + (_vm.heights[ri]) + "px;\n        line-height: " + (_vm.heights[ri]) + "px;\n        background-color: " + (_vm.mergedConfig[row.rowIndex % 2 === 0 ? 'evenRowBGC' : 'oddRowBGC']) + ";\n      "))
    }, _vm._l((row.ceils), function(ceil, ci) {
      return _c('div', {
        key: ("" + ceil + ri + ci),
        staticClass: "ceil",
        style: (("width: " + (_vm.widths[ci]) + "px;")),
        attrs: {
          "align": _vm.aligns[ci]
        },
        domProps: {
          "innerHTML": _vm._s(ceil)
        },
        on: {
          "click": function($event) {
            return _vm.emitEvent('click', ri, ci, row, ceil)
          },
          "mouseenter": function($event) {
            return _vm.handleHover(true, ri, ci, row, ceil)
          },
          "mouseleave": function($event) {
            return _vm.handleHover(false)
          }
        }
      })
    }), 0)
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1085),
  /* template */
  __webpack_require__(1086),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixin_autoResize__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render_lib_plugin_util__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvScrollRankingBoard',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixin_autoResize__["a" /* default */]],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'scroll-ranking-board',

      defaultConfig: {
        /**
         * @description Board data
         * @type {Array<Object>}
         * @default data = []
         */
        data: [],
        /**
         * @description Row num
         * @type {Number}
         * @default rowNum = 5
         */
        rowNum: 5,
        /**
         * @description Scroll wait time
         * @type {Number}
         * @default waitTime = 2000
         */
        waitTime: 2000,
        /**
         * @description Carousel type
         * @type {String}
         * @default carousel = 'single'
         * @example carousel = 'single' | 'page'
         */
        carousel: 'single',
        /**
         * @description Value unit
         * @type {String}
         * @default unit = ''
         * @example unit = 'ton'
         */
        unit: '',
        /**
         * @description Auto sort by value
         * @type {Boolean}
         * @default sort = true
         */
        sort: true,
        /**
         * @description Value formatter
         * @type {Function}
         * @default valueFormatter = null
         */
        valueFormatter: null
      },

      mergedConfig: null,

      rowsData: [],

      rows: [],

      heights: [],

      animationIndex: 0,

      animationHandler: '',

      updater: 0
    };
  },

  watch: {
    config: function config() {
      var stopAnimation = this.stopAnimation,
          calcData = this.calcData;


      stopAnimation();

      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var mergedConfig = this.mergedConfig,
          calcHeights = this.calcHeights;


      if (!mergedConfig) return;

      calcHeights(true);
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcRowsData = this.calcRowsData;


      mergeConfig();

      calcRowsData();

      var calcHeights = this.calcHeights;


      calcHeights();

      var animation = this.animation;


      animation(true);
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config || {});
    },
    calcRowsData: function calcRowsData() {
      var _mergedConfig = this.mergedConfig,
          data = _mergedConfig.data,
          rowNum = _mergedConfig.rowNum,
          sort = _mergedConfig.sort;


      sort && data.sort(function (_ref, _ref2) {
        var a = _ref.value;
        var b = _ref2.value;

        if (a > b) return -1;
        if (a < b) return 1;
        if (a === b) return 0;
      });

      var value = data.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      });

      var min = Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(value)) || 0;

      // abs of min
      var minAbs = Math.abs(min);

      var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(value)) || 0;

      // abs of max
      var maxAbs = Math.abs(max);

      var total = max + minAbs;

      data = data.map(function (row, i) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, row, { ranking: i + 1, percent: (row.value + minAbs) / total * 100 });
      });

      var rowLength = data.length;

      if (rowLength > rowNum && rowLength < 2 * rowNum) {
        data = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(data), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(data));
      }

      data = data.map(function (d, i) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, d, { scroll: i });
      });

      this.rowsData = data;
      this.rows = data;
    },
    calcHeights: function calcHeights() {
      var onresize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var height = this.height,
          mergedConfig = this.mergedConfig;
      var rowNum = mergedConfig.rowNum,
          data = mergedConfig.data;


      var avgHeight = height / rowNum;

      this.avgHeight = avgHeight;

      if (!onresize) this.heights = new Array(data.length).fill(avgHeight);
    },
    animation: function animation() {
      var _this = this;

      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _heights;

        var avgHeight, animationIndex, mergedConfig, rowsData, animation, updater, waitTime, carousel, rowNum, rowLength, animationNum, rows, back;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                avgHeight = _this.avgHeight, animationIndex = _this.animationIndex, mergedConfig = _this.mergedConfig, rowsData = _this.rowsData, animation = _this.animation, updater = _this.updater;
                waitTime = mergedConfig.waitTime, carousel = mergedConfig.carousel, rowNum = mergedConfig.rowNum;
                rowLength = rowsData.length;

                if (!(rowNum >= rowLength)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                if (!start) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, waitTime);
                });

              case 8:
                if (!(updater !== _this.updater)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                animationNum = carousel === 'single' ? 1 : rowNum;
                rows = rowsData.slice(animationIndex);

                rows.push.apply(rows, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(rowsData.slice(0, animationIndex)));

                _this.rows = rows.slice(0, rowNum + 1);
                _this.heights = new Array(rowLength).fill(avgHeight);

                _context.next = 17;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, 300);
                });

              case 17:
                if (!(updater !== _this.updater)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt('return');

              case 19:

                (_heights = _this.heights).splice.apply(_heights, [0, animationNum].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new Array(animationNum).fill(0))));

                animationIndex += animationNum;

                back = animationIndex - rowLength;

                if (back >= 0) animationIndex = back;

                _this.animationIndex = animationIndex;
                _this.animationHandler = setTimeout(animation, waitTime - 300);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    stopAnimation: function stopAnimation() {
      var animationHandler = this.animationHandler,
          updater = this.updater;


      this.updater = (updater + 1) % 999999;

      if (!animationHandler) return;

      clearTimeout(animationHandler);
    }
  },
  destroyed: function destroyed() {
    var stopAnimation = this.stopAnimation;


    stopAnimation();
  }
});

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "dv-scroll-ranking-board"
  }, _vm._l((_vm.rows), function(item, i) {
    return _c('div', {
      key: item.toString() + item.scroll,
      staticClass: "row-item",
      style: (("height: " + (_vm.heights[i]) + "px;"))
    }, [_c('div', {
      staticClass: "ranking-info"
    }, [_c('div', {
      staticClass: "rank"
    }, [_vm._v("No." + _vm._s(item.ranking))]), _vm._v(" "), _c('div', {
      staticClass: "info-name",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ranking-value"
    }, [_vm._v(_vm._s(_vm.mergedConfig.valueFormatter ? _vm.mergedConfig.valueFormatter(item) : item.value + _vm.mergedConfig.unit))])]), _vm._v(" "), _c('div', {
      staticClass: "ranking-column"
    }, [_c('div', {
      staticClass: "inside-column",
      style: (("width: " + (item.percent) + "%;"))
    }, [_c('div', {
      staticClass: "shine"
    })])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1089),
  /* template */
  __webpack_require__(1090),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_index__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DvWaterLevelPond',
  props: {
    config: Object,
    default: function _default() {
      return {};
    }
  },
  data: function data() {
    var id = Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["e" /* uuid */])();
    return {
      gradientId: 'water-level-pond-' + id,

      defaultConfig: {
        /**
         * @description Data
         * @type {Array<Number>}
         * @default data = []
         * @example data = [60, 40]
         */
        data: [],
        /**
         * @description Shape of wanter level pond
         * @type {String}
         * @default shape = 'rect'
         * @example shape = 'rect' | 'roundRect' | 'round'
         */
        shape: 'rect',
        /**
         * @description Water wave number
         * @type {Number}
         * @default waveNum = 3
         */
        waveNum: 3,
        /**
         * @description Water wave height (px)
         * @type {Number}
         * @default waveHeight = 40
         */
        waveHeight: 40,
        /**
         * @description Wave opacity
         * @type {Number}
         * @default waveOpacity = 0.4
         */
        waveOpacity: 0.4,
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default colors = ['#00BAFF', '#3DE7C9']
         * @example colors = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#3DE7C9', '#00BAFF'],
        /**
         * @description Formatter
         * @type {String}
         * @default formatter = '{value}%'
         */
        formatter: '{value}%'
      },

      mergedConfig: {},

      renderer: null,

      svgBorderGradient: [],

      details: '',

      waves: [],

      animation: false
    };
  },

  computed: {
    radius: function radius() {
      var shape = this.mergedConfig.shape;


      if (shape === 'round') return '50%';

      if (shape === 'rect') return '0';

      if (shape === 'roundRect') return '10px';

      return '0';
    },
    shape: function shape() {
      var shape = this.mergedConfig.shape;


      if (!shape) return 'rect';

      return shape;
    }
  },
  watch: {
    config: function config() {
      var calcData = this.calcData,
          renderer = this.renderer;


      renderer.delAllGraph();

      this.waves = [];

      setTimeout(calcData, 0);
    }
  },
  methods: {
    init: function init() {
      var initRender = this.initRender,
          config = this.config,
          calcData = this.calcData;


      initRender();

      if (!config) return;

      calcData();
    },
    initRender: function initRender() {
      var $refs = this.$refs;


      this.renderer = new __WEBPACK_IMPORTED_MODULE_7__jiaminghi_c_render___default.a($refs['water-pond-level']);
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcSvgBorderGradient = this.calcSvgBorderGradient,
          calcDetails = this.calcDetails;


      mergeConfig();

      calcSvgBorderGradient();

      calcDetails();

      var addWave = this.addWave,
          animationWave = this.animationWave;


      addWave();

      animationWave();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_5__jiaminghi_charts_lib_util_index__["deepMerge"])(Object(__WEBPACK_IMPORTED_MODULE_6__jiaminghi_c_render_lib_plugin_util__["deepClone"])(defaultConfig, true), config);
    },
    calcSvgBorderGradient: function calcSvgBorderGradient() {
      var colors = this.mergedConfig.colors;


      var colorNum = colors.length;

      var colorOffsetGap = 100 / (colorNum - 1);

      this.svgBorderGradient = colors.map(function (c, i) {
        return [colorOffsetGap * i, c];
      });
    },
    calcDetails: function calcDetails() {
      var _mergedConfig = this.mergedConfig,
          data = _mergedConfig.data,
          formatter = _mergedConfig.formatter;


      if (!data.length) {
        this.details = '';

        return;
      }

      var maxValue = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(data));

      this.details = formatter.replace('{value}', maxValue);
    },
    addWave: function addWave() {
      var renderer = this.renderer,
          getWaveShapes = this.getWaveShapes,
          getWaveStyle = this.getWaveStyle,
          drawed = this.drawed;


      var shapes = getWaveShapes();
      var style = getWaveStyle();

      this.waves = shapes.map(function (shape) {
        return renderer.add({
          name: 'smoothline',
          animationFrame: 300,
          shape: shape,
          style: style,
          drawed: drawed
        });
      });
    },
    getWaveShapes: function getWaveShapes() {
      var mergedConfig = this.mergedConfig,
          renderer = this.renderer,
          mergeOffset = this.mergeOffset;
      var waveNum = mergedConfig.waveNum,
          waveHeight = mergedConfig.waveHeight,
          data = mergedConfig.data;

      var _renderer$area = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(renderer.area, 2),
          w = _renderer$area[0],
          h = _renderer$area[1];

      var pointsNum = waveNum * 4 + 4;

      var pointXGap = w / waveNum / 2;

      return data.map(function (v) {
        var points = new Array(pointsNum).fill(0).map(function (foo, j) {
          var x = w - pointXGap * j;

          var startY = (1 - v / 100) * h;

          var y = j % 2 === 0 ? startY : startY - waveHeight;

          return [x, y];
        });

        points = points.map(function (p) {
          return mergeOffset(p, [pointXGap * 2, 0]);
        });

        return { points: points };
      });
    },
    mergeOffset: function mergeOffset(_ref, _ref2) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          x = _ref4[0],
          y = _ref4[1];

      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
          ox = _ref3[0],
          oy = _ref3[1];

      return [x + ox, y + oy];
    },
    getWaveStyle: function getWaveStyle() {
      var renderer = this.renderer,
          mergedConfig = this.mergedConfig;


      var h = renderer.area[1];

      return {
        gradientColor: mergedConfig.colors,
        gradientType: 'linear',
        gradientParams: [0, 0, 0, h],
        gradientWith: 'fill',
        opacity: mergedConfig.waveOpacity,
        translate: [0, 0]
      };
    },
    drawed: function drawed(_ref5, _ref6) {
      var points = _ref5.shape.points;
      var ctx = _ref6.ctx,
          area = _ref6.area;

      var firstPoint = points[0];
      var lastPoint = points.slice(-1)[0];

      var h = area[1];

      ctx.lineTo(lastPoint[0], h);
      ctx.lineTo(firstPoint[0], h);

      ctx.closePath();

      ctx.fill();
    },
    animationWave: function animationWave() {
      var _this = this;

      var repeat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var waves, renderer, animation, w;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                waves = _this.waves, renderer = _this.renderer, animation = _this.animation;

                if (!animation) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                _this.animation = true;

                w = renderer.area[0];


                waves.forEach(function (graph) {
                  graph.attr('style', { translate: [0, 0] });

                  graph.animation('style', {
                    translate: [w, 0]
                  }, true);
                });

                _context.next = 8;
                return renderer.launchAnimation();

              case 8:

                _this.animation = false;

                if (renderer.graphs.length) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return');

              case 11:

                _this.animationWave(repeat + 1);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  },
  beforeDestroy: function beforeDestroy() {
    var renderer = this.renderer;


    renderer.delAllGraph();

    this.waves = [];
  }
});

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dv-water-pond-level"
  }, [(_vm.renderer) ? _c('svg', [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": _vm.gradientId,
      "x1": "0%",
      "y1": "0%",
      "x2": "0%",
      "y2": "100%"
    }
  }, _vm._l((_vm.svgBorderGradient), function(lc) {
    return _c('stop', {
      key: lc[0],
      attrs: {
        "offset": lc[0],
        "stop-color": lc[1]
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.renderer) ? _c('text', {
    attrs: {
      "stroke": ("url(#" + _vm.gradientId + ")"),
      "fill": ("url(#" + _vm.gradientId + ")"),
      "x": _vm.renderer.area[0] / 2 + 8,
      "y": _vm.renderer.area[1] / 2 + 8
    }
  }, [_vm._v("\n      " + _vm._s(_vm.details) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.shape || _vm.shape === 'round') ? _c('ellipse', {
    attrs: {
      "cx": _vm.renderer.area[0] / 2 + 8,
      "cy": _vm.renderer.area[1] / 2 + 8,
      "rx": _vm.renderer.area[0] / 2 + 5,
      "ry": _vm.renderer.area[1] / 2 + 5,
      "stroke": ("url(#" + _vm.gradientId + ")")
    }
  }) : _c('rect', {
    attrs: {
      "x": "2",
      "y": "2",
      "rx": _vm.shape === 'roundRect' ? 10 : 0,
      "ry": _vm.shape === 'roundRect' ? 10 : 0,
      "width": _vm.renderer.area[0] + 12,
      "height": _vm.renderer.area[1] + 12,
      "stroke": ("url(#" + _vm.gradientId + ")")
    }
  })]) : _vm._e(), _vm._v(" "), _c('canvas', {
    ref: "water-pond-level",
    style: (("border-radius: " + _vm.radius + ";"))
  })])
},staticRenderFns: []}

/***/ })
]),[419]);


// WEBPACK FOOTER //
// static/js/app.da912f27c9fec87592d4.js